(function (root) {
  'use strict';


  var RELEASE_COPY = {"banner_heading": "Make room for the people who matter.", "banner_body": "Save their important dates. We’ll help you remember.", "add": "Add a reminder", "add_short": "+ Add", "start": "Start with an occasion", "BIRTHDAY": "Birthday", "ANNIVERSARY": "Anniversary", "CHRISTMAS": "Christmas", "VALENTINES_DAY": "Valentine’s Day", "MOTHERS_DAY": "Mother’s Day", "FATHERS_DAY": "Father’s Day", "OTHER": "Something else", "CHRISTMAS_rule": "25 December · Every year", "VALENTINES_DAY_rule": "14 February · Every year", "MOTHERS_DAY_rule": "Second Sunday in May · Every year", "FATHERS_DAY_rule": "First Sunday in September · Every year", "unknown_help": "Tick this to save __NAME__ without a date. We’ll give you a link to share so they can confirm their birthday, or you can add it later. Reminders start once a date is saved.", "save_link": "Save and get a birthday link", "save": "Save reminder", "saved_unknown": "__NAME__ is saved. Invite them to join Reminders.", "share": "Share birthday link", "later": "I’ll add the date later", "copied": "Birthday link copied.", "share_error": "Couldn’t copy the link. Select and copy it below.", "share_message": "I’m keeping birthdays somewhere I’ll remember them. Could you add yours here?", "more": "More occasions for __NAME__", "added": "Already added", "add_occasion": "Add __TYPE__ for __NAME__", "dates_to_find": "Dates to find", "up_next": "Up next", "shop": "Shop", "edit": "Edit reminder", "ask": "Ask for birthday", "add_date": "Add date", "show_all": "Show all (__COUNT__)", "empty_month": "Someone to celebrate in __MONTH__?", "current_month": "Current month", "jump": "Jump to __MONTH__", "enable_sms": "Turn on SMS reminders", "channel_settings": "Reminder settings", "days": "In __DAYS__ days", "today": "Today", "paid": "Gift purchased", "messaged": "Message sent", "lapsed": "Date passed", "duplicate": "This reminder already exists. Open it, or save a different person with the same name.", "open_existing": "Open existing reminder", "different_person": "Save as a different person", "refresh": "Refresh dates", "neutral_name": "them", "shop_for": "Shop for __NAME__ — __TYPE__", "unknown_help_other": "Tick this to save __NAME__ without a date and add it later. Reminders start once a date is saved."};
  RELEASE_COPY.tomorrow = "Tomorrow";
  RELEASE_COPY.date_needed = "Date needed";
  RELEASE_COPY.calendar_empty = "No dates saved for __MONTH__ yet.";
  RELEASE_COPY.calendar_month_count = "__MONTH__: __COUNT__ reminders";
  RELEASE_COPY.calendar_month_one = "__MONTH__: 1 reminder";
  RELEASE_COPY.calendar_year_status = "Year overview. All 12 months.";
  RELEASE_COPY.calendar_all_status = "All reminders, nearest date first.";
  RELEASE_COPY.calendar_open_month = "Open __MONTH__ in By month";
  /* The person view (?reminder_view=friend): every reminder saved for one
     person. __NAME__ in friend_heading and friend_link is already
     possessive ("Alvaro’s"); in friend_add it is the plain name. */
  RELEASE_COPY.friend_heading = "__NAME__ reminders";
  RELEASE_COPY.friend_link = "All of __NAME__ reminders";
  RELEASE_COPY.friend_add = "Add another occasion for __NAME__";
  RELEASE_COPY.friend_not_found = "We couldn’t find that person.";
  /* List wayfinding (business-os #145). open_notes is the name link's
     accessible name. notes_mark is the visible chip, shown only when the
     list payload says hasNotes === true. */
  RELEASE_COPY.open_notes = "Open notes and occasions for __NAME__";
  RELEASE_COPY.notes_mark = "Notes";
  /* OTHER is a customer-named occasion (a christening, a name day): the
     type carries no date rule, so the customer gives the month and day and a
     short label that stands in for the type name everywhere it is shown. */
  var OCCASION_TYPES = ['BIRTHDAY', 'ANNIVERSARY', 'CHRISTMAS', 'VALENTINES_DAY', 'MOTHERS_DAY', 'FATHERS_DAY', 'OTHER'];
  var OCCASION_ICONS = { BIRTHDAY: '🎂', ANNIVERSARY: '♡', CHRISTMAS: '✧', VALENTINES_DAY: '♥', MOTHERS_DAY: '❀', FATHERS_DAY: '☆', OTHER: '✦' };
  /* Chip icons are one drawn set (16px, 1.5px stroke, currentColor) so they
     match in size and weight and invert with the pressed chip. Text glyphs
     and emoji render at different sizes per font, which is why they are not
     used here. */
  var CHIP_ICON_OPEN = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var CHIP_ICONS = {
    BIRTHDAY: '<path d="M3 13.5h10V8.75A1.25 1.25 0 0 0 11.75 7.5h-7.5A1.25 1.25 0 0 0 3 8.75z"/><path d="M1.75 13.5h12.5"/><path d="M8 7.5V4.75"/><circle cx="8" cy="2.9" r="1"/>',
    ANNIVERSARY: '<circle cx="5.75" cy="9" r="3.5"/><circle cx="10.25" cy="9" r="3.5"/>',
    CHRISTMAS: '<path d="M8 2l3 4H9.5l2.5 3.5h-2l2.5 3.5h-9l2.5-3.5h-2L6.5 6H5z"/><path d="M8 13v1.5"/>',
    VALENTINES_DAY: '<path d="M8 13.5l-.9-.8C3.9 9.8 1.75 7.85 1.75 5.45A2.95 2.95 0 0 1 4.7 2.5c1.3 0 2.55.6 3.3 1.55C8.75 3.1 10 2.5 11.3 2.5a2.95 2.95 0 0 1 2.95 2.95c0 2.4-2.15 4.35-5.35 7.25z"/>',
    MOTHERS_DAY: '<circle cx="8" cy="8" r="1.5"/><circle cx="8" cy="3.9" r="1.9"/><circle cx="8" cy="3.9" r="1.9" transform="rotate(72 8 8)"/><circle cx="8" cy="3.9" r="1.9" transform="rotate(144 8 8)"/><circle cx="8" cy="3.9" r="1.9" transform="rotate(216 8 8)"/><circle cx="8" cy="3.9" r="1.9" transform="rotate(288 8 8)"/>',
    FATHERS_DAY: '<path d="M8 2l1.41 4.06 4.3.09-3.43 2.59 1.25 5.11L8 10.4l-3.53 3.45 1.25-5.11-3.43-2.59 4.3-.09z"/>',
    OTHER: '<path d="M8 2.25c.45 3.1 2.2 4.85 5.3 5.3-3.1.45-4.85 2.2-5.3 5.3-.45-3.1-2.2-4.85-5.3-5.3 3.1-.45 4.85-2.2 5.3-5.3z"/>'
  };
  /* The name an occasion is shown under: its type, or the customer's own
     label for an OTHER occasion. */
  function occasionName(occasion) {
    if (!occasion) return words('BIRTHDAY');
    if (occasion.type === 'OTHER') return occasion.label || words('OTHER');
    return words(occasion.type || 'BIRTHDAY');
  }
  /* "Jake" → "Jake’s", "Jess" → "Jess’", and a name already written as a
     possessive ("Jake's") is left alone. Shared by the occasion shop's
     headline and the person view's heading. */
  function possessive(name) {
    var value = String(name || '');
    return /['’]s$/i.test(value) ? value : /s$/i.test(value) ? value + '’' : value + '’s';
  }
  var MAX_OCCASION_LABEL = 60;
  /* One rule for both forms: a customer-named occasion needs its label, and
     the API caps it at 60 characters. `messages` is the sheet's or page's
     dataset. Returns the message to show, or null. */
  function occasionLabelError(type, label, messages) {
    if (type === 'OTHER' && !label) return messages.labelRequired;
    if (label && label.length > MAX_OCCASION_LABEL) return messages.labelLong;
    return null;
  }
  function occasionChip(type, label) {
    var button = element('button', 'fb-reminders-occasion-chip');
    button.type = 'button';
    var icon = element('span', 'fb-reminders-occasion-chip__icon');
    icon.innerHTML = CHIP_ICON_OPEN + (CHIP_ICONS[type] || '') + '</svg>';
    button.appendChild(icon);
    button.appendChild(element('span', 'fb-reminders-occasion-chip__label', label));
    return button;
  }
  function words(key, values) {
    var node = typeof document !== 'undefined' && document.getElementById ? document.getElementById('fb-reminders-copy') : null;
    var copy = RELEASE_COPY;
    if (node) { try { copy = JSON.parse(node.textContent); } catch (_) {} }
    var value = copy[key] || RELEASE_COPY[key] || key;
    Object.keys(values || {}).forEach(function (name) { value = value.split('__' + name + '__').join(String(values[name])); });
    return value;
  }
  function automaticDate(type) {
    if (type === 'CHRISTMAS') return { month: 12, day: 25 };
    if (type === 'VALENTINES_DAY') return { month: 2, day: 14 };
    var month = type === 'MOTHERS_DAY' ? 5 : type === 'FATHERS_DAY' ? 9 : null;
    if (!month) return null;
    var year = Number(new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric' }).format(new Date()));
    return { month: month, day: 1 + (7 - new Date(Date.UTC(year, month - 1, 1)).getUTCDay()) % 7 + (type === 'MOTHERS_DAY' ? 7 : 0) };
  }
  function disableControl(control, disabled) {
    if (control.hasAttribute('data-fb-reminders-was-disabled')) control.setAttribute('data-fb-reminders-was-disabled', disabled ? 'true' : 'false');
    else control.disabled = disabled;
  }
  function pendingForm(form, pending) {
    if (!form.querySelectorAll) return;
    form.querySelectorAll('button, input, select, textarea').forEach(function (control) {
      if (control.hasAttribute('data-fb-reminders-close')) return;
      if (pending) {
        var disabled = control.hasAttribute('data-fb-reminders-was-disabled') ? control.getAttribute('data-fb-reminders-was-disabled') === 'true' : control.disabled;
        control.setAttribute('data-reminders-busy-disabled', disabled ? 'true' : 'false');
        disableControl(control, true);
      } else if (control.hasAttribute('data-reminders-busy-disabled')) {
        disableControl(control, control.getAttribute('data-reminders-busy-disabled') === 'true');
        control.removeAttribute('data-reminders-busy-disabled');
      }
    });
    form.setAttribute('aria-busy', pending ? 'true' : 'false');
  }
  function syncDateForm(form) {
    var type = form.elements.type ? form.elements.type.value : 'BIRTHDAY';
    var fixed = automaticDate(type);
    var oldType = form._dateType;
    form._manualDates = form._manualDates || {};
    if (oldType && !automaticDate(oldType) && !form._dateUnknown) {
      form._manualDates[oldType] = { month: form.elements.month.value, day: form.elements.day.value };
    }
    if (fixed) {
      form.elements.unknownDate.checked = false;
      form.elements.month.value = String(fixed.month);
      form.elements.day.value = String(fixed.day);
    } else if ((oldType && oldType !== type) || (form._dateUnknown && !form.elements.unknownDate.checked)) {
      var previous = form._manualDates[type] || {};
      form.elements.month.value = previous.month || '';
      form.elements.day.value = previous.day || '';
    }
    var unknown = form.elements.unknownDate.checked;
    var fields = form.querySelector('[data-reminders-date-fields]');
    if (fields) fields.hidden = !!fixed || unknown;
    ['day', 'month'].forEach(function (name) { disableControl(form.elements[name], !!fixed || unknown); form.elements[name].required = !fixed && !unknown; });
    var rule = form.querySelector('[data-reminders-date-rule]');
    if (rule) { rule.hidden = !fixed; rule.textContent = fixed ? words(type + '_rule') : ''; }
    var unknownControl = form.querySelector('[data-reminders-unknown-control]');
    if (unknownControl) unknownControl.hidden = !!fixed;
    var labelField = form.querySelector('[data-reminders-label-field]');
    if (labelField) {
      var other = type === 'OTHER';
      labelField.hidden = !other;
      if (form.elements.label) { form.elements.label.required = other; disableControl(form.elements.label, !other); }
    }
    var help = form.querySelector('[data-reminders-unknown-help]');
    if (help) { help.hidden = !!fixed; help.textContent = words(type === 'BIRTHDAY' ? 'unknown_help' : 'unknown_help_other', { NAME: form.elements.name.value.trim() || words('neutral_name') }); }
    if (form.hasAttribute && form.hasAttribute('data-reminders-capture')) {
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.textContent = words(unknown && type === 'BIRTHDAY' ? 'save_link' : 'save');
    }
    if (form.querySelectorAll) form.querySelectorAll('[data-shortcut-type]').forEach(function (button) { button.setAttribute('aria-pressed', button.dataset.shortcutType === type ? 'true' : 'false'); });
    form._dateType = type;
    form._dateUnknown = unknown;
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function relevantOccasions(relationship) {
    var relation = String(relationship || '').trim().toLowerCase();
    if (!relation) return [];
    var types = ['CHRISTMAS'];
    if (['partner', 'wife', 'husband', 'spouse', 'girlfriend', 'boyfriend', 'fiancée', 'fiancé', 'fiancee', 'fiance'].indexOf(relation) !== -1) types.push('VALENTINES_DAY');
    if (['mum', 'mother', 'mom'].indexOf(relation) !== -1) types.push('MOTHERS_DAY');
    if (['dad', 'father'].indexOf(relation) !== -1) types.push('FATHERS_DAY');
    return types;
  }
  function moreOccasions(container, occasion, all, relationship) {
    if (!container) return;
    container.textContent = '';
    var types = relevantOccasions(relationship).filter(function (type) {
      return !(all || []).some(function (other) { return other.friendId === occasion.friendId && other.type === type; });
    });
    container.hidden = !types.length;
    if (!types.length) return;
    container.appendChild(element('h3', '', words('more', { NAME: occasion.name })));
    var options = element('div', 'fb-reminders-shortcuts');
    types.forEach(function (type) {
      var button = occasionChip(type, words('add_occasion', { TYPE: words(type), NAME: occasion.name }));
      button.dataset.fbRemindersOpen = '';
      button.dataset.remindersOpenState = 'capture';
      button.dataset.remindersType = type;
      button.dataset.remindersFriendId = occasion.friendId;
      button.dataset.remindersName = occasion.name;
      options.appendChild(button);
    });
    container.appendChild(options);
  }
  /* `track`, when passed, is { surface, touchpoint, occasionId }: invite_shared
     fires only once the share sheet or clipboard write succeeds, so a
     cancelled share is never counted. */
  async function shareBirthday(url, status, fallback, track) {
    if (!isSafeHref(url)) return;
    if (status) status.textContent = '';
    try {
      var method;
      if (root.navigator && typeof root.navigator.share === 'function') {
        await root.navigator.share({ text: words('share_message'), url: url });
        method = 'native';
      } else {
        await root.navigator.clipboard.writeText(url);
        if (status) status.textContent = words('copied');
        method = 'copy';
      }
      if (track) trackReminderEvent('invite_shared', track.surface, track.touchpoint, { occasion_id: track.occasionId, method: method });
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (status) status.textContent = words('share_error');
      if (fallback) { fallback.hidden = false; fallback.value = url; fallback.focus(); fallback.select(); }
    }
  }

  var DRAFT_KEY = 'fb_rem_draft';
  var BATCH_KEY = 'fb_rem_draft_batch';
  var DRAFT_TTL = 24 * 60 * 60 * 1000;

  function safeStorage() {
    try { return root.sessionStorage || null; } catch (_) { return null; }
  }

  function readDraft(now) {
    var store = safeStorage();
    if (!store) return null;
    try {
      var draft = JSON.parse(store.getItem(DRAFT_KEY) || 'null');
      if (!draft || !draft.createdAt || draft.createdAt + DRAFT_TTL <= (now || Date.now)()) {
        try { store.removeItem(DRAFT_KEY); } catch (_) {}
        return null;
      }
      return draft;
    } catch (_) {
      try { store.removeItem(DRAFT_KEY); } catch (_) {}
      return null;
    }
  }

  function writeDraft(values, now) {
    var store = safeStorage();
    var existing = readDraft(now);
    var draft = {
      name: values.name,
      type: values.type == null ? 'BIRTHDAY' : values.type,
      // Keep automatic selection separate from an occasion the shopper chose.
      // Restoring a draft must still let an erased name return to an empty form.
      defaultType: values.type === 'BIRTHDAY' && values.defaultType === 'BIRTHDAY' ? 'BIRTHDAY' : undefined,
      label: values.type === 'OTHER' && values.label ? values.label : null,
      friendId: values.friendId || undefined,
      confirmNew: values.confirmNew === true,
      month: values.month || null,
      day: values.day || null,
      unknownDate: values._unknownDate != null ? values._unknownDate === true : values.unknownDate != null ? values.unknownDate === true : values.month == null && values.day == null,
      year: null,
      source: values.source || 'theme_sheet',
      createdAt: Math.min(existing && existing.createdAt || Infinity, Number.isFinite(values.createdAt) ? values.createdAt : Infinity, (now || Date.now)())
    };
    if (store) { try { store.setItem(DRAFT_KEY, JSON.stringify(draft)); } catch (_) {} }
    return draft;
  }

  function clearDraft() {
    var store = safeStorage();
    if (store) {
      try { store.removeItem(DRAFT_KEY); } catch (_) {}
    }
  }

  function validDate(month, day) {
    month = Number(month);
    day = Number(day);
    if (!Number.isInteger(month) || month < 1 || month > 12) return false;
    if (!Number.isInteger(day) || day < 1) return false;
    return day <= new Date(Date.UTC(2000, month, 0)).getUTCDate();
  }

  function apiDraft(draft) {
    return {
      people: [{
        name: draft.name,
        type: draft.type || 'BIRTHDAY',
        label: draft.label || undefined,
        friendId: draft.friendId,
        confirmNew: draft.confirmNew === true,
        month: draft.month,
        day: draft.day,
        year: draft.year
      }]
    };
  }

  // A guest's completed entries are still drafts. Session storage deliberately
  // expires them; neither this queue nor its count is proof of a reward.
  function storeBatch(batch) {
    var store = safeStorage();
    if (store) { try { if (batch) store.setItem(BATCH_KEY, JSON.stringify(batch)); else store.removeItem(BATCH_KEY); } catch (_) {} }
  }
  function readBatch() {
    try {
      var store = safeStorage(), batch = store && JSON.parse(store.getItem(BATCH_KEY) || 'null');
      if (batch && Number.isFinite(batch.createdAt) && batch.createdAt + DRAFT_TTL > Date.now() && Array.isArray(batch.people) && batch.people.length && batch.people.length <= 100 && batch.people.every(function (p) { return p && typeof p.name === 'string' && OCCASION_TYPES.indexOf(p.type) >= 0; })) return batch;
    } catch (_) {}
    storeBatch(null); return null;
  }
  function sameDraftPerson(a, b) {
    return a.type === b.type && (a.friendId ? a.friendId === b.friendId : String(a.name || '').trim().toLowerCase() === String(b.name || '').trim().toLowerCase());
  }
  function qualifyingDraftCount(people) {
    return people.filter(function (p) { return !!automaticDate(p.type) || (['BIRTHDAY', 'ANNIVERSARY', 'OTHER'].indexOf(p.type) >= 0 && !p.unknownDate && validDate(p.month, p.day)); }).length;
  }

  /* ============================================================
   * T2 — the page (list, person, manage, settings, invite, link).
   * Pure helpers first (unit tested directly), then PageController,
   * which mirrors Controller's shape but drives sections/
   * fb-reminders-app.liquid instead of the sheet.
   * ============================================================ */

  function parseParams(search) {
    var params = {};
    var raw = String(search || '');
    if (raw.charAt(0) === '?') raw = raw.slice(1);
    if (!raw) return params;
    raw.split('&').forEach(function (pair) {
      if (!pair) return;
      var idx = pair.indexOf('=');
      var key = decodeURIComponent(idx === -1 ? pair : pair.slice(0, idx));
      var value = idx === -1 ? '' : decodeURIComponent(pair.slice(idx + 1).replace(/\+/g, ' '));
      if (!Object.prototype.hasOwnProperty.call(params, key)) params[key] = value;
    });
    return params;
  }

  /* ?r= always wins. Shopify reserves ?view= for alternate templates, so
     new links use reminder_view. Read view as well for previously sent links
     served by the matching compatibility templates. */
  function resolveView(search) {
    var params = parseParams(search);
    if (params.r) return 'link';
    var known = ['list', 'person', 'friend', 'manage', 'settings', 'invite', 'link', 'group', 'group-invite', 'join', 'preseed'];
    var requested = params.reminder_view || params.view;
    return known.indexOf(requested) !== -1 ? requested : 'list';
  }

  function appendParam(url, key, value) {
    var base = String(url || '');
    var hash = base.indexOf('#');
    var fragment = hash === -1 ? '' : base.slice(hash);
    var path = hash === -1 ? base : base.slice(0, hash);
    var sep = path.indexOf('?') === -1 ? '?' : '&';
    return path + sep + encodeURIComponent(key) + '=' + encodeURIComponent(value) + fragment;
  }

  function withReturn(targetUrl, returnUrl) {
    return appendParam(targetUrl, 'return', returnUrl);
  }

  /* Review fix #2: true unless value carries an explicit non-http(s) scheme
     (javascript:, data:, vbscript:, …), once the tabs/newlines a browser's
     own URL parser strips before ever reading the scheme are stripped here
     too. A value with no scheme at all is a relative reference, which
     always resolves against the current page's own http/https origin — so
     "resolve relative to location.origin first" holds without a URL
     constructor, which the vm-sandboxed unit tests never provide. */
  function isSafeHref(value) {
    if (!value) return false;
    var stripped = String(value).replace(/[\t\n\r]+/g, '').trim();
    var scheme = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(stripped);
    if (!scheme) return true;
    var protocol = scheme[1].toLowerCase();
    return protocol === 'http' || protocol === 'https';
  }

  function pageUrl(basePath, view, id) {
    var url = basePath + '?reminder_view=' + encodeURIComponent(view);
    if (id) url += '&id=' + encodeURIComponent(id);
    return url;
  }

  /* Undated people are never grouped by days-until and never given a
     countdown (SURFACES.md 2.4, T2.1) — the only date text they ever
     get is "Date needed". */
  function classifyOccasion(occasion) {
    var dated = !!(occasion && occasion.date && occasion.date.known);
    if (!dated) return { dated: false, group: 'later', status: 'date_needed', date: null };
    var next = occasion.next || {};
    var days = typeof next.daysUntil === 'number' ? next.daysUntil : null;
    var group = (days !== null && days >= 0 && days <= 30) ? 'coming_up' : 'later';
    return { dated: true, group: group, status: statusWord(occasion), date: next.date || null };
  }

  function statusWord(occasion) {
    if (!occasion || !occasion.date || !occasion.date.known) return 'date_needed';
    var next = occasion.next || {};
    if (occasion.status === 'PAUSED') return 'paused';
    if (next.outcome === 'PAID') return 'paid';
    if (next.outcome === 'MESSAGED') return 'messaged';
    if (next.outcome === 'LAPSED') return 'lapsed';
    if (next.outcome === 'SKIPPED') return 'skipped';
    if (next.outcome === 'HANDLED_ELSEWHERE') return 'sorted';
    if (next.snoozedUntil) return 'paused';
    return 'upcoming';
  }

  function compareStrings(a, b) { return a < b ? -1 : a > b ? 1 : 0; }

  /* Both groups are pre-sorted so the caller can render them straight
     through; GET /occasions is already sorted by next date, but this
     does not assume that stays true. */
  function groupOccasions(occasions) {
    var comingUp = [];
    var later = [];
    (occasions || []).forEach(function (occasion) {
      var info = classifyOccasion(occasion);
      (info.group === 'coming_up' ? comingUp : later).push(occasion);
    });
    function dateKey(occasion) { return (occasion.next && occasion.next.date) || ''; }
    comingUp.sort(function (a, b) { return compareStrings(dateKey(a), dateKey(b)); });
    later.sort(function (a, b) {
      var aDated = !!(a.date && a.date.known);
      var bDated = !!(b.date && b.date.known);
      if (aDated !== bDated) return aDated ? -1 : 1;
      if (aDated) return compareStrings(dateKey(a), dateKey(b));
      return compareStrings(String(a.name || ''), String(b.name || ''));
    });
    return { comingUp: comingUp, later: later };
  }

  function channelsSummary(channels) {
    var sms = !!(channels && channels.sms && channels.sms.enabled);
    var email = !!(channels && channels.email && channels.email.enabled);
    if (!sms && !email) return 'off';
    if (sms && email) return 'both';
    return sms ? 'sms' : 'email';
  }

  /* "snooze is hidden when the API says none remains" (T2.3): reminder.kind
     is "none" for exactly this case in the data GET /occasions already
     returned (API-CONTRACT.md 5.2), so this needs no extra round trip. A
     refusal from the outcome endpoint itself is still honoured — see
     PageController.prototype.submitOutcome — this is the proactive half. */
  function canSnooze(occasion) {
    if (!occasion || !occasion.date || !occasion.date.known) return false;
    var next = occasion.next || {};
    if (next.outcome === 'SKIPPED' || next.outcome === 'HANDLED_ELSEWHERE') return false;
    if (occasion.reminder && occasion.reminder.kind === 'none') return false;
    return true;
  }

  function canRestore(occasion) {
    var next = (occasion && occasion.next) || {};
    return next.outcome === 'SKIPPED' || next.outcome === 'HANDLED_ELSEWHERE';
  }

  function PageController(page) {
    this.page = page;
    this.api = root.FBRemindersAPI.create(page.dataset.apiBase);
    this.occasion = null;
    this.inviteToken = null;
    this.inviteExisting = null;
    /* Review fix #1: shared by submitOutcome and removeOccasion — either
       action can collide with the other on the same occasion, not only
       with itself, so one flag guards both rather than one per method. */
    this.busy = false;
    this.bind();
    this.route();
  }

  PageController.prototype.bind = function () {
    var self = this;
    this.page.addEventListener('click', function (event) {
      if (self.handlePreseedClick(event)) return;
      var layoutButton = event.target.closest('[data-reminders-layout]');
      if (layoutButton) {
        if (layoutButton.dataset.remindersLayout === 'agenda') self.calendarMonth = null;
        self.setCalendarView(layoutButton.dataset.remindersLayout); return;
      }
      var monthButton = event.target.closest('[data-reminders-month-select], [data-reminders-year-month]');
      if (monthButton) {
        var fromYear = monthButton.hasAttribute('data-reminders-year-month');
        self.calendarMonth = Number(fromYear ? monthButton.dataset.remindersYearMonth : monthButton.dataset.remindersMonthSelect);
        self.setCalendarView('agenda');
        var focusTarget = self.page.querySelector(fromYear ? '[data-reminders-agenda-heading]' : '[data-reminders-month-select="' + self.calendarMonth + '"]');
        if (focusTarget) focusTarget.focus();
        return;
      }
      if (event.target.closest('[data-reminders-refresh]')) { self.showList(); return; }
      var action = event.target.closest('[data-reminders-action]');
      if (action) { event.preventDefault(); self.submitOutcome(action.dataset.remindersAction); return; }
      if (event.target.closest('[data-reminders-review-latest]')) { event.preventDefault(); self.reviewManageConflict(); return; }
      if (event.target.closest('[data-reminders-keep-draft]')) { event.preventDefault(); self.keepManageDraft(); return; }
      if (event.target.closest('[data-reminders-manage-remove-start]')) { event.preventDefault(); self.showRemoveConfirm(true); return; }
      if (event.target.closest('[data-reminders-manage-remove-cancel]')) { event.preventDefault(); self.showRemoveConfirm(false); return; }
      if (event.target.closest('[data-reminders-manage-remove-confirm-button]')) { event.preventDefault(); self.removeOccasion(); return; }
      if (event.target.closest('[data-reminders-invite-confirm]')) { event.preventDefault(); self.confirmInviteExisting(); return; }
      if (event.target.closest('[data-reminders-invite-decline]')) { event.preventDefault(); self.declineInvite(); return; }
    });
    var editForm = this.page.querySelector('[data-reminders-manage-edit-form]');
    if (editForm) {
      editForm.addEventListener('submit', function (event) { self.submitManageEdit(event); });
      editForm.addEventListener('input', function (event) {
        if (event.target.name === 'name') { self.syncManageNameLabel(event.target.value); self.syncManageIntent(); }
      });
    }
    var preferencesForm = this.page.querySelector('[data-reminders-page-preferences]');
    if (preferencesForm) preferencesForm.addEventListener('submit', function (event) { self.submitPreferences(event); });
    var inviteForm = this.page.querySelector('[data-reminders-invite-form]');
    if (inviteForm) inviteForm.addEventListener('submit', function (event) { self.submitInvite(event); });
    var preseedOtpForm = this.page.querySelector('[data-preseed-otp-form]');
    if (preseedOtpForm) preseedOtpForm.addEventListener('submit', function (event) { self.submitPreseedOtp(event); });
    var preseedDeleteForm = this.page.querySelector('[data-preseed-delete-form]');
    if (preseedDeleteForm) preseedDeleteForm.addEventListener('submit', function (event) { self.submitPreseedDelete(event); });
    var preseedUnsubscribeForm = this.page.querySelector('[data-preseed-unsubscribe-form]');
    if (preseedUnsubscribeForm) preseedUnsubscribeForm.addEventListener('submit', function (event) { self.submitPreseedUnsubscribe(event); });
    this.page.addEventListener('change', function (event) {
      if (event.target.closest('[data-reminders-manage-edit-form]')) { syncDateForm(event.target.closest('form')); if (event.target.name === 'type' || event.target.name === 'relationship') self.syncManageIntent(); return; }
      if (event.target.name === 'unknownDate') self.toggleInviteUnknownDate(event.target.checked);
    });
  };

  /* No hash routing and no pushState: every reminder_view link is a plain link, so a
     shared URL and the browser's own back button both just work, and a
     visit with JS disabled still gets the server-rendered shell. */
  PageController.prototype.route = function () {
    var search = (root.location && root.location.search) || '';
    this.basePath = (root.location && root.location.pathname) || '/pages/reminders';
    var params = parseParams(search);
    var view = resolveView(search);
    if (view === 'join') return this.showJoin(params.token || (root.history && root.history.state && root.history.state.fbBirthdayInvitationToken));
    if (view === 'group' || view === 'group-invite') return this.show('group');
    if (view === 'link') return this.showLink(params.r);
    if (view === 'invite') return this.showInvite(params.token);
    if (view === 'person') return this.showPerson(params.id);
    if (view === 'friend') return this.showFriend(params.id);
    if (view === 'manage') return this.showManage(params.id);
    if (view === 'settings') return this.showSettings();
    if (view === 'preseed') return this.showPreseed(params);
    return this.showList();
  };

  PageController.prototype.showJoin = function (token) {
    this.show('join');
    if (this.joinController) this.joinController.destroy();
    var section = this.page.querySelector('[data-reminders-join]');
    var sheet = document.querySelector('fb-reminders-sheet');
    this.joinController = root.FBRemindersJoin.mount(section, { api: this.api, token: token, authenticate: function (intent) {
      var auth = root.FBReminders.init(sheet);
      auth.birthdayInvitationReturn = intent.onVerified;
      return auth.open({ dataset: { remindersOpenState: 'identify', birthdayInvitationToken: intent.birthdayInvitationToken }, focus: function () {} });
    } });
  };

  PageController.prototype.show = function (name) {
    this.page.querySelectorAll('[data-reminders-page-state]').forEach(function (state) {
      state.hidden = state.dataset.remindersPageState !== name;
    });
    var heading = this.page.querySelector('[data-reminders-page-state="' + name + '"] h1');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      if (typeof heading.focus === 'function') heading.focus();
    }
  };

  PageController.prototype.showFatal = function (error) {
    var el = this.page.querySelector('[data-reminders-page-error]');
    if (el) el.textContent = (error && error.message) || this.page.dataset.tryAgain;
    this.show('error');
  };

  /* Review fix #4: the same routing an initial /me check already uses when
     it comes back signed out (showList/showPerson/showManage/showSettings
     below) — the shell's own call to action opens the T1 sheet's identify
     flow, so a session that expired mid-mutation lands the member on a real
     "sign in again" affordance instead of a generic error they cannot act
     on. */
  PageController.prototype.handleUnauthenticated = function () {
    this.show('shell');
  };

  /* Accepts either an ISO "YYYY-MM-DD" (occurrence dates) or a
     {month, day} object (an Occasion's own date), matching Controller's
     formatDate above. longForm picks the person-view style over the
     list row's compact one. */
  PageController.prototype.formatDate = function (value, longForm) {
    if (!value) return this.page.dataset.dateNeeded;
    var month, day;
    if (typeof value === 'string') {
      var parts = value.split('-');
      month = Number(parts[1]);
      day = Number(parts[2]);
    } else {
      month = Number(value.month);
      day = Number(value.day);
    }
    if (!validDate(month, day)) return this.page.dataset.dateNeeded;
    var options = longForm
      ? { day: 'numeric', month: 'long', timeZone: 'UTC' }
      : { day: 'numeric', month: 'short', timeZone: 'UTC' };
    return new Intl.DateTimeFormat('en-AU', options).format(new Date(Date.UTC(2000, month - 1, day)));
  };

  /* ---------- list (07) ---------- */

  /* The signed-out answer to /me is the shell the server already rendered, so
     these loaders keep it on screen while they ask. Swapping it for the
     loading skeleton and back moved everything below the page (the footer,
     in the first viewport on a phone) twice on every logged-out visit, about
     100px each way: a layout shift of 0.16 before any content changed. The
     skeleton now appears only once the visitor is known to be signed in and
     a different view is coming. */

  /* From 990px the cards between Up next and Your dates sit side by side
     (assets/fb-reminders.css), so a card that fills in after the list is on
     screen resizes or moves the cards beside it and pushes Your dates down.
     Each card carries data-fb-card-pending until its script has its answer
     (favourite flowers, group gifts, the wish list). Keep the loading state
     up until they have, for at most CARDS_WAIT_MS. Phones stack the cards
     and show the list straight away, as before. */
  var CARDS_WAIT_MS = 1200;
  /* A card whose answer never comes (a hung request) stops holding its
     place this long after the list shows, so it can't leave a blank slot. */
  var CARDS_RELEASE_MS = 5000;
  function releaseCards(page) {
    if (!page.querySelector('[data-fb-card-pending]')) return;
    root.setTimeout(function () {
      page.querySelectorAll('[data-fb-card-pending]').forEach(function (card) { card.removeAttribute('data-fb-card-pending'); });
    }, CARDS_RELEASE_MS);
  }
  function cardsSettled(page) {
    var wide = typeof root.matchMedia === 'function' && root.matchMedia('(min-width: 990px)').matches;
    if (!wide || !page.querySelector('[data-fb-card-pending]')) return Promise.resolve();
    return new Promise(function (resolve) {
      var started = Date.now();
      (function check() {
        if (!page.querySelector('[data-fb-card-pending]') || Date.now() - started >= CARDS_WAIT_MS) return resolve();
        root.setTimeout(check, 50);
      })();
    });
  }

  PageController.prototype.showList = async function () {
    try {
      var me = await this.api.me();
      if (!me.signedIn) return this.show('shell');
      if (root.FBRemindersLanding && root.FBRemindersLanding.hasPendingSave()) return this.show('shell');
      this.show('loading');
      var response = await this.api.getOccasions();
      this.renderList(response.occasions || [], me.member);
      await cardsSettled(this.page);
      this.show('list');
      releaseCards(this.page);
    } catch (error) {
      this.showFatal(error);
    }
  };

  PageController.prototype.bandText = function (channels) {
    var page = this.page;
    var map = { off: page.dataset.listBandOff, both: page.dataset.listBandBoth, sms: page.dataset.listBandSms, email: page.dataset.listBandEmail };
    return map[channelsSummary(channels)];
  };

  PageController.prototype.statusText = function (status) {
    var page = this.page;
    var map = {
      upcoming: page.dataset.statusUpcoming,
      date_needed: page.dataset.statusDateNeeded,
      sorted: page.dataset.statusSorted,
      skipped: page.dataset.statusSkipped,
      paused: page.dataset.statusPaused
    };
    return map[status] || words(status);
  };

  PageController.prototype.renderList = function (occasions, member) {
    var page = this.page;
    var settingsButton = page.querySelector('[data-reminders-channel-settings]');
    if (settingsButton) {
      settingsButton.setAttribute('aria-label', words('channel_settings'));
      settingsButton.setAttribute('title', words('channel_settings'));
      settingsButton.dataset.remindersEnableSms = 'false';
      settingsButton.hidden = false;
    }
    this.occasions = occasions;
    this.renderCalendar();
    var next = occasions.filter(function (o) { return o.next && o.next.daysUntil >= 0 && o.next.outcome === 'PENDING' && o.status !== 'PAUSED'; }).sort(function (a,b) { return a.next.daysUntil - b.next.daysUntil; })[0];
    var upcoming = page.querySelector('[data-reminders-up-next]'); upcoming.textContent = ''; upcoming.hidden = !next;
    if (next) { upcoming.appendChild(element('h2', '', words('up_next'))); var nextRows = element('ul', 'fb-reminders-page__rows'); this.renderRows(nextRows, [next]); upcoming.appendChild(nextRows); }
    page.querySelector('[data-reminders-list-empty]').hidden = occasions.length > 0;
    /* One line under the list intro. Hidden when there is nothing to tap. */
    var wayfinding = page.querySelector('[data-reminders-wayfinding-intro]');
    if (wayfinding) wayfinding.hidden = !occasions.length;
  };

  function calendarMonthName(month, shortForm) {
    return new Intl.DateTimeFormat('en-AU', { month: shortForm ? 'short' : 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2000, month - 1, 1)));
  }

  PageController.prototype.setCalendarView = function (layout) {
    this.calendarLayout = layout === 'year' || layout === 'agenda' ? layout : 'all';
    try { root.localStorage.setItem('fb_rem_calendar_view', this.calendarLayout); } catch (_) {}
    this.renderCalendar();
    var status = this.page.querySelector('[data-reminders-calendar-status]');
    if (status) status.textContent = this.calendarLayout === 'all' ? words('calendar_all_status') : this.calendarLayout === 'year' ? words('calendar_year_status') : this.calendarMonthSummary;
  };

  PageController.prototype.renderCalendar = function () {
    var page = this.page;
    var calendar = page.querySelector('[data-reminders-calendar]');
    var agenda = page.querySelector('[data-reminders-agenda]');
    if (!calendar || !agenda) return;
    var currentMonth = Number(new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', month: 'numeric' }).format(new Date()));
    if (!this.calendarMonth || this.calendarMonth < 1 || this.calendarMonth > 12) this.calendarMonth = currentMonth;
    if (!this.calendarLayout) {
      try { this.calendarLayout = root.localStorage.getItem('fb_rem_calendar_view'); } catch (_) {}
      if (this.calendarLayout !== 'agenda' && this.calendarLayout !== 'year') this.calendarLayout = 'all';
    }
    var self = this;
    var all = page.querySelector('[data-reminders-all]');
    var showAll = this.calendarLayout === 'all';
    var year = this.calendarLayout === 'year';
    calendar.hidden = !year; agenda.hidden = this.calendarLayout !== 'agenda';
    if (all) {
      all.hidden = !showAll;
      var sorted = showAll ? (this.occasions || []).slice().sort(function (a, b) {
        var aDated = !!(a.date && a.date.known);
        var bDated = !!(b.date && b.date.known);
        if (aDated !== bDated) return aDated ? -1 : 1;
        // ISO occurrence dates keep January next year after December this year.
        var aDate = aDated && a.next && a.next.date || '9999-12-31';
        var bDate = bDated && b.next && b.next.date || '9999-12-31';
        return compareStrings(aDate, bDate) || compareStrings(a.name || '', b.name || '') || compareStrings(a.id || '', b.id || '');
      }) : [];
      this.renderRows(all, sorted);
    }
    var undated = (this.occasions || []).filter(function (o) { return !o.date || !o.date.known; });
    var undatedSection = page.querySelector('[data-reminders-undated]');
    if (undatedSection) undatedSection.hidden = showAll || !undated.length;
    this.renderRows(page.querySelector('[data-reminders-list-group="undated"]'), showAll ? [] : undated);
    page.querySelectorAll('[data-reminders-layout]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.remindersLayout === self.calendarLayout ? 'true' : 'false');
    });
    var nav = page.querySelector('[data-reminders-month-nav]');
    nav.textContent = ''; calendar.textContent = '';
    for (var month = 1; month <= 12; month++) {
      var monthName = calendarMonthName(month);
      var rows = (this.occasions || []).filter(function (occasion) { return occasion.date && occasion.date.known && Number(occasion.date.month) === month; });
      rows.sort(function (a, b) { return Number(a.date.day) - Number(b.date.day) || compareStrings(a.name, b.name); });
      var countLabel = words(rows.length === 1 ? 'calendar_month_one' : 'calendar_month_count', { MONTH: monthName, COUNT: rows.length });
      var monthButton = element('button'); monthButton.type = 'button';
      monthButton.dataset.remindersMonthSelect = String(month);
      monthButton.setAttribute('aria-pressed', month === this.calendarMonth ? 'true' : 'false');
      monthButton.setAttribute('aria-label', countLabel);
      monthButton.setAttribute('aria-controls', 'reminders-agenda-heading');
      if (month === currentMonth) monthButton.setAttribute('aria-current', 'date');
      monthButton.appendChild(element('span', '', calendarMonthName(month, true)));
      var count = element('span', 'fb-reminders-month-nav__count', String(rows.length)); count.setAttribute('aria-hidden', 'true'); monthButton.appendChild(count);
      nav.appendChild(monthButton);
      if (month === this.calendarMonth) {
        this.calendarMonthSummary = countLabel;
        page.querySelector('[data-reminders-agenda-heading]').textContent = monthName;
        var agendaAdd = page.querySelector('[data-reminders-agenda-add]');
        agendaAdd.dataset.remindersMonth = String(month);
        agendaAdd.setAttribute('aria-label', words('add') + ' · ' + monthName);
        self.renderRows(page.querySelector('[data-reminders-agenda-rows]'), rows);
        var empty = page.querySelector('[data-reminders-agenda-empty]'); empty.hidden = !!rows.length; empty.textContent = words('calendar_empty', { MONTH: monthName });
      }
      if (!year) continue;
      var card = element('section', 'fb-reminders-month' + (month === currentMonth ? ' is-current' : ''));
      card.id = 'reminders-month-' + month;
      card.setAttribute('aria-labelledby', card.id + '-heading');
      var header = element('div', 'fb-reminders-month__header');
      var heading = element('h3'); heading.id = card.id + '-heading';
      var openMonth = element('button', 'fb-reminders-month__open', monthName);
      openMonth.type = 'button'; openMonth.dataset.remindersYearMonth = String(month);
      openMonth.setAttribute('aria-label', words('calendar_open_month', { MONTH: monthName }));
      heading.appendChild(openMonth); header.appendChild(heading);
      card.appendChild(header);
      if (month === currentMonth) card.appendChild(element('span', 'fb-reminders-month__current', words('current_month')));
      var list = element('ul', 'fb-reminders-page__rows'); self.renderRows(list, rows.slice(0, 3)); card.appendChild(list);
      if (rows.length > 3) {
        var details = element('details', 'fb-reminders-month__more');
        details.appendChild(element('summary', '', words('show_all', { COUNT: rows.length })));
        var extra = element('ul', 'fb-reminders-page__rows'); self.renderRows(extra, rows.slice(3)); details.appendChild(extra); card.appendChild(details);
      }
      if (!rows.length) card.appendChild(element('p', 'fb-reminders-month__empty', words('calendar_empty', { MONTH: monthName })));
      calendar.appendChild(card);
    }
  };

  /* By default a row leads with the person's name, linked to the friend view
     (their notes and occasions), then "Birthday · 9 Oct 2026".
     `options.withinPerson` is for the friend view itself, where every row is
     the same person's and the heading already names them: the row leads with
     the occasion in the name's bold style ("Birthday"), the line under it is
     the date alone, and nothing links back to the page it is on.
     Shop, Edit and Ask stay their own controls. A whole-row hit is not used,
     so those links cannot be swallowed by the friend destination. */
  function listSurfaceView(layout) {
    if (layout === 'year') return 'year';
    if (layout === 'agenda') return 'month';
    return 'all';
  }
  function bindListFriendOpen(node, source, occasion, page) {
    if (!node || typeof node.addEventListener !== 'function') return;
    node.addEventListener('click', function () {
      trackReminderEvent('reminders_person_opened', 'page', 'list', {
        occasion_id: occasion && occasion.id,
        source: source,
        view: listSurfaceView(page && page.calendarLayout)
      });
    });
  }
  PageController.prototype.renderRows = function (list, occasions, options) {
    if (!list) return;
    list.textContent = '';
    var self = this;
    var withinPerson = !!(options && options.withinPerson);
    occasions.forEach(function (occasion) {
      var info = classifyOccasion(occasion);
      var typeName = occasionName(occasion);
      var li = element('li', 'fb-reminders-page__row');
      var description = element('div', 'fb-reminders-page__row-info');
      if (withinPerson) {
        description.appendChild(element('strong', 'fb-reminders-page__row-name', typeName));
      } else if (occasion.friendId) {
        var friendHref = pageUrl(self.basePath, 'friend', occasion.friendId);
        var openLabel = words('open_notes', { NAME: occasion.name });
        var personLink = element('a', 'fb-reminders-page__row-name', occasion.name);
        personLink.href = friendHref;
        personLink.setAttribute('aria-label', openLabel);
        description.appendChild(personLink);
        bindListFriendOpen(personLink, 'list_name', occasion, self);
        /* Presence only. The list payload carries hasNotes, never the note. */
        if (occasion.hasNotes === true) {
          var notesMark = element('a', 'fb-reminders-notes-mark', words('notes_mark'));
          notesMark.href = friendHref;
          notesMark.setAttribute('aria-label', words('notes_mark') + '. ' + openLabel);
          notesMark.setAttribute('data-reminders-notes-mark', '');
          description.appendChild(notesMark);
          bindListFriendOpen(notesMark, 'notes_mark', occasion, self);
        }
      } else {
        description.appendChild(element('strong', 'fb-reminders-page__row-name', occasion.name));
      }
      var dateText = self.formatDate(info.dated ? info.date : null, false);
      if (info.dated && typeof info.date === 'string') dateText += ' ' + info.date.split('-')[0];
      description.appendChild(element('span', 'fb-reminders-page__row-date', withinPerson ? dateText : typeName + ' · ' + dateText));
      if (info.dated && occasion.next) description.appendChild(element('span', 'fb-reminders-page__row-status', info.status === 'upcoming' ? (occasion.next.daysUntil === 0 ? words('today') : words('days', { DAYS: occasion.next.daysUntil })) : self.statusText(info.status)));
      li.appendChild(description);
      var actions = element('div', 'fb-reminders-row-actions');
      var shop = element('a', 'fb-reminders-text-action', words('shop') + ' →'); shop.href = pageUrl(self.basePath, 'person', occasion.id);
      shop.setAttribute('aria-label', words('shop_for', { NAME: occasion.name, TYPE: typeName }));
      if (!info.dated && occasion.type === 'BIRTHDAY') {
        var template = self.page.querySelector('[data-reminders-invitation-template]');
        if (template && root.FBRemindersInvitation) {
          var panel = template.content.firstElementChild.cloneNode(true);
          root.FBRemindersInvitation.mount(panel, { url: occasion.links && occasion.links.joinReminders });
          li.appendChild(panel);
        }
      }
      actions.appendChild(shop);
      var edit = element('a', 'fb-reminders-text-action', words(info.dated ? 'edit' : 'add_date')); edit.href = pageUrl(self.basePath, 'manage', occasion.id); edit.setAttribute('aria-label', words(info.dated ? 'edit' : 'add_date') + ' · ' + occasion.name + ' · ' + typeName); actions.appendChild(edit);
      li.appendChild(actions); list.appendChild(li);
    });
  };

  /* ---------- person (08) ---------- */

  /* There is no GET /occasions/{id} in API-CONTRACT.md 5.2, only the list —
     so a deep link (list row, bookmark, ?return= bounce) re-fetches the
     list and finds its one row. GET /occasions is inexpensive and this
     keeps person/manage always showing the server's current truth. */
  PageController.prototype.findOccasion = async function (id) {
    var response = await this.api.getOccasions();
    var match = (response.occasions || []).filter(function (occasion) { return occasion.id === id; });
    return match[0] || null;
  };

  PageController.prototype.showPerson = async function (id) {
    try {
      var me = await this.api.me();
      if (!me.signedIn) return this.show('shell');
      this.show('loading');
      var occasion = id ? await this.findOccasion(id) : null;
      if (!occasion) return this.showFatal({ message: this.page.dataset.personNotFound });
      this.renderPerson(occasion);
      this.show('person');
    } catch (error) {
      this.showFatal(error);
    }
  };

  PageController.prototype.setAskLink = function (selector, url, returnTo) {
    var el = this.page.querySelector(selector);
    if (!el) return;
    if (!url) { el.hidden = true; return; }
    var target = withReturn(url, returnTo);
    /* Review fix #2: same scheme guard as showLink below — a rejected
       scheme is treated the same as having no link at all. */
    if (!isSafeHref(target)) { el.hidden = true; return; }
    el.href = target;
  };

  /* The signed shop link supplies context for in-page recommendations and
     subsequent product browsing. The person page itself now opens with the
     occasion and its picks, rather than sending shoppers to a collection. */
  PageController.prototype.renderPerson = function (occasion, contextAlreadyStored) {
    trackReminderEvent('occasion_shop_viewed', 'page', 'person', { occasion_id: occasion.id });
    var page = this.page;
    var dated = !!(occasion.date && occasion.date.known);
    var name = occasion.name || words('neutral_name');
    var label = occasionName(occasion);
    var personal = occasion.type === 'BIRTHDAY' || occasion.type === 'ANNIVERSARY';
    var headline = personal ? possessive(name) + ' ' + label.toLowerCase() : label + ' for ' + name;
    var days = dated && occasion.next && occasion.next.daysUntil;
    if (days === 0) headline += ' is today';
    page.querySelector('[data-reminders-person-date]').textContent = dated ? this.formatDate(occasion.next && occasion.next.date, true) : words('date_needed');
    page.querySelector('[data-reminders-person-occasion-title]').textContent = headline;
    page.dataset.occasionType = occasion.type || 'OTHER';
    var browse = page.querySelector('[data-reminders-seasonal-browse]');
    if (browse) {
      var active = false;
      browse.querySelectorAll('[data-seasonal-occasion]').forEach(function (link) {
        link.hidden = link.dataset.seasonalOccasion !== occasion.type;
        if (!link.hidden) active = true;
      });
      browse.hidden = !active;
    }
    page.querySelector('[data-reminders-loading-name]').textContent = name;
    /* Copy that addresses the person ("Invite Alvaro to share…", "Alvaro is
       my…", "Explore more for Alvaro") rather than a generic "them". */
    if (typeof page.querySelectorAll === 'function') {
      page.querySelectorAll('[data-reminders-person-name]').forEach(function (slot) { slot.textContent = name; });
    }
    page.querySelector('[data-reminders-person-occasion-icon]').textContent = OCCASION_ICONS[occasion.type] || '✿';
    page.querySelector('[data-reminders-person-occasion]').setAttribute('data-occasion', occasion.type || 'OTHER');

    if (root.FBPersonDetails) root.FBPersonDetails.mount(page.querySelector('[data-person-details-occasion]'), this.api, {
      id: occasion.friendId, name: name, askAddress: function () { page.querySelector('[data-reminders-person-ask-address]').click(); }
    });
    var manageLink = page.querySelector('[data-reminders-person-manage-link]');
    var manageTarget = occasion.id ? pageUrl(this.basePath, 'manage', occasion.id) : (occasion.links && occasion.links.manage);
    manageLink.hidden = !isSafeHref(manageTarget);
    if (!manageLink.hidden) manageLink.setAttribute('href', manageTarget);
    /* Every reminder saved for this person, on the person view. Hidden when
       the occasion carries no friendId: there is no person view to open. */
    var allLink = page.querySelector('[data-reminders-person-all-link]');
    if (allLink) {
      allLink.hidden = !occasion.friendId;
      if (occasion.friendId) {
        allLink.setAttribute('href', pageUrl(this.basePath, 'friend', occasion.friendId));
        allLink.textContent = words('friend_link', { NAME: possessive(name) });
      }
    }

    var giftUrl = (occasion.links && occasion.links.shop) || page.dataset.defaultGiftUrl;
    /* Review fix #2: an unsafe scheme on the API-supplied shop link falls
       back to the default gift URL, the same as a missing one. */
    giftUrl = isSafeHref(giftUrl) ? giftUrl : page.dataset.defaultGiftUrl;
    /* T3: the person view receives the signed `?occ=` occasion-shop
       link (API-CONTRACT.md 6.3). Store the context now, in the same tab and
       origin the shopper is about to leave, so the destination page can fill
       the banner straight from sessionStorage — a bare ctx token carries no
       name (6.1) and there is no endpoint to resolve one back to one. */
    var contextMatch = /[?&]occ=([^&#]+)/.exec(giftUrl);
    if (contextMatch) {
      if (!contextAlreadyStored) storeOccasionLinkContext(giftUrl, occasion);
    } else if (readContext()) {
      /* A person without a dated occurrence has no signed token. Do not
         carry the previous person's banner or cart attribution onward. */
      clearContext();
      writeCartAttribute('');
    }
    /* Product cards are rendered from the live Shopify collection. Carry
       the same signed occurrence into a direct product choice. The context
       store above powers the banner in this tab; the URL keeps the token
       visible for the subsequent product route. */
    if (typeof page.querySelectorAll === 'function') {
      var productLinks = page.querySelectorAll('[data-reminders-person-product-link]');
      var shelf = page.querySelector('.fb-reminders-person__shop');
      if (shelf) shelf.hidden = !occasion.id;
      productLinks.forEach(function (productLink) {
        if (!contextMatch || !isSafeHref(productLink.href)) return;
        productLink.href = appendParam(productLink.href, 'occ', contextMatch[1]);
      });
    }

    var more = page.querySelector('[data-reminders-person-more]');
    if (more) {
      var moreItems = null;
      var relationship = occasion.relationship;
      more.hidden = true;
      if (typeof page.addEventListener === 'function') page.addEventListener('fb-reminders:relationship', function (event) {
        relationship = event.detail && event.detail.relationship;
        if (moreItems) moreOccasions(more, occasion, moreItems, relationship);
      });
      this.api.getOccasions().then(function (response) {
        moreItems = response.occasions || [];
        moreOccasions(more, occasion, moreItems, relationship);
      }).catch(function () {});
    }
    var returnTo = occasion.id ? pageUrl(this.basePath, 'person', occasion.id) : null;
    var messageLink = page.querySelector('[data-reminders-person-message-link]');
    var messageTarget = occasion.links && occasion.links.message ? withReturn(occasion.links.message, returnTo) : null;
    // The section leaves the link out while "Write a message" is switched off.
    if (messageLink && messageTarget && isSafeHref(messageTarget)) {
      messageLink.hidden = false;
      messageLink.href = messageTarget;
    } else if (messageLink) {
      messageLink.hidden = true;
    }

    var details = page.querySelector('.fb-reminders-person__details');
    if (details) details.hidden = !occasion.id;
    var birthdayRow = page.querySelector('[data-reminders-person-ask-birthday-row]');
    var unknownBirthday = occasion.type === 'BIRTHDAY' && occasion.date && !occasion.date.known;
    birthdayRow.hidden = occasion.type !== 'BIRTHDAY' || !!unknownBirthday;
    var invitationRow = page.querySelector('[data-reminders-person-invitation]');
    if (this.personInvitationPanel) { this.personInvitationPanel.destroy(); this.personInvitationPanel = null; }
    if (invitationRow) {
      invitationRow.hidden = !unknownBirthday;
      if (unknownBirthday && root.FBRemindersInvitation) this.personInvitationPanel = root.FBRemindersInvitation.mount(invitationRow.querySelector('[data-reminders-invitation]'), { url: occasion.links && occasion.links.joinReminders });
    }
  };

  /* ---------- person view: all of one person's reminders ---------- */

  /* ?reminder_view=friend&id=fr_… — `id` is the Occasion's friendId, which
     every occasion saved for the same person shares (API-CONTRACT.md 5.2).
     Same shape as showPerson: there is no per-person endpoint, so the list
     is fetched and filtered, keeping the view on the server's current
     truth. A friendId with no occasions reads the same as an unknown one. */
  PageController.prototype.showFriend = async function (id) {
    try {
      var me = await this.api.me();
      if (!me.signedIn) return this.show('shell');
      this.show('loading');
      var response = id ? await this.api.getOccasions() : { occasions: [] };
      var occasions = (response.occasions || []).filter(function (occasion) { return occasion.friendId === id; });
      if (!occasions.length) return this.showFatal({ message: words('friend_not_found') });
      this.renderFriend(occasions);
      this.show('friend');
    } catch (error) {
      this.showFatal(error);
    }
  };

  /* Rows run dated first by next date, then undated (groupOccasions' own
     order), each with the same Shop and Edit actions as the list. The name
     and relationship come from the first occasion that carries them: the
     API keeps both per person, so every row agrees. */
  PageController.prototype.renderFriend = function (occasions) {
    var page = this.page;
    var first = occasions[0];
    var named = occasions.filter(function (occasion) { return occasion.name; })[0] || first;
    if (root.FBPersonDetails) root.FBPersonDetails.mount(page.querySelector('[data-person-details-friend]'), this.api, { id: first.friendId, name: named.name || words('neutral_name') });
    var related = occasions.filter(function (occasion) { return occasion.relationship; })[0];
    var name = named.name || words('neutral_name');
    var relationship = related ? related.relationship : null;
    var heading = page.querySelector('[data-reminders-friend-heading]');
    if (heading) heading.textContent = words('friend_heading', { NAME: possessive(name) });
    var kicker = page.querySelector('[data-reminders-friend-relationship]');
    if (kicker) { kicker.textContent = relationship || ''; kicker.hidden = !relationship; }
    var groups = groupOccasions(occasions);
    this.renderRows(page.querySelector('[data-reminders-friend-rows]'), groups.comingUp.concat(groups.later), { withinPerson: true });
    /* Opens the capture sheet with the name locked to this person (the
       same prefill the "More occasions" chips use), type left for them to
       choose. */
    var add = page.querySelector('[data-reminders-friend-add]');
    if (add) {
      add.textContent = words('friend_add', { NAME: name });
      add.dataset.remindersFriendId = first.friendId;
      add.dataset.remindersName = name;
    }
    moreOccasions(page.querySelector('[data-reminders-friend-more]'), { friendId: first.friendId, name: name }, occasions, relationship);
  };

  function occasionIntentControl(type, relationship, name) {
    var relation = String(relationship || '').trim().toLowerCase();
    var person = String(name || '').trim() || 'them';
    if ((type === 'MOTHERS_DAY' && relation !== 'mum') || (type === 'FATHERS_DAY' && relation !== 'dad')) return {
      question: 'Are you celebrating ' + person + ' as a parent?', help: 'This helps us choose suggestions for this occasion.',
      options: [['parental-role', 'Yes, I’m celebrating their role as a parent'], ['', 'Not now', 'Keep this reminder without adding that context.']]
    };
    if (type === 'VALENTINES_DAY' && relation !== 'partner') return {
      question: 'What are you celebrating?', help: 'We’ll use this context for Valentine’s Day suggestions.',
      options: [['platonic', 'Our friendship'], ['family', 'Family love'], ['', 'Leave this for now']]
    };
    if (type === 'ANNIVERSARY' && relation !== 'partner') return {
      question: 'What does this anniversary mark?', help: 'Choose the meaning of this occasion for ' + person + '.',
      options: [['couple', 'A couple’s anniversary'], ['work', 'A work milestone'], ['bereavement', 'Remembering someone'], ['', 'Leave this for now']]
    };
    return null;
  }

  PageController.prototype.syncManageIntent = function () {
    var form = this.page.querySelector('[data-reminders-manage-edit-form]');
    var field = form.querySelector('[data-reminders-manage-intent]');
    if (!field) return;
    var type = form.elements.type ? form.elements.type.value : this.occasion.type;
    var config = this.occasion && this.occasion.revision ? occasionIntentControl(type, form.elements.relationship && form.elements.relationship.value, form.elements.name.value) : null;
    field.hidden = !config;
    var choices = field.querySelector('[data-reminders-intent-choices]');
    choices.replaceChildren();
    if (!config) return;
    field.querySelector('legend').textContent = config.question;
    field.querySelector('[data-reminders-intent-help]').textContent = config.help;
    var self = this;
    this.intentDrafts = this.intentDrafts || {};
    config.options.forEach(function (choice) {
      var label = element('label', 'fb-reminders-check fb-reminders-intent-choice');
      var input = document.createElement('input'); input.type = 'radio'; input.name = 'explicitIntent'; input.value = choice[0];
      input.checked = choice[0] === (self.intentDrafts[type] || '');
      input.setAttribute('aria-describedby', 'fb-reminders-intent-help');
      input.addEventListener('change', function () { self.intentDrafts[type] = input.value; });
      var text = element('span', '', choice[1]);
      if (choice[2]) text.appendChild(element('small', '', choice[2]));
      label.appendChild(input); label.appendChild(text); choices.appendChild(label);
    });
  };

  PageController.prototype.reviewManageConflict = async function () {
    var error = this.page.querySelector('[data-reminders-manage-edit-error]');
    try {
      var latest = await this.findOccasion(this.occasion.id);
      if (!latest) { error.textContent = 'This reminder is no longer available. Your changes are still here.'; return; }
      this.latestManageOccasion = latest;
      var meaning = {'parental-role':'Celebrating their role as a parent',platonic:'Our friendship',family:'Family love',couple:'A couple’s anniversary',work:'A work milestone',bereavement:'Remembering someone'};
      var title = {MOTHERS_DAY:'Mother’s Day',FATHERS_DAY:'Father’s Day',VALENTINES_DAY:'Valentine’s Day',ANNIVERSARY:'Anniversary',CHRISTMAS:'Christmas',BIRTHDAY:'Birthday',OTHER:latest.label || 'Other'};
      var date = latest.date && latest.date.known ? latest.date.day + '/' + latest.date.month : 'Date not added';
      this.page.querySelector('[data-reminders-manage-latest]').textContent = [latest.name,latest.relationship || 'Relationship not added',title[latest.type] || latest.type,date,meaning[latest.explicitIntent] || 'No extra context',latest.status === 'PAUSED' ? 'Paused' : 'Active'].join(' · ');
      this.page.querySelector('[data-reminders-manage-conflict]').hidden = false;
    } catch (failure) { error.textContent = 'We couldn’t load the latest reminder. Your changes are still here. Please try again.'; }
  };

  PageController.prototype.keepManageDraft = function () {
    if (!this.latestManageOccasion) return;
    // Only a deliberate review action advances the revision. The form stays intact.
    this.occasion = this.latestManageOccasion;
    this.latestManageOccasion = null;
    var review = this.page.querySelector('[data-reminders-review-latest]'); if (review) review.hidden = true;
    this.page.querySelector('[data-reminders-manage-conflict]').hidden = true;
    this.page.querySelector('[data-reminders-manage-edit-error]').textContent = 'Your changes are still here. Save changes when you’re ready.';
  };

  /* ---------- manage (17) ---------- */

  PageController.prototype.showManage = async function (id) {
    try {
      var me = await this.api.me();
      if (!me.signedIn) return this.show('shell');
      this.show('loading');
      var occasion = id ? await this.findOccasion(id) : null;
      if (!occasion) return this.showFatal({ message: this.page.dataset.personNotFound });
      this.renderManage(occasion);
      this.show('manage');
    } catch (error) {
      this.showFatal(error);
    }
  };

  /* The Manage form's relationship label reads "Alvaro is my…" rather than
     "They are my…". renderManage sets it from the saved occasion; the input
     listener in bind() keeps it in step while the name field is retyped,
     falling back to the saved name when the field is emptied. */
  PageController.prototype.syncManageNameLabel = function (typed) {
    var label = this.page.querySelector('[data-reminders-manage-name]');
    if (!label) return;
    var value = typeof typed === 'string' ? typed.trim() : '';
    label.textContent = value || (this.occasion && this.occasion.name) || words('neutral_name');
  };

  PageController.prototype.renderManage = function (occasion) {
    this.occasion = occasion;
    this.intentDrafts = {}; this.intentDrafts[occasion.type] = occasion.explicitIntent || '';
    this.latestManageOccasion = null;
    var review = this.page.querySelector('[data-reminders-review-latest]'); if (review) review.hidden = true;
    var conflict = this.page.querySelector('[data-reminders-manage-conflict]'); if (conflict) conflict.hidden = true;
    var page = this.page;
    var dated = !!(occasion.date && occasion.date.known);
    var dateText = this.formatDate(dated ? (occasion.next && occasion.next.date) : null, true);
    page.querySelector('[data-reminders-manage-summary]').textContent = (occasion.name || '') + ' · ' + dateText;

    var form = page.querySelector('[data-reminders-manage-edit-form]');
    form.elements.name.value = occasion.name || '';
    this.syncManageNameLabel(occasion.name);
    if (form.elements.relationship) {
      var relationship = occasion.relationship || '';
      if (relationship && !Array.from(form.elements.relationship.options).some(function (option) { return option.value === relationship; })) {
        var oldRelation = element('option', '', relationship); oldRelation.value = relationship; form.elements.relationship.appendChild(oldRelation);
      }
      form.elements.relationship.value = relationship;
    }
    form.elements.day.value = dated && occasion.date.day ? String(occasion.date.day) : '';
    form.elements.month.value = dated && occasion.date.month ? String(occasion.date.month) : '';
    if (form.elements.label) form.elements.label.value = occasion.label || '';
    if (form.elements.type) { form._dateType = null; form._manualDates = {}; form.elements.type.value = occasion.type; form.elements.unknownDate.checked = !dated; syncDateForm(form); }

    this.syncManageIntent();

    /* An undated occasion has no occurrence to skip or mark handled — the
       right action for it is the edit form above, or the birthday ask from
       the person view — so those two stay hidden rather than sitting there
       inert (submitOutcome itself also no-ops with no occasion.next, but a
       button that visibly does nothing is worse than one that isn't shown). */
    var hasOccurrence = !!(occasion.next && occasion.next.id);
    var restorable = canRestore(occasion);
    page.querySelector('[data-reminders-action="snooze"]').hidden = !canSnooze(occasion);
    page.querySelector('[data-reminders-action="restore"]').hidden = !restorable;
    page.querySelector('[data-reminders-action="handled_elsewhere"]').hidden = restorable || !hasOccurrence;
    page.querySelector('[data-reminders-action="skipped"]').hidden = restorable || !hasOccurrence;

    page.querySelector('[data-reminders-manage-remove-copy]').textContent = safeReplace(page.dataset.manageRemoveTemplate, '__NAME__', occasion.name || '');
    this.showRemoveConfirm(false);
    page.querySelector('[data-reminders-manage-status]').textContent = '';
    page.querySelector('[data-reminders-manage-edit-error]').textContent = '';
  };

  /* Calls the outcome endpoint and re-renders manage from a fresh fetch of
     just this occasion, so the visible state always reflects the server's
     answer (T2.3) and a sibling row's data is never even read, let alone
     changed (T2.5). A refusal (e.g. snooze with no stage left) shows the
     server's own message and hides the snooze control going forward —
     the reactive half of "honouring its refusals"; canSnooze above is the
     proactive half. */
  PageController.prototype.submitOutcome = async function (action) {
    var page = this.page;
    var status = page.querySelector('[data-reminders-manage-status]');
    var occasion = this.occasion;
    if (!occasion || !occasion.next) return;
    /* Review fix #1: ignore a re-entrant call (double-click, or a second
       action clicked while this one is still in flight) rather than firing
       a second concurrent request for the same occurrence. */
    if (this.busy) return;
    this.busy = true;
    var control = page.querySelector('[data-reminders-action="' + action + '"]');
    if (control) control.disabled = true;
    var body = { outcome: action, shown: occasion.next.date || null };
    if (action === 'snooze') body.snoozeDays = 2;
    try {
      await this.api.occurrenceOutcome(occasion.next.id, body);
      var outcomeEvent = OUTCOME_EVENT_NAMES[action];
      if (outcomeEvent) trackReminderEvent(outcomeEvent, 'page', 'manage', { occasion_id: occasion.id, occurrence_id: occasion.next.id });
      var fresh = await this.findOccasion(occasion.id);
      if (fresh) this.renderManage(fresh);
      if (status) status.textContent = page.dataset.preferencesSaved;
      /* Review fix #3: this outcome just changed what /me would answer
         (channels/notification/occasion counts) — invalidate the 60s cache
         other surfaces read, including the header dot on every other page. */
      this.api.clearMe();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      if (status) status.textContent = (error && error.message) || page.dataset.manageError;
      if (action === 'snooze') page.querySelector('[data-reminders-action="snooze"]').hidden = true;
    } finally {
      this.busy = false;
      if (control) control.disabled = false;
    }
  };

  PageController.prototype.submitManageEdit = async function (event) {
    event.preventDefault();
    var page = this.page;
    var form = event.currentTarget;
    var errorNode = page.querySelector('[data-reminders-manage-edit-error]');
    errorNode.textContent = '';
    var name = form.elements.name.value.trim();
    if (!name) { errorNode.textContent = page.dataset.nameRequired; return; }
    if (name.length > 80) { errorNode.textContent = page.dataset.nameLong; return; }
    var unknown = form.elements.unknownDate && form.elements.unknownDate.checked;
    var day = !unknown && form.elements.day.value ? Number(form.elements.day.value) : null;
    var month = !unknown && form.elements.month.value ? Number(form.elements.month.value) : null;
    if ((day === null) !== (month === null)) { errorNode.textContent = page.dataset.dateRequired; return; }
    if (day !== null && !validDate(month, day)) { errorNode.textContent = page.dataset.dateRequired; return; }
    var type = form.elements.type ? form.elements.type.value : this.occasion.type;
    if (form.elements.type && !type) { errorNode.textContent = page.dataset.occasionRequired; return; }
    var label = type === 'OTHER' && form.elements.label ? form.elements.label.value.trim() : null;
    var labelError = occasionLabelError(type, label, page.dataset);
    if (labelError) { errorNode.textContent = labelError; return; }
    try {
      var body = { name: name, type: type, label: label, day: day, month: month, relationship: form.elements.relationship ? form.elements.relationship.value || null : this.occasion.relationship };
      // A new client carries a revision even for core routes. Older API fixtures
      // without a revision retain their existing ordinary-edit behaviour.
      if (this.occasion.revision) {
        body.revision = this.occasion.revision;
        var config = occasionIntentControl(type, body.relationship, name);
        if (config) body.explicitIntent = this.intentDrafts && this.intentDrafts[type] || null;
      }
      await this.api.patchOccasion(this.occasion.id, body);
      trackReminderEvent('occasion_saved', 'page', 'manage', { occasion_id: this.occasion.id });
      var fresh = await this.findOccasion(this.occasion.id);
      if (fresh) this.renderManage(fresh);
      page.querySelector('[data-reminders-manage-status]').textContent = page.dataset.preferencesSaved;
      this.api.clearMe();
      notifyRemindersChanged();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      errorNode.textContent = error && error.code === 'EDIT_CONFLICT' ? 'This reminder changed in another tab. Your changes are still here. Review the latest reminder before saving again.' : (error && error.message) || 'We couldn’t save your changes. They’re still here. Please try again.';
      var review = page.querySelector('[data-reminders-review-latest]'); if (review) review.hidden = !(error && error.code === 'EDIT_CONFLICT');
    }
  };

  PageController.prototype.showRemoveConfirm = function (visible) {
    var confirmBlock = this.page.querySelector('[data-reminders-manage-remove-confirm]');
    var start = this.page.querySelector('[data-reminders-manage-remove-start]');
    if (confirmBlock) confirmBlock.hidden = !visible;
    if (start) start.hidden = visible;
  };

  /* The confirmation itself (naming the scope: "This removes {name}'s
     birthday and future reminders…") is static copy set in renderManage
     from data-manage-remove-template, so it is visible the moment the
     member opens the confirm step, before this ever runs. */
  PageController.prototype.removeOccasion = async function () {
    var page = this.page;
    if (!this.occasion) return;
    /* Review fix #1: shares submitOutcome's busy flag — without it, a
       double-tap on "Remove" fires a second DELETE against the id the first
       call already removed, overwriting the success message with a generic
       failure. */
    if (this.busy) return;
    this.busy = true;
    var confirmButton = page.querySelector('[data-reminders-manage-remove-confirm-button]');
    if (confirmButton) confirmButton.disabled = true;
    var status = page.querySelector('[data-reminders-manage-status]');
    try {
      await this.api.deleteOccasion(this.occasion.id);
      if (status) status.textContent = page.dataset.manageRemoved;
      ['[data-reminders-manage-edit]', '[data-reminders-manage-remove-start]', '[data-reminders-manage-remove-confirm]'].forEach(function (selector) {
        var el = page.querySelector(selector);
        if (el) el.hidden = true;
      });
      page.querySelectorAll('[data-reminders-action]').forEach(function (button) { button.hidden = true; });
      this.api.clearMe();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      if (status) status.textContent = (error && error.message) || page.dataset.manageError;
    } finally {
      this.busy = false;
      if (confirmButton) confirmButton.disabled = false;
    }
  };

  /* ---------- settings (18) — the sheet's preferences panel, page-native ---------- */

  PageController.prototype.showSettings = async function () {
    try {
      var me = await this.api.me();
      if (!me.signedIn) return this.show('shell');
      this.show('loading');
      var prefs = await this.api.getPreferences();
      this.renderSettings(prefs);
      this.show('settings');
    } catch (error) {
      this.showFatal(error);
    }
  };

  PageController.prototype.renderSettings = function (prefs) {
    var page = this.page;
    var form = page.querySelector('[data-reminders-page-preferences]');
    form.elements.sms.checked = !!(prefs.sms && prefs.sms.enabled);
    form.elements.email.checked = !!(prefs.email && prefs.email.enabled);
    form.elements.email.disabled = !!(prefs.email && prefs.email.editable === false);
    page.querySelector('[data-reminders-page-phone-masked]').textContent = prefs.sms && prefs.sms.phoneMasked ? '(' + prefs.sms.phoneMasked + ')' : '';
    page.querySelector('[data-reminders-page-email-masked]').textContent = prefs.email && prefs.email.emailMasked ? '(' + prefs.email.emailMasked + ')' : '';
    var reason = page.querySelector('[data-reminders-page-email-reason]');
    reason.textContent = prefs.email && prefs.email.reason ? prefs.email.reason : '';
    reason.hidden = !reason.textContent;
    page.querySelector('[data-reminders-page-preferences-status]').textContent = prefs.providerSync === 'pending' ? page.dataset.preferencesPending : '';
  };

  PageController.prototype.submitPreferences = async function (event) {
    event.preventDefault();
    var page = this.page;
    var form = event.currentTarget;
    var statusNode = page.querySelector('[data-reminders-page-preferences-status]');
    var body = { sms: form.elements.sms.checked, email: form.elements.email.checked };
    try {
      var response = await this.api.putPreferences(body);
      statusNode.textContent = response.providerSync === 'pending' ? page.dataset.preferencesPending : page.dataset.preferencesSaved;
      trackReminderEvent('preference_changed', 'page', 'settings', null);
      if (body.sms || body.email) trackReminderEvent('notification_channel_enabled', 'page', 'settings', null);
      this.api.clearMe();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      statusNode.textContent = (error && error.message) || page.dataset.manageError;
    }
  };

  /* ---------- invite (30) ---------- */

  PageController.prototype.showInvite = async function (token) {
    this.show('loading');
    this.inviteToken = token;
    if (!token) return this.showFatal({ message: this.page.dataset.inviteInvalid });
    try {
      var invite = await this.api.getInvite(token);
      this.renderInvite(invite);
      this.show('invite');
    } catch (error) {
      this.showFatal({ message: this.page.dataset.inviteInvalid });
    }
  };

  PageController.prototype.renderInvite = function (invite) {
    var page = this.page;
    trackReminderEvent('invite_viewed', 'page', 'invite', this.inviteToken ? { invite_token: this.inviteToken } : null);
    var existingBlock = page.querySelector('[data-reminders-invite-existing]');
    var form = page.querySelector('[data-reminders-invite-form]');
    if (invite.existing) {
      this.inviteExisting = invite.existing;
      existingBlock.hidden = false;
      form.hidden = true;
      page.querySelector('[data-reminders-invite-existing-summary]').textContent = safeReplace(page.dataset.inviteExistingTemplate, '__NAME__', invite.existing.name || '');
    } else {
      this.inviteExisting = null;
      existingBlock.hidden = true;
      form.hidden = false;
      form.elements.name.value = invite.recipientFirstName || '';
    }
  };

  PageController.prototype.toggleInviteUnknownDate = function (checked) {
    var form = this.page.querySelector('[data-reminders-invite-form]');
    if (!form) return;
    form.elements.day.disabled = checked;
    form.elements.month.disabled = checked;
    form.elements.day.required = !checked;
    form.elements.month.required = !checked;
    if (checked) { form.elements.day.value = ''; form.elements.month.value = ''; }
  };

  PageController.prototype.renderInviteSaved = function (saved, fallbackName) {
    var page = this.page;
    var name = (saved && saved.name) || fallbackName || '';
    var dated = !!(saved && saved.date && saved.date.known);
    var dateText = this.formatDate(dated ? saved.date : null, true);
    var status = page.querySelector('[data-reminders-invite-status]');
    status.textContent = safeReplace(safeReplace(page.dataset.savedTemplate, '__NAME__', name), '__DATE__', dateText);
    page.querySelector('[data-reminders-invite-form]').hidden = true;
    var existingBlock = page.querySelector('[data-reminders-invite-existing]');
    if (existingBlock) existingBlock.hidden = true;
  };

  PageController.prototype.submitInvite = async function (event) {
    event.preventDefault();
    var page = this.page;
    var form = event.currentTarget;
    var errorNode = page.querySelector('[data-reminders-invite-error]');
    errorNode.textContent = '';
    var name = form.elements.name.value.trim();
    var unknown = form.elements.unknownDate.checked;
    if (!name) { errorNode.textContent = page.dataset.nameRequired; return; }
    if (name.length > 80) { errorNode.textContent = page.dataset.nameLong; return; }
    var month = unknown || !form.elements.month.value ? null : Number(form.elements.month.value);
    var day = unknown || !form.elements.day.value ? null : Number(form.elements.day.value);
    if (!unknown && !validDate(month, day)) { errorNode.textContent = page.dataset.dateRequired; return; }
    try {
      var response = await this.api.acceptInvite(this.inviteToken, { type: 'BIRTHDAY', name: name, month: month, day: day, source: 'invite' });
      var saved = response.saved && response.saved[0];
      this.renderInviteSaved(saved, name);
      trackReminderEvent('invite_accepted', 'page', 'invite', { invite_token: this.inviteToken, occasion_id: saved && saved.id });
      if (this.api.clearMe) this.api.clearMe();
      notifyRemindersChanged();
    } catch (error) {
      errorNode.textContent = (error && error.message) || page.dataset.manageError;
    }
  };

  PageController.prototype.confirmInviteExisting = async function () {
    var existing = this.inviteExisting;
    if (!existing) return;
    var page = this.page;
    var status = page.querySelector('[data-reminders-invite-status]');
    var body = {
      type: existing.type,
      name: existing.name,
      month: existing.date && existing.date.month,
      day: existing.date && existing.date.day,
      year: existing.date && existing.date.year,
      source: 'invite'
    };
    try {
      var response = await this.api.acceptInvite(this.inviteToken, body);
      var saved = (response.saved && response.saved[0]) || existing;
      this.renderInviteSaved(saved, existing.name);
      trackReminderEvent('invite_accepted', 'page', 'invite', { invite_token: this.inviteToken, occasion_id: saved && saved.id });
      this.api.clearMe();
      notifyRemindersChanged();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      status.textContent = (error && error.message) || page.dataset.manageError;
    }
  };

  PageController.prototype.declineInvite = async function () {
    var page = this.page;
    var status = page.querySelector('[data-reminders-invite-status]');
    try {
      await this.api.declineInvite(this.inviteToken, { reason: 'not_annual' });
      trackReminderEvent('invite_declined', 'page', 'invite', this.inviteToken ? { invite_token: this.inviteToken } : null);
      status.textContent = page.dataset.inviteDeclined;
      page.querySelector('[data-reminders-invite-form]').hidden = true;
      var existingBlock = page.querySelector('[data-reminders-invite-existing]');
      if (existingBlock) existingBlock.hidden = true;
      this.api.clearMe();
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') { this.handleUnauthenticated(); return; }
      status.textContent = (error && error.message) || page.dataset.manageError;
    }
  };

  /* ---------- link landing (11 entry) ---------- */

  /* Resolves ?r= exactly once (no retry, no polling), stores the context
     the same shape T3 will read from sessionStorage (API-CONTRACT.md 6.1),
     and opens the person and occasion before gift choice. A failure of any
     kind — expired, revoked,
     unknown, or someone else's token, all of which the API answers with
     the same 404 LINK_INVALID — shows one neutral message with no details,
     never the server's own error text. */
  PageController.prototype.showLink = async function (token) {
    var measurement = currentReminderLinkMeasurement();
    this.show('loading');
    if (!token) return this.renderLinkInvalid();
    var result;
    try {
      result = await this.api.resolveLink(token);
      var contextInShop = result && /[?&]occ=([^&#]+)/.exec(result.shopUrl || '');
      var matchingContext = false;
      try { matchingContext = !!contextInShop && decodeURIComponent(contextInShop[1]) === result.ctx; } catch (_) {}
      if (!result || !result.name || !result.ctx || !isSafeHref(result.shopUrl) || !matchingContext) {
        return this.renderLinkInvalid();
      }
    } catch (_) {
      return this.renderLinkInvalid();
    }
    this.storeContext(result);
    trackReminderLinkOpened('page', 'link', result && result.ctx, measurement);
    try {
      // The public token only grants a safe landing and shopping context.
      // Private picks and budgets are fetched on the owned person route.
      var me = await this.api.me();
      if (me.signedIn && result.occasionId) {
        var owned = await this.findOccasion(result.occasionId);
        if (owned) {
          root.location.replace(pageUrl(this.basePath, 'person', owned.id));
          return;
        }
        return this.renderLinkReady(result, 'This reminder belongs to another account. You can still browse gifts for ' + result.name + '.', false);
      }
      this.renderLinkReady(result, 'Sign in to see your personalised picks for ' + result.name + '.', true);
    } catch (_) {
      this.renderLinkReady(result, 'Personalised picks are temporarily unavailable. You can still browse gifts for ' + result.name + '.', true);
    }
  };

  PageController.prototype.renderLinkReady = function (result, message, offerSignIn) {
    this.page.querySelector('[data-reminders-link-status]').textContent = message;
    var signIn = this.page.querySelector('[data-reminders-link-sign-in]');
    if (signIn) signIn.hidden = !offerSignIn;
    var browse = this.page.querySelector('[data-reminders-link-browse]');
    if (browse) { browse.href = result.shopUrl; browse.hidden = false; }
    this.show('link');
  };

  PageController.prototype.renderLinkInvalid = function () {
    if (readContext()) {
      clearContext();
      writeCartAttribute('');
    }
    var page = this.page;
    page.querySelector('[data-reminders-link-status]').textContent = page.dataset.linkInvalid;
    var signIn = page.querySelector('[data-reminders-link-sign-in]');
    if (signIn) signIn.hidden = false;
    var browse = page.querySelector('[data-reminders-link-browse]');
    if (browse) browse.hidden = true;
    this.show('link');
  };

  PageController.prototype.storeContext = function (result) {
    try {
      var store = root.sessionStorage;
      if (!store || !result) return;
      var expiresAt = null;
      if (result.date) {
        var parts = String(result.date).split('-');
        var year = Number(parts[0]);
        var month = Number(parts[1]);
        var day = Number(parts[2]);
        if (year && month && day) expiresAt = Date.UTC(year, month - 1, day + 7);
      }
      store.setItem('fb_rem_ctx', JSON.stringify({
        ctx: result.ctx,
        name: result.name,
        type: result.type,
        label: result.label || null,
        date: result.date,
        shopUrl: result.shopUrl,
        expiresAt: expiresAt
      }));
      trackReminderEvent('occasion_context_attached', 'page', 'link', result.ctx ? { ctx: result.ctx } : null);
    } catch (_) {}
  };

  /* ============================================================
   * Logged-out pre-seed landing (?reminder_view=preseed).
   * The bearer never travels in a URL. layout/theme.liquid renders
   * snippets/fb-reminders-preseed-privacy.liquid before PostHog, and
   * that script parks a valid token in sessionStorage. Calls below
   * send it only as X-FB-Preseed-Token.
   * ============================================================ */

  var PRESEED_TOKEN_KEY = 'fb_preseed_token';
  var PRESEED_UNSUB_KEY = 'fb_preseed_unsub';
  var PRESEED_UNLOCKED_HEADING = "3 saved. You're set.";
  var PRESEED_UNLOCKED_COPY = "You're set. We'll remind you two weeks before each birthday, a week before, and the day before. Every year. Your 20% code is on its way. It arrives with the next birthday reminder we send you. The email shows its expiry date.";
  var PRESEED_UNLOCKED_SET_COPY = "You're set. We'll remind you two weeks before each birthday, a week before, and the day before. Every year. Your 20% code is on its way. It arrives with the next birthday reminder we send you. The email shows its expiry date.";
  var PRESEED_MOCK_SCENES = { '1': 'ok', ok: 'ok', expired: 'expired', unlocked: 'unlocked', otp: 'otp', unsub: 'unsub' };

  function readPreseedToken() {
    try {
      var store = root.sessionStorage;
      var token = store && store.getItem(PRESEED_TOKEN_KEY);
      return root.FBRemindersAPI && root.FBRemindersAPI.validPreseedToken(token) ? token : '';
    } catch (e) { return ''; }
  }

  function clearPreseedToken() {
    try {
      if (root.sessionStorage) root.sessionStorage.removeItem(PRESEED_TOKEN_KEY);
    } catch (e) {}
  }

  function readPreseedUnsub() {
    try {
      var store = root.sessionStorage;
      var credential = store && store.getItem(PRESEED_UNSUB_KEY);
      return root.FBRemindersAPI && root.FBRemindersAPI.validPreseedToken(credential) ? credential : '';
    } catch (e) { return ''; }
  }

  function clearPreseedUnsub() {
    try {
      if (root.sessionStorage) root.sessionStorage.removeItem(PRESEED_UNSUB_KEY);
    } catch (e) {}
  }

  function preseedMockScene(page) {
    if (!page || page.dataset.preseedMockAllowed !== '1') return null;
    var raw = '';
    try {
      var params = parseParams((root.location && root.location.search) || '');
      raw = params.preseed_mock || '';
      if (!raw && root.sessionStorage) raw = root.sessionStorage.getItem('fb_preseed_mock') || '';
    } catch (e) { raw = ''; }
    if (!raw && page.dataset.preseedMockSetting === '1') raw = '1';
    if (!raw || raw === '0') return null;
    return PRESEED_MOCK_SCENES[raw] || 'ok';
  }

  function preseedProgressText(saved, page) {
    var key = saved >= 3 ? 'progress_three' : saved === 2 ? 'progress_two' : saved === 1 ? 'progress_one' : 'progress';
    var defaults = {"progress": "Save three birthdays and we'll send you 20% off your next order.", "progress_one": "1 of 3 saved. Two more and we'll send you 20% off your next order.", "progress_two": "2 of 3 saved. One more for 20% off.", "progress_three": "3 saved. You're set."};
    var dataKey = 'preseedCopy' + key.replace(/(^|_)([a-z])/g, function (_, prefix, letter) { return letter.toUpperCase(); });
    return preseedCopy(page, dataKey === 'preseedCopyProgress' ? 'preseedCopyProgressTemplate' : dataKey, defaults[key]);
  }

  function preseedClone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function preseedFixture(scene) {
    if (scene === 'expired') {
      return {
        state: 'expired',
        people: [],
        birthdaysSaved: 0,
        threshold: 3,
        unlocked: false,
        linkExpiryDate: null,
        maskedEmail: null
      };
    }
    var payload = {
      state: 'ok',
      people: [
        { id: 'ps_ava', firstName: 'Ava', month: 3 },
        { id: 'ps_noah', firstName: 'Noah', month: 11 }
      ],
      birthdaysSaved: 0,
      threshold: 3,
      unlocked: false,
      linkExpiryDate: '1 December 2026',
      maskedEmail: 'a\u2022\u2022\u2022@example.com'
    };
    if (scene === 'unlocked') {
      payload.people.push({ id: 'ps_mia', firstName: 'Mia', month: 6 });
      payload.birthdaysSaved = 3;
      payload.unlocked = true;
    }
    return payload;
  }

  function preseedMonthOptions(page) {
    var fallback = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(function (label, index) {
      return { value: String(index + 1), label: label };
    });
    var node = page && page.querySelector && page.querySelector('[data-preseed-months]');
    if (!node || !node.textContent) return fallback;
    try {
      var parsed = JSON.parse(node.textContent);
      if (!Array.isArray(parsed) || !parsed.length) return fallback;
      var months = parsed.filter(function (item) {
        return item && /^(?:[1-9]|1[0-2])$/.test(String(item.value)) && typeof item.label === 'string';
      }).map(function (item) {
        return { value: String(item.value), label: item.label.slice(0, 24) };
      });
      return months.length ? months : fallback;
    } catch (e) { return fallback; }
  }

  function preseedNormalisePerson(person) {
    var month = Number(person && person.month);
    return {
      id: person && typeof person.id === 'string' ? person.id.slice(0, 64) : '',
      firstName: person && typeof person.firstName === 'string' ? person.firstName.slice(0, 40) : '',
      month: month >= 1 && month <= 12 ? String(month) : '',
      local: !!(person && person.local)
    };
  }

  function preseedCopy(page, key, fallback) {
    return (page && page.dataset && page.dataset[key]) || fallback;
  }

  /* Held suggestions already have a name and month. Confirm can only send
     the day, so that is the only field those rows can fail. A local draft
     still needs all three. */
  function preseedProblem(data, page, mode) {
    var nameRequired = preseedCopy(page, 'preseedCopyNameRequired', 'Add a first name to save this birthday.');
    var monthRequired = preseedCopy(page, 'preseedCopyMonthRequired', 'Choose a month to save this birthday.');
    var dayRequired = preseedCopy(page, 'preseedCopyDayRequired', "That date doesn't exist. Check the day and month.");
    if (mode !== 'held') {
      if (!data || !data.firstName || data.firstName.length > 40) return { field: 'name', message: nameRequired };
      if (!/^(?:[1-9]|1[0-2])$/.test(String(data.month || ''))) return { field: 'month', message: monthRequired };
    }
    if (!data || !validDate(data.month, Number(data.day))) return { field: 'day', message: dayRequired };
    return null;
  }

  function preseedMonthLabel(month, months) {
    var value = String(month || '');
    for (var i = 0; i < months.length; i++) {
      if (String(months[i].value) === value) return months[i].label;
    }
    return value;
  }

  function publicPreseed(state) {
    var copy = preseedClone(state);
    (copy.people || []).forEach(function (person) { delete person.day; });
    return copy;
  }

  function preseedLinkDead(error) {
    if (!error) return false;
    if (error.code === 'PRESEED_TOKEN_INVALID' || error.code === 'LINK_INVALID' || error.code === 'UNAUTHENTICATED' || error.code === 'NOT_FOUND') return true;
    return error.status === 401 || error.status === 404;
  }

  function focusPreseedNode(node) {
    if (!node) return;
    try {
      var tag = String(node.tagName || '').toUpperCase();
      var focusable = tag === 'INPUT' || tag === 'SELECT' || tag === 'BUTTON' || tag === 'A' || tag === 'TEXTAREA';
      if (!focusable && node.setAttribute && node.getAttribute && node.getAttribute('tabindex') == null) node.setAttribute('tabindex', '-1');
      if (typeof node.focus === 'function') node.focus();
    } catch (e) {}
  }

  function preseedDomId(prefix, person, index) {
    var safe = String((person && person.id) || index).replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64);
    return prefix + (safe || String(index));
  }

  PageController.prototype.handlePreseedClick = function (event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return false;
    /* Action hooks live on controls inside a preseed view. Copy sits on the
       page root under data-preseed-copy-*, so a lookup that walks out of the
       view would treat the root as the control. */
    var view = target.closest('[data-reminders-page-state]');
    var stateName = view && view.getAttribute ? (view.getAttribute('data-reminders-page-state') || '') : '';
    if (!view || view === this.page || stateName.indexOf('preseed') !== 0) return false;
    var within = function (selector) {
      var node = target.closest(selector);
      if (!node || node === view) return null;
      /* Elements expose parentElement, not .parent. A missing link stops the
         walk on the control itself and every action looks unmatched. */
      var current = node.parentElement;
      while (current) {
        if (current === view) return node;
        current = current.parentElement;
      }
      return null;
    };
    var row = within('[data-preseed-person]');
    if (within('[data-preseed-delete-all]')) { event.preventDefault(); this.show('preseed-delete'); return true; }
    if (within('[data-preseed-edit]')) { event.preventDefault(); this.editPreseedPerson(row); return true; }
    if (within('[data-preseed-confirm]')) { event.preventDefault(); return this.confirmPreseedPerson(row); }
    if (within('[data-preseed-remove]')) { event.preventDefault(); return this.askRemovePreseedPerson(row); }
    if (within('[data-preseed-remove-confirm]')) { event.preventDefault(); return this.confirmRemovePreseedPerson(); }
    if (within('[data-preseed-remove-keep]')) { event.preventDefault(); this.show('preseed'); this.preseedRemoveRow = null; return true; }
    if (within('[data-preseed-save-all]')) { event.preventDefault(); return this.saveAllPreseed(); }
    if (within('[data-preseed-add]')) { event.preventDefault(); this.addPreseedDraft(); return true; }
    if (within('[data-preseed-see-all]')) { event.preventDefault(); return this.requestPreseedOtp(); }
    if (within('[data-preseed-retry]')) { event.preventDefault(); return this.showPreseed(); }
    if (within('[data-preseed-delete-confirm]')) { event.preventDefault(); return this.submitPreseedDelete(event); }
    if (within('[data-preseed-unsubscribe-confirm]')) { event.preventDefault(); return this.submitPreseedUnsubscribe(event); }
    return false;
  };

  PageController.prototype.trackPreseed = function (name, extra) {
    var ids = null;
    if (extra && typeof extra.outcome === 'string' && /^(ok|expired|unlocked)$/.test(extra.outcome)) ids = { outcome: extra.outcome };
    trackReminderEvent(name, 'page', 'preseed', ids);
  };

  PageController.prototype.preseedReturnHref = function () {
    var href = (this.basePath || '/pages/reminders') + '?reminder_view=preseed';
    if (!this.preseedMock) return href;
    var raw = '';
    try {
      var params = parseParams((root.location && root.location.search) || '');
      raw = params.preseed_mock || (root.sessionStorage && root.sessionStorage.getItem('fb_preseed_mock')) || '';
    } catch (e) { raw = ''; }
    if (!raw) raw = '1';
    if (!PRESEED_MOCK_SCENES[raw]) raw = '1';
    return href + '&preseed_mock=' + encodeURIComponent(raw === 'ok' ? '1' : raw);
  };

  PageController.prototype.fillPreseedKeepLinks = function () {
    var href = this.preseedReturnHref();
    if (!this.page.querySelectorAll) return;
    this.page.querySelectorAll('[data-preseed-keep]').forEach(function (link) { link.href = href; });
  };

  PageController.prototype.showPreseedExpired = function () {
    /* An expired link must not keep its bearer. A valid response never
       reaches this screen, so a live token stays in sessionStorage. */
    clearPreseedToken();
    this.preseedToken = '';
    var status = this.page.querySelector('[data-preseed-expired-status]');
    var body = this.page.querySelector('[data-preseed-expired-body]');
    if (status) status.textContent = preseedCopy(this.page, 'preseedCopyExpiredHeading', 'This link has expired.');
    if (body) body.textContent = preseedCopy(this.page, 'preseedCopyExpiredBody', "Email service@figandbloom.com and we'll delete them.");
    this.show('preseed-expired');
    if (!this.preseedExpiredTracked) {
      this.preseedExpiredTracked = true;
      this.trackPreseed('preseed_viewed', { outcome: 'expired' });
    }
  };

  PageController.prototype.showPreseedInvalid = function () {
    var status = this.page.querySelector('[data-preseed-expired-status]');
    var body = this.page.querySelector('[data-preseed-expired-body]');
    if (status) status.textContent = preseedCopy(this.page, 'preseedCopyInvalidHeading', 'This link isn\u2019t valid.');
    if (body) body.textContent = preseedCopy(this.page, 'preseedCopyExpiredBody', "Email service@figandbloom.com and we'll delete them.");
    this.show('preseed-expired');
    if (!this.preseedExpiredTracked) {
      this.preseedExpiredTracked = true;
      this.trackPreseed('preseed_viewed', { outcome: 'expired' });
    }
  };

  PageController.prototype.showPreseed = async function (params) {
    params = params || parseParams((root.location && root.location.search) || '');
    this.preseedToken = readPreseedToken();
    this.preseedUnsub = readPreseedUnsub();
    this.preseedMock = preseedMockScene(this.page);
    this.preseedDrafts = [];
    this.preseedLocalSeq = 0;
    this.preseedSavedIds = {};
    this.preseedDays = {};
    this.preseedEditing = {};
    this.preseedFixture = null;
    if (this.preseedMock && this.preseedMock !== 'expired' && this.preseedMock !== 'otp') {
      this.preseedFixture = preseedClone(preseedFixture(this.preseedMock === 'unlocked' ? 'unlocked' : 'ok'));
    }
    this.fillPreseedKeepLinks();
    var action = params.preseed_action === 'delete' || params.preseed_action === 'unsubscribe' ? params.preseed_action : '';
    /* Unsubscribe accepts a known token after the link has expired or been
       revoked. Open the confirm screen with no GET, including when a GET
       would have been the expired state. */
    if (action === 'unsubscribe' || this.preseedMock === 'unsub') {
      this.show('preseed-unsubscribe');
      return;
    }
    if (this.preseedMock === 'expired' || (!this.preseedToken && !this.preseedMock)) {
      this.showPreseedExpired();
      return;
    }
    if (this.preseedMock === 'otp') {
      this.showPreseedOtp(preseedFixture('ok'));
      return;
    }
    /* Delete still needs a live link. Confirm only after GET says ok. */
    if (action === 'delete') {
      this.show('loading');
      try {
        var live = await this.preseedCall('get');
        if (!live || live.state === 'expired') { this.showPreseedExpired(); return; }
        this.show('preseed-delete');
      } catch (err) {
        if (preseedLinkDead(err)) { this.showPreseedExpired(); return; }
        this.show('preseed-delete');
        var deleteError = this.page.querySelector('[data-preseed-delete-error]');
        if (deleteError) deleteError.textContent = this.preseedErrorText(err);
      }
      return;
    }
    this.show('loading');
    try {
      var payload = await this.preseedCall('get');
      if (!payload || payload.state === 'expired') {
        this.showPreseedExpired();
        return;
      }
      this.renderPreseed(payload, { initial: true });
    } catch (e) {
      if (preseedLinkDead(e)) { this.showPreseedExpired(); return; }
      this.setPreseedLoadFailed(this.preseedErrorText(e));
    }
  };

  PageController.prototype.preseedCall = function (kind, body) {
    var self = this;
    if (this.preseedMock) {
      return new Promise(function (resolve, reject) {
        try { resolve(self.preseedMockCall(kind, body)); }
        catch (error) { reject(error); }
      });
    }
    var token = this.preseedToken;
    var api = this.api;
    if (!api) return Promise.reject(new Error('Reminders are unavailable right now'));
    if (kind === 'get') return api.getPreseed(token);
    if (kind === 'confirm') return api.preseedConfirm(token, body);
    if (kind === 'save-all') return api.preseedSaveAll(token, body);
    if (kind === 'add') return api.preseedAdd(token, body);
    if (kind === 'remove') return api.preseedRemove(token, body);
    if (kind === 'delete') return api.preseedDelete(token);
    if (kind === 'unsubscribe') return api.preseedUnsubscribe(token, this.preseedUnsub);
    if (kind === 'otp-request') return api.preseedOtpRequest(token);
    if (kind === 'otp-verify') return api.preseedOtpVerify(token, body);
    return Promise.reject(new Error('Reminders are unavailable right now'));
  };

  PageController.prototype.preseedMockCall = function (kind, body) {
    if (!this.preseedFixture) this.preseedFixture = preseedClone(preseedFixture('ok'));
    var state = this.preseedFixture;
    var threshold = Number(state.threshold) || 3;
    function bump() {
      state.birthdaysSaved = Math.min(threshold, (Number(state.birthdaysSaved) || 0) + 1);
      state.unlocked = state.birthdaysSaved >= threshold;
      state.state = 'ok';
    }
    function reject(status, code, field, message) {
      var error = new Error(message || 'Request failed');
      error.status = status;
      error.code = code;
      if (field) error.field = field;
      throw error;
    }
    if (kind === 'get') return publicPreseed(state);
    if (kind === 'otp-request') {
      if (state.state === 'expired') return { state: 'expired' };
      return { state: 'ok' };
    }
    if (kind === 'otp-verify') {
      var code = body && body.code;
      if (!/^\d{4,8}$/.test(String(code || ''))) reject(400, 'INVALID_INPUT', 'code', 'That code did not work. Please try again.');
      return { state: 'ok', signedIn: true };
    }
    if (kind === 'delete') {
      state.people = [];
      state.birthdaysSaved = 0;
      state.unlocked = false;
      state.state = 'ok';
      return publicPreseed(state);
    }
    if (kind === 'unsubscribe') {
      state.people = [];
      state.birthdaysSaved = 0;
      state.unlocked = false;
      state.state = 'expired';
      if (this.preseedMock === 'unsub' || this.preseedUnsub || this.preseedToken) return { state: 'unsubscribed' };
      return { state: 'expired' };
    }
    if (kind === 'remove') {
      var removedSaved = false;
      state.people = (state.people || []).filter(function (person) {
        if (person.id !== (body && body.id)) return true;
        removedSaved = person.day != null;
        return false;
      });
      if (removedSaved) state.birthdaysSaved = Math.max(0, (Number(state.birthdaysSaved) || 0) - 1);
      state.unlocked = state.birthdaysSaved >= threshold;
      state.state = 'ok';
      return publicPreseed(state);
    }
    if (kind === 'add') {
      var name = body && typeof body.name === 'string' ? body.name : '';
      if (!name || !validDate(body && body.month, Number(body && body.day))) {
        reject(400, name ? 'INVALID_DATE' : 'INVALID_INPUT', name ? 'day' : 'name', "That date doesn't exist. Check the day and month.");
      }
      state.people = state.people || [];
      state.people.push({
        id: 'ps_new_' + state.people.length,
        firstName: name,
        month: Number(body.month),
        day: Number(body.day)
      });
      bump();
      return publicPreseed(state);
    }
    if (kind === 'confirm') {
      var target = null;
      (state.people || []).forEach(function (person) {
        if (person.id === (body && body.id)) target = person;
      });
      if (!target) reject(404, 'NOT_FOUND', null, 'missing');
      if (!validDate(target.month, Number(body && body.day))) reject(400, 'INVALID_DATE', 'day', "That date doesn't exist. Check the day and month.");
      var already = target.day != null;
      target.day = Number(body.day);
      if (!already) bump();
      return publicPreseed(state);
    }
    if (kind === 'save-all') {
      var days = (body && body.days) || {};
      var people = state.people || [];
      for (var i = 0; i < people.length; i++) {
        if (!validDate(people[i].month, Number(days[people[i].id]))) {
          reject(400, 'INVALID_DATE', people[i].id, "That date doesn't exist. Check the day and month.");
        }
      }
      people.forEach(function (person) { person.day = Number(days[person.id]); });
      state.birthdaysSaved = people.length;
      state.unlocked = state.birthdaysSaved >= threshold;
      state.state = 'ok';
      return publicPreseed(state);
    }
    return publicPreseed(state);
  };

  PageController.prototype.renderPreseed = function (payload, options) {
    options = options || {};
    payload = payload || {};
    var saved = Number(payload.birthdaysSaved);
    if (!isFinite(saved) || saved < 0) saved = 0;
    var threshold = Number(payload.threshold);
    if (!isFinite(threshold) || threshold < 1) threshold = 3;
    var people = Array.isArray(payload.people) ? payload.people.slice(0, 20).map(preseedNormalisePerson) : [];
    var alive = {};
    people.forEach(function (person) { if (person.id) alive[person.id] = true; });
    var savedIds = this.preseedSavedIds || (this.preseedSavedIds = {});
    Object.keys(savedIds).forEach(function (id) { if (!alive[id]) delete savedIds[id]; });
    if (people.length && saved >= people.length) {
      people.forEach(function (person) { if (person.id) savedIds[person.id] = true; });
    }
    this.preseedPayload = {
      state: 'ok',
      people: people,
      birthdaysSaved: saved,
      threshold: threshold,
      unlocked: payload.unlocked === true || saved >= threshold,
      linkExpiryDate: typeof payload.linkExpiryDate === 'string' ? payload.linkExpiryDate : '',
      maskedEmail: typeof payload.maskedEmail === 'string' ? payload.maskedEmail : ''
    };
    var view = this.page.querySelector('[data-reminders-page-state="preseed"]');
    if (!view || view.hidden) this.show('preseed');
    var model = this.preseedPayload;
    var heading = this.page.querySelector('[data-preseed-heading]');
    var headingKey = people.length >= 3 ? 'preseedCopyHeading' : people.length === 2 ? 'preseedCopyHeadingTwo' : people.length === 1 ? 'preseedCopyHeadingOne' : 'preseedCopyEmptyHeading';
    if (people.length > 0 && people.length < 3 && people.slice(0, 2).some(function (person) { return !person.firstName.trim(); })) headingKey = 'preseedCopyHeadingFallback';
    var headingDefaults = {"preseedCopyHeading": "We've already found them", "preseedCopyHeadingOne": "We've found __NAME_1__. Who else?", "preseedCopyHeadingTwo": "We've found __NAME_1__ and __NAME_2__", "preseedCopyHeadingFallback": "Confirm these birthdays", "preseedCopyEmptyHeading": "Nothing left to check"};
    if (heading) heading.textContent = preseedCopy(this.page, headingKey, headingDefaults[headingKey])
      .replace(/__NAME_([12])__/g, function (_, index) { return people[Number(index) - 1].firstName; });
    var empty = this.page.querySelector('[data-preseed-empty]');
    if (empty) empty.hidden = people.length > 0;
    var terms = this.page.querySelector('[data-preseed-terms]');
    var termsWrap = this.page.querySelector('[data-preseed-terms-wrap]');
    var termsText = [1, 2, 3, 4].map(function (part) {
      return preseedCopy(this.page, 'preseedCopyTerms-' + part, '');
    }, this).join(' ');
    if (terms) terms.textContent = termsText.replace(/__LINK_EXPIRY_DATE__/g, function () { return model.linkExpiryDate; });
    if (termsWrap) termsWrap.hidden = !model.linkExpiryDate;
    var progress = this.page.querySelector('[data-preseed-progress]');
    if (progress) progress.textContent = preseedProgressText(model.birthdaysSaved, this.page);
    this.preseedLoadFailed = false;
    this.syncPreseedLoadChrome(false);
    var next = this.page.querySelector('[data-preseed-next]');
    if (next) next.hidden = !(model.birthdaysSaved > 0);
    if (options.clearError !== false) {
      var error = this.page.querySelector('[data-preseed-error]');
      if (error) error.textContent = '';
    }
    this.paintPreseedPeople();
    if (options.initial) this.trackPreseed('preseed_viewed', { outcome: model.unlocked ? 'unlocked' : 'ok' });
    if (options.focus) focusPreseedNode(options.focus);
  };

  PageController.prototype.preseedNothingLeftToAdd = function () {
    if ((this.preseedDrafts || []).length) return false;
    var people = (this.preseedPayload && this.preseedPayload.people) || [];
    if (!people.length) return false;
    for (var i = 0; i < people.length; i++) {
      var id = people[i] && people[i].id;
      if (!id || !this.preseedSavedIds || !this.preseedSavedIds[id]) return false;
    }
    return true;
  };

  PageController.prototype.syncPreseedUnlocked = function () {
    var unlocked = this.page.querySelector('[data-preseed-unlocked]');
    var model = this.preseedPayload;
    var reachedThree = model && model.birthdaysSaved >= 3;
    var intro = this.page.querySelector('[data-preseed-intro]');
    if (intro && !this.preseedLoadFailed) intro.hidden = !!(reachedThree && this.preseedNothingLeftToAdd());
    if (!unlocked) return;
    if (!model || model.birthdaysSaved < 1) {
      unlocked.hidden = true;
      return;
    }
    unlocked.hidden = false;
    var heading = unlocked.querySelector('[data-preseed-unlocked-heading]');
    var body = unlocked.querySelector('[data-preseed-unlocked-body]');
    var headingText = reachedThree ? preseedCopy(this.page, 'preseedCopyUnlockedHeading', PRESEED_UNLOCKED_HEADING) : '';
    var bodyText = !reachedThree ? preseedCopy(this.page, 'preseedCopySuccessUnderThree', "Saved. We'll remind you two weeks before each birthday, a week before, and the day before. Every year. Save three birthdays and we'll send you 20% off your next order.") : this.preseedNothingLeftToAdd()
      ? preseedCopy(this.page, 'preseedCopyUnlockedSet', PRESEED_UNLOCKED_SET_COPY)
      : preseedCopy(this.page, 'preseedCopyUnlocked', PRESEED_UNLOCKED_COPY).replace(/\{n\}/g, String(model.birthdaysSaved));
    if (heading) { heading.textContent = headingText; heading.hidden = !headingText; }
    if (body) body.textContent = bodyText;
  };

  PageController.prototype.syncPreseedLoadChrome = function (failed) {
    var self = this;
    ['[data-preseed-intro]', '[data-preseed-progress]', '[data-preseed-people]', '[data-preseed-actions]', '[data-preseed-next]'].forEach(function (selector) {
      var node = self.page.querySelector(selector);
      if (node) node.hidden = !!failed;
    });
    if (failed) {
      var unlocked = this.page.querySelector('[data-preseed-unlocked]');
      if (unlocked) unlocked.hidden = true;
    }
    var retry = this.page.querySelector('[data-preseed-retry]');
    if (retry) retry.hidden = !failed;
  };

  PageController.prototype.setPreseedLoadFailed = function (message) {
    this.preseedLoadFailed = true;
    this.show('preseed');
    this.setPreseedError(message);
    this.syncPreseedLoadChrome(true);
  };

  PageController.prototype.paintPreseedPeople = function () {
    this.syncPreseedUnlocked();
    var list = this.page.querySelector('[data-preseed-people]');
    if (!list || !root.document || typeof root.document.createElement !== 'function') return;
    while (list.firstChild) list.removeChild(list.firstChild);
    var months = preseedMonthOptions(this.page);
    var people = (this.preseedPayload && this.preseedPayload.people || []).concat(this.preseedDrafts || []);
    var self = this;
    people.forEach(function (person, index) {
      list.appendChild(self.preseedPersonNode(person, index, months));
    });
    this.syncPreseedSaveAll();
  };

  PageController.prototype.preseedPersonNode = function (person, index, months) {
    var doc = root.document;
    var item = doc.createElement('li');
    item.className = 'fb-preseed-person';
    item.setAttribute('data-preseed-person', '');
    item.setAttribute('data-preseed-id', person.id || '');
    if (person.local) item.setAttribute('data-preseed-local', '1');
    if (!person.local && person.month) item.setAttribute('data-preseed-month-value', String(person.month));
    var saved = this.preseedRowSaved(person);
    var held = !person.local && !!person.id;
    var fieldset = doc.createElement('fieldset');
    var legend = doc.createElement('legend');
    legend.className = 'visually-hidden';
    legend.textContent = String(this.page.dataset.preseedCopyRowLabel || 'Birthday __N__').replace(/__N__/g, String(index + 1));
    fieldset.appendChild(legend);
    var grid = doc.createElement('div');
    grid.className = 'fb-preseed-person__grid';
    var nameLabel = this.page.dataset.preseedCopyFirstName || 'First name';
    var monthLabel = this.page.dataset.preseedCopyMonth || 'Month';
    var dayLabel = this.page.dataset.preseedCopyDay || 'Day';
    var nameId = preseedDomId('fb-preseed-name-', person, index);
    var monthId = preseedDomId('fb-preseed-month-', person, index);
    var dayId = preseedDomId('fb-preseed-day-', person, index);
    if (saved || held) {
      grid.appendChild(this.preseedTextField(nameLabel, person.firstName || '', 'data-preseed-name-text'));
      grid.appendChild(this.preseedTextField(monthLabel, preseedMonthLabel(person.month, months), 'data-preseed-month-text'));
      if (saved && this.preseedDays && this.preseedDays[person.id] != null && this.preseedDays[person.id] !== '') {
        grid.appendChild(this.preseedTextField(dayLabel, String(this.preseedDays[person.id]), 'data-preseed-day-text'));
      } else if (!saved) {
        grid.appendChild(this.preseedField(dayId, dayLabel, this.preseedDayInput(dayId, person)));
      }
    } else {
      grid.appendChild(this.preseedField(nameId, nameLabel, this.preseedNameInput(nameId, person)));
      grid.appendChild(this.preseedField(monthId, monthLabel, this.preseedMonthSelect(monthId, person, months)));
      grid.appendChild(this.preseedField(dayId, dayLabel, this.preseedDayInput(dayId, person)));
    }
    fieldset.appendChild(grid);
    var actions = doc.createElement('div');
    actions.className = 'fb-preseed-person__actions';
    if (saved) {
      var status = doc.createElement('p');
      status.className = 'fb-preseed-saved';
      status.setAttribute('data-preseed-row-status', '');
      status.textContent = this.page.dataset.preseedCopySaved || 'Saved';
      actions.appendChild(status);
      actions.appendChild(this.preseedButton('fb-reminders-text-action', this.page.dataset.preseedCopyEdit || 'Edit', 'data-preseed-edit'));
    } else {
      actions.appendChild(this.preseedButton('button', this.page.dataset.preseedCopyConfirm || 'Confirm', 'data-preseed-confirm'));
      actions.appendChild(this.preseedButton('button button--secondary', this.page.dataset.preseedCopyRemove || 'Remove', 'data-preseed-remove'));
    }
    fieldset.appendChild(actions);
    var rowError = doc.createElement('p');
    rowError.className = 'fb-reminders-error';
    rowError.setAttribute('data-preseed-row-error', '');
    rowError.setAttribute('aria-live', 'polite');
    fieldset.appendChild(rowError);
    item.appendChild(fieldset);
    return item;
  };

  PageController.prototype.preseedField = function (id, labelText, control) {
    var wrap = root.document.createElement('div');
    wrap.className = 'fb-reminders-field';
    var label = root.document.createElement('label');
    label.setAttribute('for', id);
    label.textContent = labelText;
    control.id = id;
    wrap.appendChild(label);
    wrap.appendChild(control);
    return wrap;
  };

  PageController.prototype.preseedTextField = function (labelText, value, attr) {
    var wrap = root.document.createElement('div');
    wrap.className = 'fb-reminders-field';
    var label = root.document.createElement('span');
    label.className = 'fb-preseed-label';
    label.textContent = labelText;
    var text = root.document.createElement('span');
    text.className = 'fb-preseed-value';
    text.setAttribute(attr, '');
    text.textContent = value || '';
    wrap.appendChild(label);
    wrap.appendChild(text);
    return wrap;
  };

  PageController.prototype.preseedDayInput = function (id, person) {
    var input = root.document.createElement('input');
    input.id = id;
    input.className = 'field__input';
    input.type = 'text';
    input.setAttribute('data-preseed-day', '');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '2');
    input.setAttribute('autocomplete', 'off');
    var value = '';
    if (person.local && person.day) value = String(person.day);
    else if (person.id && this.preseedDays && this.preseedDays[person.id] != null && this.preseedDays[person.id] !== '') value = String(this.preseedDays[person.id]);
    input.value = value;
    var self = this;
    input.addEventListener('input', function () { self.onPreseedDayInput(input); });
    return input;
  };

  PageController.prototype.onPreseedDayInput = function (input) {
    if (!input || typeof input.closest !== 'function') return;
    var row = input.closest('[data-preseed-person]');
    if (!row) return;
    var data = this.readPreseedRow(row);
    if (!data || !validDate(data.month, Number(data.day))) return;
    this.setPreseedRowError(row, '', '');
  };

  PageController.prototype.preseedNameInput = function (id, person) {
    var input = root.document.createElement('input');
    input.id = id;
    input.className = 'field__input';
    input.type = 'text';
    input.setAttribute('data-preseed-name', '');
    input.setAttribute('maxlength', '40');
    input.setAttribute('autocomplete', 'off');
    input.value = person.firstName || '';
    return input;
  };

  PageController.prototype.preseedMonthSelect = function (id, person, months) {
    var select = root.document.createElement('select');
    select.id = id;
    select.className = 'select__select';
    select.setAttribute('data-preseed-month', '');
    var placeholder = root.document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = this.page.dataset.preseedCopyChooseMonth || 'Choose a month';
    select.appendChild(placeholder);
    months.forEach(function (month) {
      var option = root.document.createElement('option');
      option.value = month.value;
      option.textContent = month.label;
      if (String(person.month) === String(month.value)) option.selected = true;
      select.appendChild(option);
    });
    if (person.month) select.value = String(person.month);
    return select;
  };

  PageController.prototype.preseedButton = function (className, text, attr) {
    var button = root.document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute(attr, '');
    button.textContent = text;
    return button;
  };

  PageController.prototype.readPreseedRow = function (row) {
    if (!row || !row.querySelector) return null;
    var id = row.getAttribute('data-preseed-id') || '';
    var name = row.querySelector('[data-preseed-name]');
    var nameText = row.querySelector('[data-preseed-name-text]');
    var month = row.querySelector('[data-preseed-month]');
    var day = row.querySelector('[data-preseed-day]');
    var dayValue = '';
    if (day) dayValue = String(day.value || '').trim();
    else if (this.preseedDays && this.preseedDays[id] != null) dayValue = String(this.preseedDays[id]);
    return {
      id: id,
      local: row.getAttribute('data-preseed-local') === '1',
      firstName: name ? String(name.value || '').trim() : (nameText ? String(nameText.textContent || '').trim() : ''),
      month: month ? String(month.value || '') : (row.getAttribute('data-preseed-month-value') || ''),
      day: dayValue
    };
  };

  PageController.prototype.findPreseedRow = function (id) {
    var rows = this.page.querySelectorAll ? this.page.querySelectorAll('[data-preseed-person]') : [];
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-preseed-id') === id) return rows[i];
    }
    return null;
  };

  PageController.prototype.setPreseedRowError = function (row, field, message) {
    if (!row) return;
    var slot = row.querySelector('[data-preseed-row-error]');
    if (slot) slot.textContent = message || '';
    ['name', 'month', 'day'].forEach(function (name) {
      var node = row.querySelector('[data-preseed-' + name + ']');
      if (node && node.removeAttribute) node.removeAttribute('aria-invalid');
    });
    if (!message) return;
    var target = field && row.querySelector('[data-preseed-' + field + ']');
    if (target && target.setAttribute) target.setAttribute('aria-invalid', 'true');
    focusPreseedNode(target || slot);
  };

  PageController.prototype.setPreseedError = function (message) {
    var node = this.page.querySelector('[data-preseed-error]');
    if (node) node.textContent = message || '';
    if (message) focusPreseedNode(node);
  };

  PageController.prototype.setPreseedBusy = function (on) {
    var view = this.page.querySelector('[data-reminders-page-state="preseed"]');
    if (view && view.setAttribute) view.setAttribute('aria-busy', on ? 'true' : 'false');
    if (!this.page.querySelectorAll) return;
    this.page.querySelectorAll('[data-preseed-confirm], [data-preseed-remove], [data-preseed-edit], [data-preseed-save-all], [data-preseed-add], [data-preseed-see-all], [data-preseed-delete-confirm], [data-preseed-remove-confirm], [data-preseed-remove-keep], [data-preseed-unsubscribe-confirm], [data-preseed-otp-submit]').forEach(function (button) {
      button.disabled = !!on;
    });
  };

  PageController.prototype.notePreseedSaved = function (id) {
    if (!id) return;
    if (!this.preseedSavedIds) this.preseedSavedIds = {};
    this.preseedSavedIds[id] = true;
  };

  PageController.prototype.preseedRetryMessage = function () {
    return this.page.dataset.preseedCopyRetry || 'That did not work. Please try again.';
  };

  PageController.prototype.preseedErrorText = function (error) {
    if (error && error.code === 'RATE_LIMITED' && error.retryInSeconds) {
      return preseedCopy(this.page, 'preseedCopyRateLimit', 'Please wait __SECONDS__ seconds and try again.').replace(/__SECONDS__/g, String(error.retryInSeconds));
    }
    if (error && (error.code === 'FORBIDDEN_ORIGIN' || error.code === 'INTERNAL' || error.status === 503)) {
      return preseedCopy(this.page, 'preseedCopyUnavailable', '') || this.page.dataset.unavailable || 'Reminders are unavailable right now';
    }
    if (error && (error.code === 'INVALID_DATE' || error.code === 'INVALID_INPUT') && error.message && error.message !== 'Request failed') return error.message;
    return this.preseedRetryMessage();
  };

  PageController.prototype.preseedFieldRow = function (field) {
    if (typeof field !== 'string' || !field) return null;
    var id = field.indexOf('days.') === 0 ? field.slice(5) : field;
    if (id === 'day' || id === 'name' || id === 'month' || id === 'code') return null;
    return this.findPreseedRow(id);
  };

  PageController.prototype.showPreseedFailure = function (error, row) {
    if (preseedLinkDead(error)) { this.showPreseedExpired(); return; }
    var text = this.preseedErrorText(error);
    var field = error && typeof error.field === 'string' ? error.field : '';
    var control = (field === 'name' || field === 'month' || field === 'day') ? field : 'day';
    var target = this.preseedFieldRow(field) || row;
    var inline = error && (error.code === 'INVALID_DATE' || error.code === 'INVALID_INPUT' || error.code === 'RATE_LIMITED' || error.status === 0);
    if (inline && target) { this.setPreseedRowError(target, control, text); return; }
    this.setPreseedError(text);
  };

  PageController.prototype.preseedRowSaved = function (person) {
    if (!person || person.local || !person.id) return false;
    if (!this.preseedSavedIds || !this.preseedSavedIds[person.id]) return false;
    if (this.preseedEditing && this.preseedEditing[person.id]) return false;
    return true;
  };

  PageController.prototype.preseedPendingCount = function () {
    var pending = (this.preseedDrafts || []).length;
    var people = (this.preseedPayload && this.preseedPayload.people) || [];
    for (var i = 0; i < people.length; i++) {
      if (!this.preseedRowSaved(people[i])) pending += 1;
    }
    return pending;
  };

  PageController.prototype.syncPreseedSaveAll = function () {
    var button = this.page.querySelector('[data-preseed-save-all]');
    if (button) {
      var count = this.preseedPendingCount();
      button.hidden = count === 0;
      var key = count === 1 ? 'preseedCopySaveOne' : count === 2 ? 'preseedCopySaveTwo' : 'preseedCopySaveAll';
      var fallback = count === 1 ? 'Save 1 person' : count === 2 ? 'Save 2 people' : 'Save all __COUNT__';
      button.textContent = preseedCopy(this.page, key, fallback).replace(/__COUNT__/g, String(count));
    }
  };

  PageController.prototype.editPreseedPerson = function (row) {
    if (this.preseedBusy || !row) return;
    var id = row.getAttribute('data-preseed-id') || '';
    if (!id) return;
    if (!this.preseedEditing) this.preseedEditing = {};
    this.preseedEditing[id] = true;
    this.paintPreseedPeople();
    var fresh = this.findPreseedRow(id);
    focusPreseedNode(fresh && fresh.querySelector('[data-preseed-day]'));
  };

  PageController.prototype.capturePreseedInputs = function () {
    var self = this;
    var rows = this.page.querySelectorAll ? this.page.querySelectorAll('[data-preseed-person]') : [];
    for (var i = 0; i < rows.length; i++) {
      var data = this.readPreseedRow(rows[i]);
      if (!data || !data.id) continue;
      if (data.local) {
        (this.preseedDrafts || []).forEach(function (draft) {
          if (draft.id !== data.id) return;
          draft.firstName = data.firstName;
          draft.month = data.month;
          draft.day = data.day;
        });
      } else if (data.day) {
        if (!this.preseedDays) this.preseedDays = {};
        this.preseedDays[data.id] = data.day;
      }
    }
    return self;
  };

  PageController.prototype.confirmPreseedPerson = async function (row) {
    if (this.preseedBusy || !row) return;
    var data = this.readPreseedRow(row);
    var mode = data && data.local ? 'local' : 'held';
    var problem = preseedProblem(data, this.page, mode);
    if (problem) { this.setPreseedRowError(row, problem.field, problem.message); return; }
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    var previous = {};
    ((this.preseedPayload && this.preseedPayload.people) || []).forEach(function (person) { previous[person.id] = true; });
    var self = this;
    try {
      var kind = 'add';
      var body = { name: data.firstName, month: Number(data.month), day: Number(data.day) };
      if (!data.local && data.id) { kind = 'confirm'; body = { id: data.id, day: Number(data.day) }; }
      var payload = await this.preseedCall(kind, body);
      if (data.local) this.preseedDrafts = (this.preseedDrafts || []).filter(function (draft) { return draft.id !== data.id; });
      if (payload && payload.state === 'expired') { this.showPreseedExpired(); return; }
      if (!this.preseedDays) this.preseedDays = {};
      if (kind === 'confirm') {
        this.preseedDays[data.id] = Number(data.day);
        this.notePreseedSaved(data.id);
        if (this.preseedEditing) delete this.preseedEditing[data.id];
      } else if (payload && Array.isArray(payload.people)) {
        payload.people.forEach(function (person) {
          if (!person || !person.id || previous[person.id]) return;
          self.notePreseedSaved(person.id);
          self.preseedDays[person.id] = Number(data.day);
        });
      }
      if (payload && Array.isArray(payload.people)) this.renderPreseed(payload);
      else await this.refreshPreseed();
      this.trackPreseed(kind === 'add' ? 'preseed_person_added' : 'preseed_person_confirmed');
    } catch (error) {
      this.showPreseedFailure(error, row);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };

  PageController.prototype.askRemovePreseedPerson = function (row) {
    if (this.preseedBusy || !row) return true;
    var data = this.readPreseedRow(row);
    if (!data || data.local || !data.id) return this.removePreseedPerson(row);
    this.preseedRemoveRow = row;
    var heading = this.page.querySelector('[data-preseed-remove-heading]');
    var text = data.firstName ? preseedCopy(this.page, 'preseedCopyRemoveHeading', "Delete __FIRST_NAME__'s suggestion?") : preseedCopy(this.page, 'preseedCopyRemoveHeadingBlank', 'Delete this suggestion?');
    if (heading) heading.textContent = text.replace(/__FIRST_NAME__/g, function () { return data.firstName; });
    this.show('preseed-remove');
    return true;
  };

  PageController.prototype.confirmRemovePreseedPerson = async function () {
    if (this.preseedBusy || !this.preseedRemoveRow) return;
    var row = this.preseedRemoveRow;
    this.show('preseed');
    await this.removePreseedPerson(row);
    this.preseedRemoveRow = null;
  };

  PageController.prototype.removePreseedPerson = async function (row) {
    if (this.preseedBusy || !row) return;
    var data = this.readPreseedRow(row);
    if (!data) return;
    if (data.local || !data.id) {
      this.preseedDrafts = (this.preseedDrafts || []).filter(function (draft) { return draft.id !== data.id; });
      this.paintPreseedPeople();
      focusPreseedNode(this.page.querySelector('[data-preseed-add]'));
      return;
    }
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    try {
      var payload = await this.preseedCall('remove', { id: data.id });
      if (payload && payload.state === 'expired') { this.showPreseedExpired(); return; }
      if (this.preseedDays) delete this.preseedDays[data.id];
      if (this.preseedSavedIds) delete this.preseedSavedIds[data.id];
      if (this.preseedEditing) delete this.preseedEditing[data.id];
      if (payload && Array.isArray(payload.people)) this.renderPreseed(payload);
      else await this.refreshPreseed();
      var done = this.page.querySelector('[data-preseed-remove-done]');
      var text = data.firstName ? preseedCopy(this.page, 'preseedCopyRemoveDone', "Done. We've deleted __FIRST_NAME__'s suggestion.") : preseedCopy(this.page, 'preseedCopyRemoveDoneBlank', "Done. We've deleted this suggestion.");
      if (done) done.textContent = text.replace(/__FIRST_NAME__/g, function () { return data.firstName; });
      this.trackPreseed('preseed_person_removed');
      focusPreseedNode(this.page.querySelector('[data-preseed-progress]'));
    } catch (error) {
      this.showPreseedFailure(error, row);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };

  PageController.prototype.addPreseedDraft = function () {
    if (this.preseedBusy) return;
    this.preseedLocalSeq = (this.preseedLocalSeq || 0) + 1;
    var draft = { id: 'local-' + this.preseedLocalSeq, firstName: '', month: '', local: true };
    this.preseedDrafts = this.preseedDrafts || [];
    this.preseedDrafts.push(draft);
    this.paintPreseedPeople();
    var row = this.page.querySelector('[data-preseed-id="' + draft.id + '"]');
    focusPreseedNode(row && row.querySelector('[data-preseed-name]'));
  };

  PageController.prototype.saveAllPreseed = async function () {
    if (this.preseedBusy) return;
    var rows = this.page.querySelectorAll ? this.page.querySelectorAll('[data-preseed-person]') : [];
    var held = [];
    var drafts = [];
    var self = this;
    for (var i = 0; i < rows.length; i++) {
      var data = this.readPreseedRow(rows[i]);
      if (!data) continue;
      var problem = preseedProblem(data, this.page, data.local ? 'local' : 'held');
      if (problem) {
        if (!rows[i].querySelector('[data-preseed-' + problem.field + ']')) {
          this.capturePreseedInputs();
          if (!this.preseedEditing) this.preseedEditing = {};
          this.preseedEditing[data.id] = true;
          this.paintPreseedPeople();
          this.setPreseedRowError(this.findPreseedRow(data.id) || rows[i], problem.field, problem.message);
          return;
        }
        this.setPreseedRowError(rows[i], problem.field, problem.message);
        return;
      }
      if (data.local) drafts.push(data);
      else held.push(data);
    }
    if (!held.length && !drafts.length) { this.syncPreseedSaveAll(); return; }
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    try {
      var payload = null;
      if (held.length) {
        var days = {};
        held.forEach(function (person) { days[person.id] = Number(person.day); });
        payload = await this.preseedCall('save-all', { days: days });
        if (payload && payload.state === 'expired') { this.showPreseedExpired(); return; }
        if (!this.preseedDays) this.preseedDays = {};
        held.forEach(function (person) {
          self.preseedDays[person.id] = Number(person.day);
          self.notePreseedSaved(person.id);
        });
        if (payload && Array.isArray(payload.people)) this.renderPreseed(payload);
      }
      for (var d = 0; d < drafts.length; d++) {
        var draft = drafts[d];
        var previous = {};
        ((payload && payload.people) || (this.preseedPayload && this.preseedPayload.people) || []).forEach(function (person) {
          if (person && person.id) previous[person.id] = true;
        });
        payload = await this.preseedCall('add', { name: draft.firstName, month: Number(draft.month), day: Number(draft.day) });
        if (payload && payload.state === 'expired') { this.showPreseedExpired(); return; }
        if (payload && Array.isArray(payload.people)) {
          payload.people.forEach(function (person) {
            if (!person || !person.id || previous[person.id]) return;
            self.notePreseedSaved(person.id);
            if (!self.preseedDays) self.preseedDays = {};
            self.preseedDays[person.id] = Number(draft.day);
          });
        }
      }
      this.preseedDrafts = [];
      this.preseedEditing = {};
      if (payload && Array.isArray(payload.people)) this.renderPreseed(payload);
      else await this.refreshPreseed();
      this.trackPreseed('preseed_saved_all');
    } catch (error) {
      this.showPreseedFailure(error, null);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };

  PageController.prototype.refreshPreseed = async function () {
    var payload = await this.preseedCall('get');
    if (!payload || payload.state === 'expired') { this.showPreseedExpired(); return; }
    this.renderPreseed(payload);
  };

  PageController.prototype.requestPreseedOtp = async function () {
    if (this.preseedBusy) return;
    this.preseedBusy = true;
    this.show('loading');
    try {
      var result = await this.preseedCall('otp-request');
      if (result && result.state === 'expired') { this.showPreseedExpired(); return; }
      var email = (this.preseedPayload && this.preseedPayload.maskedEmail) || '';
      this.showPreseedOtp({ maskedEmail: email });
      this.trackPreseed('preseed_otp_requested');
    } catch (error) {
      if (preseedLinkDead(error)) { this.showPreseedExpired(); return; }
      if (this.preseedPayload) this.renderPreseed(this.preseedPayload, { clearError: false });
      this.setPreseedError(this.preseedErrorText(error));
    } finally {
      this.preseedBusy = false;
    }
  };

  PageController.prototype.showPreseedOtp = function (payload) {
    var status = this.page.querySelector('[data-preseed-otp-status]');
    var email = payload && typeof payload.maskedEmail === 'string' ? payload.maskedEmail : '';
    var template = this.page.dataset.preseedCopyOtpSent || 'We sent a code to __EMAIL__.';
    var fallback = this.page.dataset.preseedCopyOtpSentFallback || 'We sent a code to your email.';
    if (status) status.textContent = email ? template.replace(/__EMAIL__/g, email) : fallback;
    var error = this.page.querySelector('[data-preseed-otp-error]');
    if (error) error.textContent = '';
    var input = this.page.querySelector('[data-preseed-code]');
    if (input) {
      input.value = '';
      if (input.removeAttribute) input.removeAttribute('aria-invalid');
    }
    this.show('preseed-otp');
    focusPreseedNode(input || status);
  };

  PageController.prototype.submitPreseedOtp = async function (event) {
    if (event && event.preventDefault) event.preventDefault();
    if (this.preseedBusy) return;
    var input = this.page.querySelector('[data-preseed-code]');
    var errorNode = this.page.querySelector('[data-preseed-otp-error]');
    var code = input ? String(input.value || '').replace(/\s+/g, '') : '';
    if (!/^\d{4,8}$/.test(code)) {
      if (errorNode) errorNode.textContent = this.page.dataset.preseedCopyOtpInvalid || 'That code did not work. Please try again.';
      if (input && input.setAttribute) input.setAttribute('aria-invalid', 'true');
      focusPreseedNode(input);
      return;
    }
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    try {
      await this.preseedCall('otp-verify', { code: code });
      clearPreseedToken();
      this.preseedToken = '';
      if (input) input.value = '';
      this.trackPreseed('preseed_otp_verified');
      if (this.api && typeof this.api.clearMe === 'function') this.api.clearMe();
      await this.showList();
    } catch (error) {
      if (preseedLinkDead(error)) { this.showPreseedExpired(); return; }
      var invalid = this.page.dataset.preseedCopyOtpInvalid || 'That code did not work. Please try again.';
      var message = (error && error.field === 'code' && error.message && error.message !== 'Request failed') ? error.message : invalid;
      if (errorNode) errorNode.textContent = message;
      if (input && input.setAttribute) input.setAttribute('aria-invalid', 'true');
      focusPreseedNode(input);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };

  PageController.prototype.submitPreseedDelete = async function (event) {
    await this.submitPreseedTerminal(event, 'delete', '[data-preseed-delete-error]', 'preseed-delete-done', 'preseed_delete_confirmed');
  };

  PageController.prototype.submitPreseedUnsubscribe = async function (event) {
    if (event && event.preventDefault) event.preventDefault();
    if (this.preseedBusy) return;
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    var errorNode = this.page.querySelector('[data-preseed-unsubscribe-error]');
    if (errorNode) errorNode.textContent = '';
    try {
      var payload = await this.preseedCall('unsubscribe');
      if (!payload || payload.state === 'expired') { this.showPreseedInvalid(); return; }
      if (payload.state !== 'unsubscribed') {
        if (errorNode) errorNode.textContent = this.preseedRetryMessage();
        focusPreseedNode(errorNode);
        return;
      }
      clearPreseedToken();
      clearPreseedUnsub();
      this.preseedToken = '';
      this.preseedUnsub = '';
      this.trackPreseed('preseed_unsubscribe_confirmed');
      this.show('preseed-unsubscribe-done');
    } catch (error) {
      if (preseedLinkDead(error)) { this.showPreseedInvalid(); return; }
      if (errorNode) errorNode.textContent = this.preseedErrorText(error);
      focusPreseedNode(errorNode);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };

  PageController.prototype.submitPreseedTerminal = async function (event, kind, errorSelector, doneState, eventName) {
    if (event && event.preventDefault) event.preventDefault();
    if (this.preseedBusy) return;
    this.preseedBusy = true;
    this.setPreseedBusy(true);
    var errorNode = this.page.querySelector(errorSelector);
    if (errorNode) errorNode.textContent = '';
    try {
      var payload = await this.preseedCall(kind);
      if (!payload || payload.state === 'expired') { this.showPreseedExpired(); return; }
      clearPreseedToken();
      this.preseedToken = '';
      this.trackPreseed(eventName);
      this.show(doneState);
    } catch (error) {
      if (preseedLinkDead(error)) { this.showPreseedExpired(); return; }
      if (errorNode) errorNode.textContent = this.preseedRetryMessage();
      focusPreseedNode(errorNode);
    } finally {
      this.preseedBusy = false;
      this.setPreseedBusy(false);
    }
  };


  /* ============================================================
   * T3 — occasion context: the banner and the cart attribute.
   * Reuses safeStorage, parseParams, isSafeHref and validDate from above.
   * Kept independent of PageController.prototype.storeContext/formatDate
   * (same idiom, small deliberate duplication) rather than refactored to
   * share them: this package depends only on T1 (05-work-packages.md), and
   * T2's already-merged, already-tested methods are left untouched.
   * ============================================================ */

  var CTX_KEY = 'fb_rem_ctx';
  var CART_ATTRIBUTE = '_fb_reminder_ctx';
  var PERSON_NOTES_ATTRIBUTE = '_fb_person_notes';
  var PERSON_NOTES_LIMIT = 500;
  var PERSON_NOTES_STASH = 'fb_rem_person_notes';

  /* `now`, when passed, is a millisecond timestamp (not a function — unlike
     readDraft's own `now` above, this one is never called with anything but
     a plain number, so there is no "(now || Date.now)()" footgun to inherit
     from that pattern). Omit it to check against the real current time. */
  function readContext(now) {
    var store = safeStorage();
    if (!store) return null;
    var instant = typeof now === 'number' ? now : Date.now();
    try {
      var context = JSON.parse(store.getItem(CTX_KEY) || 'null');
      if (!context || !context.ctx) return null;
      /* A null/undefined expiresAt (an undated occasion — see contextExpiry
         below) means there is nothing to check client-side: it stays valid
         for the life of the session, same as T2's storeContext leaves it. */
      if (typeof context.expiresAt === 'number' && context.expiresAt <= instant) {
        try { store.removeItem(CTX_KEY); } catch (_) {}
        return null;
      }
      return context;
    } catch (_) {
      try { store.removeItem(CTX_KEY); } catch (_) {}
      return null;
    }
  }

  /* Mirrors the date-plus-seven-days math PageController.prototype.storeContext
     already does inline (API-CONTRACT.md 6.1: "valid until the occasion date
     plus seven days") — a second, independent copy rather than a shared
     helper, for the reason in the section comment above. */
  function contextExpiry(dateString) {
    if (!dateString) return null;
    var parts = String(dateString).split('-');
    var year = Number(parts[0]);
    var month = Number(parts[1]);
    var day = Number(parts[2]);
    if (!year || !month || !day) return null;
    return Date.UTC(year, month - 1, day + 7);
  }

  function writeContext(fields) {
    var store = safeStorage();
    if (!store || !fields || !fields.ctx) return null;
    var previous = null;
    try { previous = JSON.parse(store.getItem(CTX_KEY) || 'null'); } catch (_) {}
    var record = {
      ctx: fields.ctx,
      name: fields.name || '',
      type: fields.type || 'BIRTHDAY',
      label: fields.label || null,
      date: fields.date || null,
      shopUrl: fields.shopUrl || null,
      returnUrl: fields.returnUrl || null,
      budgetCents: fields.budgetCents == null ? null : fields.budgetCents,
      expiresAt: contextExpiry(fields.date)
    };
    if (fields.friendId) record.friendId = String(fields.friendId);
    else if (previous && previous.ctx === record.ctx && previous.friendId) record.friendId = previous.friendId;
    if (typeof fields.notesText === 'string') record.notesText = fields.notesText;
    else if (previous && previous.ctx === record.ctx && typeof previous.notesText === 'string') record.notesText = previous.notesText;
    if (typeof record.notesText !== 'string' && record.friendId) {
      try {
        var stash = JSON.parse(store.getItem(PERSON_NOTES_STASH) || 'null');
        if (stash && stash.friendId === record.friendId && typeof stash.notesText === 'string') record.notesText = stash.notesText;
      } catch (_) {}
    }
    try { store.setItem(CTX_KEY, JSON.stringify(record)); } catch (_) {}
    return record;
  }

  function clearContext() {
    var store = safeStorage();
    if (store) {
      try { store.removeItem(CTX_KEY); } catch (_) {}
    }
  }

  /* Same formatting Controller.prototype.formatDate and
     PageController.prototype.formatDate already use (en-AU, UTC, "12
     October") — a third independent copy for the reason above. Only the
     "YYYY-MM-DD" response shape is needed here; the banner never receives a
     bare {month, day} object the way the sheet's capture form does. */
  function formatContextDate(value) {
    if (!value) return '';
    var parts = String(value).split('-');
    var month = Number(parts[1]);
    var day = Number(parts[2]);
    if (!validDate(month, day)) return '';
    return new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2000, month - 1, day)));
  }

  /* The person view's gift link is the source of `?occ=` for the collection
     and product cards (API-CONTRACT.md 6.3). A bare ctx token carries no
     name (6.1) and there is no endpoint to resolve one back to a name, so
     this — storing the context at the point the link is made, in the same
     tab and origin the shopper is about to leave — is the only way a
     `?occ=` context can ever become displayable on the far side. An unsafe
     href (review fix #2's isSafeHref, already applied before this runs) or
     one carrying no `occ=` param writes nothing. This runs inside
     PageController.prototype.renderPerson, so a malformed percent-encoding
     in the captured token must not throw: decodeURIComponent would take the
     whole person view down with it (showPerson's try/catch would replace
     the page with a generic error) for what is otherwise a non-essential,
     best-effort store. */
  function storeOccasionLinkContext(href, occasion) {
    if (!isSafeHref(href) || !occasion) return;
    var match = /[?&]occ=([^&]+)/.exec(String(href));
    if (!match) return;
    var ctx;
    try {
      ctx = decodeURIComponent(match[1]);
    } catch (_) {
      return;
    }
    var dated = !!(occasion.date && occasion.date.known);
    writeContext({
      ctx: ctx,
      name: occasion.name,
      type: occasion.type,
      label: occasion.label || null,
      date: dated ? (occasion.next && occasion.next.date) : null,
      shopUrl: href,
      returnUrl: occasion.id ? pageUrl('/pages/reminders', 'person', occasion.id) : null,
      friendId: occasion.friendId || null
    });
    trackReminderEvent('occasion_context_attached', 'page', 'person', { ctx: ctx });
  }

  /* String.prototype.replace still special-cases $&, $`, $' and $$ in a
     plain STRING replacement, even with a non-regex search value — an
     occasion name containing one (sent verbatim, up to 80 characters —
     04-storefront-and-growth.md 2.3) would otherwise corrupt the rendered
     text. A function replacement is not subject to this: its return value
     is spliced in as-is. T6 review: reused below by Controller (T1's sheet
     preview and saved summary) and PageController (T2's person, manage,
     invite and invite-saved views) — every __NAME__/__DATE__ template fill
     in the file goes through this, not only the banner's (T3). */
  function safeReplace(template, search, value) {
    return String(template).replace(search, function () { return value; });
  }

  function readShopCart() {
    if (typeof root.fetch !== 'function') return Promise.resolve(null);
    return root.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function fulfilmentPersonNotes(text) {
    if (root.FBPersonNotes && typeof root.FBPersonNotes.fulfilmentNotes === 'function') return root.FBPersonNotes.fulfilmentNotes(text);
    var value = String(text == null ? '' : text).trim();
    if (!value) return '';
    return value.length > PERSON_NOTES_LIMIT ? value.slice(0, PERSON_NOTES_LIMIT) : value;
  }

  /* Undefined: notes were never loaded, so leave whatever the cart has.
     A string (including '') is the notes to attach. Empty attaches nothing
     and clears a stale value. Never sent as cart.note. */
  function desiredPersonNotes(context) {
    if (!context || (!context.ctx && !context.friendId)) return undefined;
    if (!Object.prototype.hasOwnProperty.call(context, 'notesText')) return undefined;
    return fulfilmentPersonNotes(context.notesText);
  }

  function writePersonNotesAttribute(value) {
    if (typeof root.fetch !== 'function') return Promise.resolve(null);
    var attributes = {};
    attributes[PERSON_NOTES_ATTRIBUTE] = value;
    return root.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function syncPersonNotesFromCart(cart, context) {
    var desired = desiredPersonNotes(context);
    if (desired === undefined) return Promise.resolve(null);
    var current = (cart && cart.attributes && cart.attributes[PERSON_NOTES_ATTRIBUTE]) || '';
    if (desired === current) return Promise.resolve(null);
    if (!desired) return writePersonNotesAttribute('');
    if (!cart || !cart.item_count) return Promise.resolve(null);
    return writePersonNotesAttribute(desired);
  }

  /* POST /cart/update.js merges attributes. An empty context value clears
     _fb_reminder_ctx and _fb_person_notes. The body never includes note. */
  function writeCartAttribute(value) {
    if (typeof root.fetch !== 'function') return Promise.resolve(null);
    var attributes = {};
    attributes[CART_ATTRIBUTE] = value || '';
    if (!value) attributes[PERSON_NOTES_ATTRIBUTE] = '';
    return root.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  /* Review fix #1 (T3 follow-up): cart:updated (bound in
     BannerController.prototype.bind below) covers assets/cart.js's own
     line-item controls, plus assets/cart-drawer-addons.js and
     sections/gift-card-upsell.liquid, which dispatch it themselves — but
     never a product page's own Add to Cart button. That flow is
     product-form.js posting to routes.cart_add_url and handing the response
     straight to assets/cart-notification.js's CartNotification.renderContents,
     which opens the drawer without ever dispatching cart:updated (confirmed:
     grepping assets/cart-notification.js for it finds nothing). Before this
     fix the attribute only ever caught up in
     BannerController.prototype.init below — the shopper's *next* full page
     load — which is too late for anyone who adds to cart and checks out from
     the drawer without one in between: the whole point of this attribute is
     letting the paid-order webhook associate the order with the right
     occasion (docs/reminders/README.md, "a hidden cart attribute that lets
     the paid-order webhook mark …").

     Same fetch/XHR interception assets/fb-pickup-time.js's isLineMutation and
     assets/fb-posthog-commerce.js's isCartMutation already use to solve the
     identical problem for their own cart attributes: every
     /cart/add|change|update|clear request is watched regardless of which
     script issued it — apps and jQuery (XHR) included — so this needs no
     cooperation from product-form.js or any card's own add-to-cart markup,
     current or future, and covers the /cart page's own update flow
     (assets/cart.js) the same way, on top of that page's own cart:updated
     dispatch. Installed at most once — cartMutationWatcherInstalled guards
     against BannerController.prototype.bind somehow running twice — though in
     practice it never can: BannerController itself is a singleton
     (root.FBReminders.initBanner) and this whole file only ever executes once
     per page regardless of how many surfaces try to load it (the sheet and
     banner loaders both check window.FBReminders first). */
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var cartMutationWatcherInstalled = false;

  function isCartMutationUrl(url) {
    if (!url) return false;
    var path;
    try {
      path = new root.URL(String(url), root.location && root.location.origin).pathname;
    } catch (_) {
      path = String(url);
    }
    return CART_MUTATION_RE.test(path);
  }

  function watchCartMutations(onMutated) {
    if (cartMutationWatcherInstalled) return;
    cartMutationWatcherInstalled = true;

    var nativeFetch = typeof root.fetch === 'function' ? root.fetch : null;
    if (nativeFetch) {
      root.fetch = function (input) {
        var url = typeof input === 'string' ? input : input && input.url;
        var watched = isCartMutationUrl(url);
        var result = nativeFetch.apply(this, arguments);
        if (!watched) return result;
        return result.then(function (response) {
          if (response && response.ok) {
            return Promise.resolve(onMutated()).then(function () { return response; });
          }
          return response;
        });
      };
    }

    // Some add-to-cart paths (apps, jQuery — jquery-3.7.1.min.js is loaded on
    // this theme) use XHR rather than fetch.
    if (typeof root.XMLHttpRequest === 'function') {
      var nativeOpen = root.XMLHttpRequest.prototype.open;
      var nativeSend = root.XMLHttpRequest.prototype.send;
      root.XMLHttpRequest.prototype.open = function (method, url) {
        this.__fbRemCartMutation = isCartMutationUrl(url);
        return nativeOpen.apply(this, arguments);
      };
      root.XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        if (xhr.__fbRemCartMutation) {
          xhr.addEventListener('load', function () {
            if (xhr.status >= 200 && xhr.status < 300) onMutated();
          });
        }
        return nativeSend.apply(this, arguments);
      };
    }
  }

  // The person shop can add through cards or quick view without ever loading
  // a product page/banner. Finish attribution before the cart drawer opens.
  function initPageCartContext() {
    watchCartMutations(function () {
      var context = readContext();
      if (!context) return;
      return readShopCart().then(function (cart) {
        var latest = readContext();
        if (!latest || latest.ctx !== context.ctx || !cart || !cart.item_count) return;
        var pending = (cart.attributes || {})[CART_ATTRIBUTE] === latest.ctx ? Promise.resolve(null) : writeCartAttribute(latest.ctx);
        return pending.then(function () { return syncPersonNotesFromCart(cart, latest); });
      });
    });
    if (root.document && typeof root.document.addEventListener === 'function') {
      root.document.addEventListener('fb-person-notes:updated', function () {
        var latest = readContext();
        if (!latest) return;
        readShopCart().then(function (cart) { return syncPersonNotesFromCart(cart, latest); });
      });
    }
  }

  function BannerController(container) {
    this.container = container;
    this.api = root.FBRemindersAPI.create(container.dataset.apiBase);
    this.context = null;
    this.popupObserver = null;
    this.bind();
    this.init();
  }

  BannerController.prototype.bind = function () {
    var self = this;
    this.container.addEventListener('click', function (event) {
      if (event.target.closest('[data-reminders-banner-not-for]')) {
        event.preventDefault();
        self.leave();
      }
      /* "Change" is a plain link to /pages/reminders — default navigation,
         no handler needed. */
    });
    /* Same event assets/fb-posthog-commerce.js listens for, dispatched after
       every cart mutation by assets/cart.js, assets/cart-drawer-addons.js and
       sections/gift-card-upsell.liquid (T3.2). */
    document.addEventListener('cart:updated', function () { self.syncAttribute(); });
    document.addEventListener('fb-person-notes:updated', function () {
      var latest = readContext();
      if (latest && self.context && latest.ctx === self.context.ctx) {
        self.context.notesText = latest.notesText;
        if (latest.friendId) self.context.friendId = latest.friendId;
      }
      self.syncAttribute();
    });
    /* Review fix #1: cart:updated alone misses a product page's own Add to
       Cart button — see watchCartMutations above for why. This is the other
       half, and the one that actually catches that flow. */
    watchCartMutations(function () { self.syncAttribute(); });
    /* A section reload in the theme customizer (editing a header setting,
       say) replaces #popupModal with fresh nodes
       sharing the same id, which would otherwise leave watchOverlayPopup's
       observer attached to a detached element — the same event
       fb-careers-link.liquid's own popup watcher already re-subscribes on. */
    document.addEventListener('shopify:section:load', function () {
      if (self.popupObserver) {
        self.popupObserver.disconnect();
        self.popupObserver = null;
      }
      if (!self.container.hidden) self.watchOverlayPopup();
    });
  };

  /* `?r=` always wins over `?occ=` — the same rule PageController.resolveView
     already applies to the identical pair on the Reminders page
     (API-CONTRACT.md 6.4). */
  BannerController.prototype.init = async function () {
    /* The Reminders page resolves its own ?r= and renders the person screen.
       Resolving it again here would count a second visit and could surface
       the previous person's banner while that request is in flight. */
    if (root.location && /\/pages\/reminders$/.test(root.location.pathname || '')) {
      this.render(null);
      return;
    }
    var params = parseParams(root.location && root.location.search);
    if (params.r) {
      await this.resolveLinkToken(params.r);
    } else if (params.occ) {
      var stored = readContext();
      if (stored && stored.ctx !== params.occ) {
        /* A direct product link for another occasion must not inherit a
           previously saved person's banner or cart attribution. A bare
           token cannot provide the new person's name on its own. */
        clearContext();
        writeCartAttribute('');
      }
    }
    this.render(readContext());
    this.syncAttribute();
  };

  /* API-CONTRACT.md 6.4: an explicit product or collection link still
     redirects straight to shopping with `?r=<token>` appended. This is
     the token resolver for those shopping pages; the Reminders person page
     uses PageController.prototype.showLink instead. Same
     public endpoint and the same failure handling: an expired, revoked or
     unknown token (all the same 404 LINK_INVALID, API-CONTRACT.md 5.2)
     simply leaves no context — a shopping page shows no error banner, unlike
     the dedicated link-landing view. */
  BannerController.prototype.resolveLinkToken = async function (token) {
    var measurement = currentReminderLinkMeasurement();
    try {
      var result = await this.api.resolveLink(token);
      if (result && result.ctx) {
        writeContext({
          ctx: result.ctx,
          name: result.name,
          type: result.type,
          date: result.date,
          shopUrl: isSafeHref(result.shopUrl) ? result.shopUrl : null
        });
        trackReminderLinkOpened('banner', 'banner', result.ctx, measurement);
        trackReminderEvent('occasion_context_attached', 'banner', 'banner', { ctx: result.ctx });
      }
    } catch (_) {
      /* Review fix #2: a shopper can already be carrying a different, stale
         context from earlier in this session (someone else's occasion, or
         one whose date has since passed) when they follow an expired,
         revoked or unknown reminder link here. Left alone, that stale
         context would go on rendering as if this new (failed) link had
         resolved — the wrong banner, and the wrong _fb_reminder_ctx written
         to their cart. Clearing it is what actually makes the doc comment
         above true ("simply leaves no context"): merely not writing a new
         one is not the same as leaving none. */
      clearContext();
    }
  };

  /* No availability, price or delivery claim ever comes from the context
     (T3.4): the only inputs this ever reads are the stored name and date. A
     context with no name (readContext found one, but it has nothing safe to
     display — see storeOccasionLinkContext above) renders nothing, same as
     no context at all. */
  BannerController.prototype.render = function (context) {
    this.context = context && context.name ? context : null;
    var container = this.container;
    if (!this.context) {
      container.hidden = true;
      return;
    }
    var dateText = formatContextDate(this.context.date);
    var occasionLabel = occasionName(this.context);
    var textNode = container.querySelector('[data-reminders-banner-text]');
    if (textNode) {
      textNode.textContent = dateText
        ? safeReplace(safeReplace(safeReplace(container.dataset.contextTemplate, '__TYPE__', occasionLabel), '__NAME__', this.context.name), '__DATE__', dateText)
        : safeReplace(safeReplace(container.dataset.contextNoDateTemplate, '__TYPE__', occasionLabel), '__NAME__', this.context.name);
    }
    var notFor = container.querySelector('[data-reminders-banner-not-for]');
    if (notFor) notFor.textContent = safeReplace(container.dataset.notForTemplate, '__NAME__', this.context.name);
    var back = container.querySelector('[data-reminders-banner-change]');
    if (back && /^\/pages\/reminders\?reminder_view=person&id=[a-zA-Z0-9_-]+$/.test(this.context.returnUrl || '')) {
      back.href = this.context.returnUrl;
      back.textContent = 'Back to ' + this.context.name + '’s shop';
    }
    var budget = container.querySelector('[data-reminders-banner-budget]');
    if (budget) {
      var bandLabels = { UNDER_50: 'Up to $50', UNDER_100: 'Up to $100', UNDER_200: 'Up to $200', OVER_200: 'More than $200' };
      var band = bandLabels[this.context.budgetBand];
      budget.hidden = !band && !(Number.isSafeInteger(this.context.budgetCents) && this.context.budgetCents >= 1000);
      if (band) budget.textContent = 'Gift range ' + band + ' · delivery calculated after postcode';
      else if (!budget.hidden) budget.textContent = 'Gift budget up to $' + (this.context.budgetCents / 100).toFixed(0) + ' · delivery calculated after postcode';
    }
    container.hidden = false;
    trackReminderEvent('occasion_shop_viewed', 'banner', 'banner', this.context.ctx ? { ctx: this.context.ctx } : null);
    this.watchOverlayPopup();
  };

  /* "Not for {name}" (04-storefront-and-growth.md 2.5): clears the stored
     context and the cart attribute together, so neither survives on its
     own (T3.2). */
  BannerController.prototype.leave = function () {
    var clearedCtx = this.context && this.context.ctx;
    clearContext();
    trackReminderEvent('occasion_context_cleared', 'banner', 'banner', clearedCtx ? { ctx: clearedCtx } : null);
    /* Same cleanup the shopify:section:load handler in bind() already does:
       render(null) below hides the container but never tears down the
       observer watchOverlayPopup() set up while it was visible, which would
       otherwise keep watching #popupModal for the rest
       of the page session for a banner that is gone for good. */
    if (this.popupObserver) {
      this.popupObserver.disconnect();
      this.popupObserver = null;
    }
    this.render(null);
    writeCartAttribute('');
  };

  /* T3.2: written through /cart/update.js once the cart has items, and
     re-written when missing after any cart mutation — cart:updated (bound
     above) plus the fetch/XHR watcher installed by watchCartMutations, which
     is what actually catches a product page's own Add to Cart button (review
     fix #1: cart:updated alone never fires for that flow). Reads the live
     cart rather than trusting an event's detail shape, which differs across
     dispatchers (see the listener above) — the same defensive choice
     assets/fb-posthog-commerce.js makes with its own fetchCart/reconcile. */
  BannerController.prototype.syncAttribute = function () {
    var self = this;
    if (!this.context || !this.context.ctx) return;
    readShopCart().then(function (cart) {
      var budget = self.container.querySelector('[data-reminders-banner-budget]');
      var ceiling = self.context && self.context.budgetCents;
      if (budget && !self.context.budgetBand && Number.isSafeInteger(ceiling) && ceiling >= 1000 && cart && Number.isSafeInteger(cart.total_price)) {
        var left = ceiling - cart.total_price;
        budget.textContent = left >= 0
          ? 'Gift budget $' + (ceiling / 100).toFixed(0) + ' · $' + (left / 100).toFixed(2) + ' left after cart subtotal · delivery calculated after postcode'
          : 'Cart subtotal is $' + (-left / 100).toFixed(2) + ' over your $' + (ceiling / 100).toFixed(0) + ' gift budget · delivery calculated after postcode';
      }
      if (!self.context || !cart || !cart.item_count) return; // "once the cart has items"
      var current = (cart.attributes && cart.attributes[CART_ATTRIBUTE]) || '';
      var pending = current === self.context.ctx ? Promise.resolve(null) : writeCartAttribute(self.context.ctx);
      return pending.then(function () {
        var stored = readContext();
        var source = stored && stored.ctx === self.context.ctx ? stored : self.context;
        return syncPersonNotesFromCart(cart, source);
      });
    });
  };

  /* The delivery/suburb popup (snippets/delivery-suburb-popup.liquid,
     #popupModal) sets no class on <body> and toggles its own inline display
     instead — the same gap fb-bottom-nav.liquid and fb-careers-link.liquid
     both work around, each in its own way. Watched directly here rather than
     relying on the CSS overlay rules above, which only ever see body
     classes (T3.3).
     Set up lazily, only once there is something worth protecting from it —
     matching the "nothing loads until there's a reason to" rule the calling
     snippet's own bootstrap script already follows. */
  BannerController.prototype.watchOverlayPopup = function () {
    if (this.popupObserver || typeof root.MutationObserver !== 'function' || !root.document) return;
    var container = this.container;
    var popups = ['popupModal']
      .map(function (id) { return root.document.getElementById(id); })
      .filter(Boolean);
    if (!popups.length) return;
    function sync() {
      var open = popups.some(function (popup) { return root.getComputedStyle(popup).display !== 'none'; });
      container.classList.toggle('fb-reminders-occasion-banner--popup-open', open);
    }
    this.popupObserver = new root.MutationObserver(sync);
    popups.forEach(function (popup) {
      this.popupObserver.observe(popup, { attributes: true, attributeFilter: ['style', 'class'] });
    }, this);
    sync();
  };

  /* ============================================================
   * T5 — analytics: one event helper used by every Reminders
   * surface below (sheet, page, banner), in the theme-native
   * PostHog register assets/cart-drawer-addons.js:143-170 already
   * established: snake_case event names, a guarded
   * root.posthog.capture that is a silent no-op with PostHog
   * absent or throwing (T5.3), and never a data source of its own.
   * `surface`, `touchpoint` and `flow_version` are stamped here,
   * centrally, so no call site can add an event later without them
   * (T5.1) — the same reasoning cart-drawer-addons.js gives for
   * stamping open_id centrally rather than at each call site. `ids`,
   * when passed, may only be the opaque tokens API-CONTRACT.md
   * already treats as safe to move off the shopper's device (an
   * occasion id, an occurrence id, a member id, an invite token, a
   * context ctx token) — never a name, email, phone, verification
   * code or date, which README.md's API client rules already forbid
   * in storage or analytics and which T5.2's payload scan (in
   * tests/fb-reminders-analytics.test.js) checks for directly. Every
   * call site below is threaded through this one function precisely
   * so that scan only has to trust one function's shape, not every
   * call site's discipline.
   *
   * `reminder_hook_viewed` and `reminder_hook_clicked` (T4) are not
   * wired through this helper: they already fire independently
   * inside snippets/fb-reminders-pdp-hook.liquid and
   * snippets/fb-reminders-cart-hook.liquid, outside this package's
   * files (see the PR description). `reminders_entry_viewed` is
   * also not wired here: assets/fb-reminders.js loads lazily on
   * first sheet open (README.md, "Conventions"), so it never runs
   * while the entry icon is merely visible on the page — that
   * impression event, if added, belongs in
   * snippets/fb-reminders-entry.liquid instead.
   * ============================================================ */
  var FLOW_VERSION = 'v1';

  /* action -> event name for PageController.prototype.submitOutcome below.
     'restore' has no event of its own: 05-work-packages.md section 5 does
     not name one. */
  var OUTCOME_EVENT_NAMES = {
    skipped: 'occurrence_skipped',
    handled_elsewhere: 'occurrence_marked_handled',
    snooze: 'occurrence_snoozed'
  };

  function trackReminderEvent(name, surface, touchpoint, ids) {
    try {
      if (!root.posthog || typeof root.posthog.capture !== 'function') return;
      var payload = { surface: surface, touchpoint: touchpoint, flow_version: FLOW_VERSION };
      // The placement that opened the sheet this session (pop, pill, cart,
      // announcement...), set by snippets/fb-reminders-sheet.liquid.
      var source = null;
      try { source = root.sessionStorage && root.sessionStorage.getItem('fb_rem_source'); } catch (_) {}
      if (source) payload.source = source;
      if (ids) {
        Object.keys(ids).forEach(function (key) {
          var value = ids[key];
          if (value !== undefined && value !== null && value !== '') payload[key] = value;
        });
      }
      root.posthog.capture(name, payload);
    } catch (err) {
      /* Analytics must never throw into the reminders surface's own
         behaviour — same rule assets/cart-drawer-addons.js:159-161
         follows for the cart drawer's rail events. */
    }
  }

  /* ---------- reminder link measurement (Birthday Club PR #304/#305) ----------

     A Birthday Club reminder email link goes through birthdays.figandbloom.com/r/<token>,
     which forwards ?em=<EmailMessage id>&lk=<link key> and the utm_* params onto the
     storefront URL (FORWARDED_PARAMS in src/lib/reminders/occasion-view.ts). The formats
     are fixed on the Birthday Club side:
       em  emailMeasurementId(): 'em_' + 32 lowercase hex (src/lib/email-library/measurement.ts),
           the same /^em_[a-f0-9]{32}$/ the funnel sync accepts (funnel-sync.ts MESSAGE_ID).
       lk  LINK_KEY /^[a-z][a-z0-9_]{0,39}$/ (src/lib/email-library/link-tracking.ts):
           cta, offer, person_1, tile_<key>, product_1 ...
       utm_content  set to the link key by trackedContentUrl().
     Anything else is dropped. With no valid em nothing from the URL is sent at all, so
     reminder_link_opened is exactly what it was before.

     The landing records the message as the person property email_message, so the
     Birthday Club funnel can match this visitor's later 'Product Added' and 'Checkout
     Started' to the email (funnel-sync.ts joins on person.properties.email_message).
     $set, not $set_once: the latest reminder link someone followed is the one their
     next add-to-cart belongs to.

     PostHog runs with person_profiles: 'identified_only' (snippets/fb-posthog.liquid),
     so an anonymous visitor's events go out with $process_person_profile: false and the
     server ignores any $set on them. setPersonProperties() is the call that switches
     person processing on for this visitor (posthog-js requires it before a person can
     carry properties), so it runs first; the event then carries the same $set. */
  var REMINDER_EMAIL_MESSAGE_ID = /^em_[a-f0-9]{32}$/;
  var REMINDER_LINK_KEY = /^[a-z][a-z0-9_]{0,39}$/;
  var REMINDER_UTM_CONTENT = /^[A-Za-z0-9_.-]{1,64}$/;

  /* First value of each key. Never throws: a malformed %-escape drops that pair. */
  function readSearchParams(search) {
    var params = {};
    var raw = String(search || '');
    if (raw.charAt(0) === '?') raw = raw.slice(1);
    if (!raw || raw.length > 4096) return params;
    raw.split('&').forEach(function (pair) {
      if (!pair) return;
      var idx = pair.indexOf('=');
      var key;
      var value;
      try {
        key = decodeURIComponent(idx === -1 ? pair : pair.slice(0, idx));
        value = idx === -1 ? '' : decodeURIComponent(pair.slice(idx + 1).replace(/\+/g, ' '));
      } catch (_) {
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(params, key)) params[key] = value;
    });
    return params;
  }

  /* The URL's reminder measurement, or null when em is missing or invalid. */
  function reminderLinkMeasurement(search) {
    var params = readSearchParams(search);
    var em = params.em;
    if (typeof em !== 'string' || !REMINDER_EMAIL_MESSAGE_ID.test(em)) return null;
    var props = { email_message_id: em };
    if (typeof params.lk === 'string' && REMINDER_LINK_KEY.test(params.lk)) props.link_key = params.lk;
    if (typeof params.utm_content === 'string' && REMINDER_UTM_CONTENT.test(params.utm_content)) props.utm_content = params.utm_content;
    props.$set = { email_message: em };
    return props;
  }

  function currentReminderLinkMeasurement() {
    try {
      return reminderLinkMeasurement(root.location && root.location.search);
    } catch (_) {
      return null;
    }
  }

  /* reminder_link_opened, with the link's measurement when it has one. `measurement`
     is read before the token resolves, so nothing that rewrites the URL meanwhile
     (the preview bar, a later replaceState) can lose it. */
  function trackReminderLinkOpened(surface, touchpoint, ctx, measurement) {
    var ids = {};
    if (ctx) ids.ctx = ctx;
    if (measurement && measurement.email_message_id) {
      try {
        if (root.posthog && typeof root.posthog.setPersonProperties === 'function') {
          root.posthog.setPersonProperties({ email_message: measurement.email_message_id });
        }
      } catch (_) { /* analytics never throws into the page */ }
      Object.keys(measurement).forEach(function (key) { ids[key] = measurement[key]; });
    }
    trackReminderEvent('reminder_link_opened', surface, touchpoint, Object.keys(ids).length ? ids : null);
  }

  /* The welcome script (assets/fb-reminders-welcome.js) applies an earned
     reward once /me confirms the code. Saving the reminder that crosses
     three happens here, on the Reminders page, and on the wish list; each
     tells it to re-read /me without waiting for the sheet to close. */
  function notifyRemindersChanged() {
    try {
      if (!root.document || typeof root.CustomEvent !== 'function' || typeof root.document.dispatchEvent !== 'function') return;
      root.document.dispatchEvent(new root.CustomEvent('fb-reminders:changed'));
    } catch (_) {}
  }

  function Controller(sheet) {
    this.sheet = sheet;
    this.panel = sheet.querySelector('.fb-reminders-sheet__panel');
    this.api = root.FBRemindersAPI.create(sheet.dataset.apiBase);
    this.opener = null;
    this.me = null;
    this.identityMode = 'email';
    this.identityValue = '';
    this.resendTimer = null;
    this.pendingPreferences = null;
    this.preferenceReturnState = null;
    this.justVerifiedEmail = false;
    this.bind();
    this.renderShortcuts();
    this.restoreDraftToForm();
  }

  Controller.prototype.bind = function () {
    var self = this;
    this.sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-fb-reminders-close]')) return self.close();
      if (event.target.closest('[data-reminders-drawer-reward-shop]')) {
        self.renderDrawerReward(self.drawerRewardMe);
        if (!self.drawerRewardCode) event.preventDefault();
        return;
      }
      var person = event.target.closest('[data-reminders-person-result]');
      if (person) {
        self.trackSearchedPerson(person.getAttribute('data-reminders-friend-id'));
        return;
      }
      var edit = event.target.closest('[data-reminders-batch-edit]');
      if (edit) { event.preventDefault(); return self.editBatch(Number(edit.dataset.remindersBatchEdit)); }
      var action = event.target.closest('[data-reminders-action]');
      if (!action) return;
      event.preventDefault();
      self.action(action.dataset.remindersAction);
    });
    this.sheet.addEventListener('change', function (event) {
      if (event.target.name === 'unknownDate' || event.target.name === 'type') {
        var form = self.sheet.querySelector('[data-reminders-capture]');
        syncDateForm(form);
        if (event.target.name === 'type') { self.captureDefaultType = ''; form.elements.name.focus(); }
      }
      if (event.target.closest('[data-reminders-capture]')) self.retainCaptureDraft();
      self.renderBatch();
    });
    this.sheet.addEventListener('input', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-reminders-person-query]')) {
        self.renderPersonSearch();
        return;
      }
      if (event.target.name === 'name') { var form = self.sheet.querySelector('[data-reminders-capture]'); var help = form.querySelector('[data-reminders-unknown-help]'); if (help) help.textContent = words('unknown_help', { NAME: event.target.value.trim() || words('neutral_name') }); }
      if (event.target.closest('[data-reminders-capture]')) { self.retainCaptureDraft(); self.renderBatch(); }
    });
    this.sheet.querySelector('[data-reminders-capture]').addEventListener('submit', function (event) { self.submitCapture(event); });
    this.sheet.querySelector('[data-reminders-identify]').addEventListener('submit', function (event) { self.submitIdentity(event); });
    this.sheet.querySelector('[data-reminders-verify]').addEventListener('submit', function (event) { self.submitVerify(event); });
    this.sheet.querySelector('[data-reminders-saved-preferences]').addEventListener('submit', function (event) { self.submitPreferences(event); });
    this.sheet.querySelector('[data-reminders-preferences]').addEventListener('submit', function (event) { self.submitPreferences(event); });
    document.addEventListener('fb-reminders:me', function (event) {
      var me = event.detail && event.detail.me;
      if (!self.sheet.hidden && self.sheet.dataset.state === 'preview') self.me = me;
      self.renderDrawerReward(me);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.FBPrivacyDialog && root.FBPrivacyDialog.isOpen()) return;
      if (event.key === 'Escape' && !self.sheet.hidden) {
        self.suppressEscapeKeyup = true;
        event.preventDefault(); event.stopPropagation(); self.close(false, 'escape');
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && self.suppressEscapeKeyup) {
        self.suppressEscapeKeyup = false; event.preventDefault(); event.stopPropagation();
      }
    }, true);
  };

  Controller.prototype.open = async function (opener) {
    if (this.requestingIdentity || this.verifyingIdentity) {
      var invitationToken = opener && opener.dataset && opener.dataset.birthdayInvitationToken;
      if (invitationToken) {
        if (this.verifyingIdentity) {
          // Its payload has already been sent. Finish that operation before
          // changing purpose; never relabel an in-flight capture response.
          this.pendingBirthdayInvitation = { token: invitationToken, onVerified: this.birthdayInvitationReturn };
        } else {
          this.birthdayInvitationToken = invitationToken;
          this.captureAuth = false; this.groupAuth = false; this.groupInvitationToken = null;
          this.pendingPreferences = null; this.preferencesIntent = null;
          this.marketingConsent = false;
          var pendingOptIn = this.sheet.querySelector('[data-identity-marketing]');
          if (pendingOptIn) pendingOptIn.hidden = true;
        }
      }
      this.opener = opener || this.opener;
      this.sheet.hidden = false; this.suspendBackground();
      document.body.classList.add('modal-open');
      document.querySelectorAll('[data-fb-reminders-open]').forEach(function (entry) { entry.setAttribute('aria-expanded', 'true'); });
      this.show(this.verifyingIdentity ? 'verify' : 'identify');
      return;
    }
    var opening = this.opening = (this.opening || 0) + 1;
    trackReminderEvent('reminders_entry_opened', 'sheet', 'entry', null);
    this.opener = opener || document.activeElement;
    this.rewardJourney = !!(opener && opener.dataset && opener.dataset.remindersRewardIntent === 'true');
    // rewardJourney is offer intent (banner, reward progress) and stays with
    // the entry points that carry it. batchJourney is the three-date guest
    // capture, which every guest entry point uses (set in beginCapture).
    this.batchJourney = false;
    this.rewardChecking = false;
    this.rewardProgressUnavailable = false;
    this.groupAuth = !!(opener && opener.dataset && opener.dataset.groupSignIn != null);
    this.groupInvitationToken = opener && opener.dataset.groupInvitationAuth === 'true' && root.FBGroupGifts ? root.FBGroupGifts.invitationToken() : null;
    this.birthdayInvitationToken = opener && opener.dataset.birthdayInvitationToken || null;
    var optIn = this.sheet.querySelector('[data-identity-marketing]');
    if (optIn) optIn.hidden = !!(this.groupAuth || this.groupInvitationToken || this.birthdayInvitationToken);
    this.pendingPreferences = null;
    this.preferenceReturnState = null;
    var requested = opener && opener.dataset.remindersOpenState;
    this.checkoutOpener = requested === 'checkout-offer' ? opener : null;
    this.captureAuth = false;
    this.preferencesIntent = requested === 'preferences' ? opener.dataset.remindersEnableSms === 'true' : null;
    this.sheet.hidden = false;
    this.suspendBackground();
    document.body.classList.add('modal-open');
    document.querySelectorAll('[data-fb-reminders-open]').forEach(function (entry) { entry.setAttribute('aria-expanded', 'true'); });
    this.show('loading');
    try {
      this.me = await this.api.me();
      if (this.sheet.hidden || this.opening !== opening) return;
      this.updateDots(this.me);
      if (requested === 'checkout-offer') {
        var reward = this.me && this.me.member && this.me.member.datesReward;
        if (this.assignedRewardArm(this.me) === 'none' || (this.me && this.me.signedIn && (!reward || reward.status !== 'locked' || !this.assignedRewardArm(this.me)))) return this.resumeCheckout();
        this.show('checkout-offer');
      } else if (requested === 'capture') this.beginCapture(opener.dataset, true);
      else if (requested === 'preferences') await this.loadPreferences(opener.dataset.remindersEnableSms === 'true');
      else if (requested === 'identify' && opener.dataset.remindersEmailFrom && this.me && this.me.signedIn) this.renderMe(this.me);
      else if (requested === 'identify') { this.setIdentityMode('email'); this.prefillIdentityEmail(opener); this.show('identify'); }
      else this.renderMe(this.me);
    } catch (error) {
      if (this.sheet.hidden || this.opening !== opening) return;
      if (error && error.code === 'UNAUTHENTICATED') {
        this.me = { signedIn: false };
        if (requested === 'checkout-offer') { this.show('checkout-offer'); return; }
        if (requested === 'capture') { this.beginCapture(opener.dataset, true); return; }
        this.setIdentityMode('email');
        if (requested === 'identify') this.prefillIdentityEmail(opener);
        this.show('identify');
        return;
      }
      if (requested === 'checkout-offer') return this.resumeCheckout();
      this.showFatal(error);
    }
  };

  /* business-os #157: the Email signup section (sections/newsletter.liquid)
     opens the sheet at identify and names its email input in
     data-reminders-email-from. Copy what was typed into the verify flow's
     email field so one tap sends the code. The value is read from the page
     at open time only: never stored, never put in a dataset or an event. */
  Controller.prototype.prefillIdentityEmail = function (opener) {
    try {
      var id = opener && opener.dataset && opener.dataset.remindersEmailFrom;
      if (!id) return;
      var source = document.getElementById(id);
      var form = this.sheet.querySelector('[data-reminders-identify]');
      var value = source && typeof source.value === 'string' ? source.value.trim() : '';
      if (form && form.elements.email && value) form.elements.email.value = value;
    } catch (_) {}
  };

  Controller.prototype.resumeCheckout = async function () {
    if (this.resumingCheckout) return;
    this.resumingCheckout = true;
    var opener = this.checkoutOpener, generation = this.opening;
    try {
      // Give the existing earned-code application a bounded chance to finish
      // before replaying checkout. Never manufacture a code or an allocation.
      var welcome = document.querySelector('fb-reminders-welcome');
      if (this.savedOccasion && this.rewardJourney && welcome && welcome.__rw) {
        var timer;
        try {
          await Promise.race([
            welcome.__rw.refresh(true),
            new Promise(function (resolve) { timer = root.setTimeout(resolve, 5000); })
          ]);
        } catch (_) {} finally { root.clearTimeout(timer); }
      }
      if (this.sheet.hidden || this.opening !== generation) return;
      this.checkoutOpener = null; this.close(true);
      if (root.FBRemindersCheckout) root.FBRemindersCheckout.resume(opener);
    } finally { this.resumingCheckout = false; }
  };

  Controller.prototype.guestDatesCount = function () {
    var batch = this.batchDraft();
    return qualifyingDraftCount(batch ? batch.people : []);
  };

  // The live offer the popup already shows: "[n]% off" or free delivery.
  Controller.prototype.leaveConfirmCopy = function (count) {
    var n = Math.max(0, Math.min(3, Number(count) || 0)), left = 3 - n;
    if (n === 0) return 'Add 3 dates to unlock your discount.';
    return 'You have ' + n + ' of 3 dates added. Add ' + left + ' more date' + (left === 1 ? '' : 's') + ' to unlock your discount.';
  };

  // Email step copy (Oct 2026), from the same live offer as "Add 3 dates for ...".
  Controller.prototype.emailStepCopy = function () {
    var arm = (this.sheet.dataset && this.sheet.dataset.rewardArm) || this.assignedRewardArm(this.me);
    var pct = arm === 'pct10' || arm === 'pct30';
    var offer = pct ? rewardArmPercent(arm) + '% off' : arm === 'free_delivery' ? 'free delivery' : '';
    return {
      heading: offer ? 'Where should we send your reminders and discount codes?' : 'Where should we send your reminders?',
      lead: offer ? 'Save your dates to claim your ' + offer + '.' : 'Save your dates.',
      submit: offer ? 'Send my discount' : 'Save my reminders'
    };
  };
  // Saving a batch: the intro above the list goes, the benefit heading sits
  // above the email field, and the button names the reward. Anything else
  // (sign-in, preferences, groups) keeps the original copy.
  Controller.prototype.applyEmailStep = function (saving) {
    this.emailStepSaving = !!saving;
    var body = this.sheet.querySelector('[data-reminders-identity-body]');
    var heading = this.sheet.querySelector('[data-reminders-email-heading]');
    var submit = this.sheet.querySelector('[data-reminders-identify] [data-identity-submit]');
    var copy = saving ? this.emailStepCopy() : null;
    if (body) body.hidden = !!saving;
    if (heading) { heading.hidden = !saving; heading.textContent = saving ? copy.heading : ''; }
    if (submit && this.identityMode !== 'sms') submit.textContent = saving ? copy.submit : (this.sheet.dataset && this.sheet.dataset.emailSubmit) || submit.textContent;
    // 3 of 3 (Oct 2026): the maroon block wraps the email entry with "Nearly
    // there!" and the offer line; the progress meter drops below it, quiet.
    var batch = saving ? this.batchDraft() : null;
    this.emailHierarchy = !!(saving && batch && qualifyingDraftCount(batch.people) >= 3);
    if (this.sheet.dataset) this.sheet.dataset.emailHierarchy = this.emailHierarchy ? 'true' : 'false';
    var intro = this.sheet.querySelector('[data-reminders-email-intro]');
    var lead = this.sheet.querySelector('[data-reminders-email-lead]');
    if (intro) intro.hidden = !this.emailHierarchy;
    if (lead) lead.textContent = this.emailHierarchy ? copy.lead : '';
    this.placeEmailProgress();
  };
  // Moves the live progress nodes (same elements, so meters, counts, pulse and
  // confetti keep working) under the email block, and back again.
  Controller.prototype.placeEmailProgress = function () {
    var slot = this.sheet.querySelector('[data-reminders-email-progress-slot]');
    if (!slot || !root.document) return;
    var below = !!this.emailHierarchy && this.sheet.dataset.state === 'identify';
    ['[data-reminders-reward-banner]', '[data-reminders-batch-progress]'].forEach(function (selector) {
      var node = this.sheet.querySelector(selector);
      if (!node || !node.parentNode) return;
      this.progressHomes = this.progressHomes || {};
      if (!this.progressHomes[selector]) { this.progressHomes[selector] = root.document.createComment(selector); node.parentNode.insertBefore(this.progressHomes[selector], node); }
      if (node.classList) node.classList.toggle('fb-reminders-batch-progress--quiet', below);
      if (below && node.parentNode !== slot) slot.appendChild(node);
      else if (!below && node.parentNode === slot) this.progressHomes[selector].parentNode.insertBefore(node, this.progressHomes[selector].nextSibling);
    }, this);
  };

  Controller.prototype.leaveOfferWords = function () {
    var arm = (this.sheet.dataset && this.sheet.dataset.rewardArm) || this.assignedRewardArm(this.me);
    if (arm === 'free_delivery') return 'free delivery';
    if (arm === 'pct10' || arm === 'pct30') return rewardArmPercent(arm) + '% off';
    return '';
  };

  function prefersReducedMotion() {
    try { return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) { return false; }
  }

  // Positive feedback each time a date lands: the bar slides to n/3 and the
  // count pulses with a tick. Confetti only on the third date.
  // Shared with the Reminders landing page (assets/fb-reminders-landing.js):
  // one pulse and one confetti, so the page and the sheet never drift apart.
  function pulseProgress(block) {
    if (!block || !block.classList || prefersReducedMotion()) return;
    block.classList.remove('is-advanced'); void block.offsetWidth; block.classList.add('is-advanced');
    root.setTimeout(function () { block.classList.remove('is-advanced'); }, 1200);
  }

  function throwConfetti() {
    if (prefersReducedMotion() || typeof document.createElement !== 'function' || !document.body || typeof document.body.appendChild !== 'function') return;
    var layer = document.createElement('div');
    layer.className = 'fb-reminders-confetti';
    layer.setAttribute('aria-hidden', 'true');
    // Classic bright party confetti, with a few brand-maroon pieces (2 in 12).
    var colours = ['#FFD23F', '#2D9CDB', '#EB3B3B', '#3CC47C', '#FF5FA2', '#4a1828', '#FFD23F', '#2D9CDB', '#EB3B3B', '#3CC47C', '#FF5FA2', '#4a1828'];
    for (var i = 0; i < 70; i++) {
      var piece = document.createElement('i');
      piece.style.left = (Math.random() * 100) + '%';
      piece.style.background = colours[i % colours.length];
      piece.style.animationDelay = (Math.random() * 0.35) + 's';
      piece.style.animationDuration = (1.4 + Math.random() * 1.1) + 's';
      piece.style.setProperty('--fb-confetti-x', (Math.random() * 160 - 80) + 'px');
      piece.style.setProperty('--fb-confetti-r', (Math.random() * 720 - 360) + 'deg');
      layer.appendChild(piece);
    }
    document.body.appendChild(layer);
    root.setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 3000);
  }

  // Positive feedback each time a date lands: the bar slides to n/3 and the
  // count pulses with a tick. Confetti only on the third date.
  Controller.prototype.celebrateProgress = function (count, offer) {
    var last = this.lastProgressCount;
    this.lastProgressCount = count;
    if (last == null || count <= last) return;
    trackReminderEvent('reminder_sheet_progress', 'sheet', 'capture', { dates_count: count });
    pulseProgress(this.sheet.querySelector(offer ? '[data-reminders-reward-banner]' : '[data-reminders-batch-progress]'));
    if (count >= 3) this.throwConfetti();
  };

  Controller.prototype.throwConfetti = function () { throwConfetti(); };

  Controller.prototype.close = function (force, method) {
    if (this.sheet.hidden) return;
    var closeCount = this.guestDatesCount();
    // Daniel's redesign: the X is the only exit, and before the third date
    // it asks once whether they really want to give up the offer.
    if (!force && this.sheet.dataset && this.sheet.dataset.state === 'capture' && this.guestBatchJourney() && !this.checkoutOpener && !this.birthdayInvitationToken && !(this.me && this.me.signedIn) && closeCount < 3 && this.leaveOfferWords()) {
      this.retainCaptureDraft();
      this.exitReturnState = 'capture'; this.leavePrompt = true;
      trackReminderEvent('reminder_sheet_leave_prompt', 'sheet', 'capture', { dates_count: closeCount, choice: 'shown' });
      this.show('batch-exit'); return;
    }
    this.batchHint = '';
    if (this.sheet.dataset && this.sheet.dataset.state === 'capture') this.retainCaptureDraft();
    var state = this.sheet.dataset && this.sheet.dataset.state;
    if (!force && this.assignedRewardArm(this.me) !== 'none' && !this.requestingIdentity && !this.verifyingIdentity && !this.savingBatch && state !== 'batch-exit' && ['capture', 'identify', 'verify', 'batch-review'].indexOf(state) >= 0 && !this.checkoutOpener && !this.birthdayInvitationToken && (this.batchDraft() || (this.guestBatchJourney() && this.captureDraft()))) {
      // The checkout detour closes in one tap, back to the cart: queued and
      // unfinished entries stay in this tab's session either way.
      this.exitReturnState = state; this.show('batch-exit'); return;
    }
    if (!force || method) trackReminderEvent('reminder_sheet_closed', 'sheet', (this.sheet.dataset && this.sheet.dataset.state) || 'unknown', { method: method || 'x', dates_count: closeCount });
    this.opening = (this.opening || 0) + 1;
    this.sheet.hidden = true;
    this.renderDrawerReward(null);
    document.body.classList.remove('modal-open');
    document.querySelectorAll('[data-fb-reminders-open]').forEach(function (entry) { entry.setAttribute('aria-expanded', 'false'); });
    var restoredDrawer = this.restoreBackground();
    if (typeof root.removeTrapFocus === 'function') root.removeTrapFocus(this.opener);
    else if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    if (restoredDrawer && typeof root.trapFocus === 'function') root.trapFocus(restoredDrawer, this.opener && this.opener.isConnected ? this.opener : restoredDrawer);
    // The welcome pill (fb-reminders-welcome.js) re-reads /me after a save.
    // Changed once per save: savedOccasion outlives this close off the list page.
    var changed = !!this.preferencesChanged || (!!this.savedOccasion && this.savedOccasion !== this.announcedSave);
    this.announcedSave = this.savedOccasion;
    if (typeof root.CustomEvent === 'function') document.dispatchEvent(new root.CustomEvent('fb-reminders:closed', { detail: { changed: changed } }));
    if (pageController && resolveView(root.location.search) === 'link') { pageController.api.clearMe(); pageController.showLink(parseParams(root.location.search).r); }
    /* The list and the person view both show saved reminders, so both re-read
       them after a save: otherwise a reminder added from the person view's
       "Add another occasion" or "More occasions" would not appear, and its
       chip would still be offered, until a reload. */
    var view = resolveView(root.location.search);
    if ((this.savedOccasion || this.preferencesChanged) && pageController && (view === 'list' || view === 'friend')) {
      this.savedOccasion = null; this.preferencesChanged = false; pageController.api.clearMe();
      if (view === 'friend') pageController.showFriend(parseParams(root.location.search).id);
      else pageController.showList();
    }
  };

  Controller.prototype.suspendBackground = function () {
    if (this.background || !document.body.children) return;
    var sheet = this.sheet;
    this.background = [];
    Array.from(document.body.children).forEach(function (node) {
      if (node === sheet || node.contains(sheet) || /^(SCRIPT|STYLE|LINK)$/.test(node.tagName)) return;
      this.background.push({ node: node, inert: node.inert });
      node.inert = true;
    }, this);
    this.suspendedDialogs = [];
    document.querySelectorAll('[aria-modal="true"]').forEach(function (node) {
      if (sheet.contains(node)) return;
      this.suspendedDialogs.push(node);
      node.setAttribute('aria-modal', 'false');
    }, this);
    var drawer = document.getElementById('offcanvas__mini_cart');
    if (drawer && drawer.classList.contains('active')) {
      this.cartDrawer = drawer;
      this.cartOverlay = document.body.classList.contains('added__overlay');
      drawer.classList.add('fb-reminders-suspended');
      document.body.classList.remove('added__overlay');
    }
  };

  Controller.prototype.restoreBackground = function () {
    (this.background || []).forEach(function (entry) { entry.node.inert = entry.inert; });
    this.background = null;
    (this.suspendedDialogs || []).forEach(function (node) { if (node.isConnected) node.setAttribute('aria-modal', 'true'); });
    this.suspendedDialogs = null;
    var drawer = this.cartDrawer;
    if (drawer) {
      drawer.classList.remove('fb-reminders-suspended');
      if (drawer.isConnected && drawer.classList.contains('active')) {
        if (this.cartOverlay) document.body.classList.add('added__overlay');
        this.cartDrawer = null;
        return drawer;
      }
    }
    this.cartDrawer = null;
  };

  Controller.prototype.retainCaptureDraft = function () {
    if (this.savingCapture) return;
    var values = this.captureValues();
    if (!values.name && (!values.type || values.type === this.captureDefaultType) && !values.month && !values.day && !values._unknownDate) { clearDraft(); this.pendingDraft = null; return; }
    if (!this.pendingDraft) trackReminderEvent('reminder_draft_started', 'sheet', 'capture', null);
    values.defaultType = this.captureDefaultType;
    this.pendingDraft = writeDraft(values);
  };

  Controller.prototype.captureDraft = function () {
    if (this.pendingDraft && this.pendingDraft.createdAt + DRAFT_TTL <= Date.now()) this.pendingDraft = null;
    return this.pendingDraft || readDraft();
  };

  Controller.prototype.guestBatchJourney = function () {
    return !(this.me && this.me.signedIn) && !!(this.rewardJourney || this.batchJourney);
  };

  Controller.prototype.batchDraft = function () {
    if (this.pendingBatch && this.pendingBatch.createdAt + DRAFT_TTL <= Date.now()) { this.pendingBatch = null; storeBatch(null); }
    return this.pendingBatch || (this.pendingBatch = readBatch());
  };

  Controller.prototype.queueCapture = function (draft) {
    var batch = this.batchDraft();
    if (!batch) { batch = { people: [], createdAt: Date.now() }; this.batchSaved = []; this.batchExisting = []; this.batchFinished = false; }
    var index = Number.isInteger(batch.editingIndex) ? batch.editingIndex : -1;
    if (batch.people.some(function (p, i) { return i !== index && sameDraftPerson(p, draft); })) {
      this.sheet.querySelector('[data-reminders-capture-error]').textContent = 'That person and occasion are already in your reminders below. Add a different occasion or person.';
      return false;
    }
    if (index < 0 && batch.people.length >= 100) {
      this.sheet.querySelector('[data-reminders-capture-error]').textContent = 'You have 100 reminders ready. Save your progress before adding more.';
      return false;
    }
    if (index >= 0) batch.people[index] = draft; else batch.people.push(draft);
    this.lastQueuedCapture = draft;
    delete batch.editingIndex;
    this.pendingBatch = batch;
    clearDraft(); this.pendingDraft = null;
    if (batch.workingDraft) { this.pendingDraft = writeDraft(batch.workingDraft); delete batch.workingDraft; }
    storeBatch(batch);
    return true;
  };

  Controller.prototype.editBatch = function (index) {
    if (this.requestingIdentity || this.verifyingIdentity || this.savingBatch) return;
    this.batchHint = '';
    var batch = this.batchDraft();
    if (!batch || !batch.people[index]) return;
    if (!Number.isInteger(batch.editingIndex)) batch.workingDraft = this.captureDraft();
    batch.editingIndex = index; storeBatch(batch);
    this.pendingDraft = writeDraft(batch.people[index]);
    this.beginCapture({}, true);
  };

  Controller.prototype.finishGuestAdd = function () {
    if (this.requestingIdentity || this.verifyingIdentity || this.savingBatch || this.savingCapture) return;
    if (this.checkoutOpener || !this.guestBatchJourney()) return;
    var values = this.captureValues();
    if (!this.validateCapture(values)) {
      values.defaultType = this.captureDefaultType;
      this.pendingDraft = writeDraft(values);
    }
    this.startBatchSave();
  };

  Controller.prototype.startBatchSave = function () {
    if (this.requestingIdentity || this.verifyingIdentity || this.savingBatch) return;
    var draft = this.captureDraft(), batch = this.batchDraft();
    if (batch && Number.isInteger(batch.editingIndex)) {
      var editError = draft && this.validateCapture(Object.assign({}, draft, { _unknownDate: draft.unknownDate === true }));
      if (!draft || editError) {
        this.restoreDraftToForm(); this.show('capture');
        if (editError) { this.sheet.querySelector('[data-reminders-capture-error]').textContent = editError.message; this.markCaptureError(editError.field); }
        return;
      }
    }
    // An unfinished next entry is retained separately. It must not prevent
    // saving earlier complete entries, nor be silently submitted as valid.
    if (draft && (!batch || batch.people.length < 100 || Number.isInteger(batch.editingIndex)) && !this.validateCapture(Object.assign({}, draft, { _unknownDate: draft.unknownDate === true }))) {
      if (!this.queueCapture(draft)) { this.show('capture'); return; }
      batch = this.batchDraft();
    }
    if (!batch) { this.beginCapture({}, true); return; }
    if (this.me && this.me.signedIn) return this.saveSignedInBatch();
    this.captureAuth = true; this.setIdentityMode('email'); this.show('identify');
  };

  Controller.prototype.acceptBatchResults = function (response) {
    var batch = this.batchDraft();
    if (!batch) return;
    var saved = (response.saved || []).filter(function (p) { return p && p.id; });
    this.batchSaved = (this.batchSaved || []).concat(saved);
    batch.people = batch.people.filter(function (p) { return !saved.some(function (s) { return sameDraftPerson(p, s); }); });
    delete batch.editingIndex;
    this.batchDuplicates = response.duplicates || [];
    this.pendingBatch = batch.people.length ? batch : null; storeBatch(this.pendingBatch);
    if (!batch.people.length) return this.finishBatch();
    this.show('batch-review');
  };

  Controller.prototype.saveSignedInBatch = async function (confirmNew) {
    if (this.savingBatch) return;
    var batch = this.batchDraft();
    if (!batch) return;
    this.savingBatch = true;
    this.show('batch-review');
    var errorNode = this.sheet.querySelector('[data-reminders-batch-error]');
    if (errorNode) errorNode.textContent = '';
    try {
      while ((batch = this.batchDraft())) {
        var draft = batch.people[0], invalid = this.validateCapture(Object.assign({}, draft, { _unknownDate: draft.unknownDate === true }));
        if (invalid) { this.savingBatch = false; this.editBatch(0); return; }
        var values = apiDraft(draft).people[0];
        values.source = draft.source || 'theme_sheet';
        if (confirmNew && !values.friendId) values.confirmNew = true;
        confirmNew = false;
        var response = await this.api.createOccasion(values);
        var saved = response && (response.occasion || response.saved && response.saved[0]);
        if (!saved || !saved.id) throw { code: 'REQUEST_FAILED' };
        this.acceptBatchResults({ saved: [saved] });
      }
    } catch (error) {
      if (error.code === 'UNAUTHENTICATED') { this.me = { signedIn: false }; this.captureAuth = true; this.setIdentityMode('email'); this.show('identify'); }
      else {
        this.batchDuplicates = error.code === 'DUPLICATE' && error.payload && error.payload.existing ? [error.payload.existing] : [];
        this.show('batch-review');
        if (errorNode && !this.batchDuplicates.length) errorNode.textContent = this.sheet.dataset.saveError || this.sheet.dataset.unavailable;
      }
    } finally { this.savingBatch = false; this.renderBatch(); }
  };

  Controller.prototype.keepBatchExisting = function () {
    if (this.savingBatch) return;
    var batch = this.batchDraft(), draft = batch && batch.people[0];
    var existing = draft && (this.batchDuplicates || []).find(function (p) { return p.id && sameDraftPerson(draft, p); });
    if (!existing) return;
    this.batchExisting = (this.batchExisting || []).concat([existing]);
    batch.people.shift(); this.pendingBatch = batch.people.length ? batch : null; storeBatch(this.pendingBatch);
    if (!this.pendingBatch) return this.finishBatch();
    this.show('batch-review');
  };

  Controller.prototype.finishBatch = function () {
    var records = (this.batchSaved || []).concat(this.batchExisting || []);
    if (!records.length) return;
    // Just verified a guest batch: welcome them, then ask about the newsletter.
    var welcomed = !!this.captureAuth && !this.groupAuth && !this.groupInvitationToken;
    this.keepPostedPending = welcomed;
    this.captureAuth = false; this.api.clearMe();
    this.showSaved(records[0]);
    (this.batchSaved || []).forEach(function (occasion) {
      this.trackedSaves = this.trackedSaves || new Set();
      if (!this.trackedSaves.has(occasion.id)) { this.trackedSaves.add(occasion.id); trackReminderEvent('occasion_saved', 'sheet', 'saved', { occasion_id: occasion.id }); }
    }, this);
    if (records.length === 1 && this.invitationMode) return;
    this.invitationMode = false; this.sheet.dataset.birthdayInvitation = 'false';
    var summary = this.sheet.querySelector('[data-reminders-saved-summary]');
    if (summary) summary.textContent = (this.batchSaved || []).length + ' reminder' + ((this.batchSaved || []).length === 1 ? '' : 's') + ' saved.' + (this.batchExisting && this.batchExisting.length ? ' ' + this.batchExisting.length + ' existing reminder' + (this.batchExisting.length === 1 ? '' : 's') + ' kept.' : '');
    ['[data-reminders-share-block]', '[data-reminders-saved-shop]', '[data-reminders-saved-flowers]', '[data-reminders-more]'].forEach(function (selector) { var node = this.sheet.querySelector(selector); if (node) node.hidden = true; }, this);
    this.batchFinished = true;
    this.sheet.dataset.batchSaved = 'true';
    var title = this.sheet.querySelector('#fb-reminders-title');
    if (title) title.textContent = records.length === 1 ? 'Your reminder is saved' : 'Your reminders are saved';
    if (welcomed) {
      var savedHeading = this.sheet.querySelector('[data-reminders-saved-heading]');
      if (savedHeading) { savedHeading.textContent = 'You’re in!'; savedHeading.hidden = false; }
      this.showKeepPosted();
    }
  };

  // Post-verify newsletter ask; replaces the email-step opt-in (Oct 2026).
  Controller.prototype.showKeepPosted = function () {
    var section = this.sheet.querySelector('[data-reminders-keep-posted]');
    if (!section || !root.FBRemindersAPI || !root.FBRemindersAPI.keepPosted) return;
    var newsletter = this.sheet.querySelector('[data-reminders-newsletter]');
    if (newsletter) newsletter.hidden = true;
    root.FBRemindersAPI.keepPosted(section, this.api, function (name, props) { trackReminderEvent(name, 'sheet', 'saved', props || null); }).show();
  };

  Controller.prototype.renderBatch = function () {
    // Old cached markup can briefly load the new asset during a theme update.
    if (!this.sheet.querySelector('[data-reminders-batch-list]')) return;
    var batch = this.batchDraft(), state = this.sheet.dataset.state;
    var active = !!batch || this.guestBatchJourney();
    var offer = this.sheet.dataset.rewardJourney === 'true';
    if (!active && !this.batchRendered) { this.renderCaptureJourney(this.me); return; }
    this.batchRendered = true;
    this.sheet.dataset.batchCapture = active ? 'true' : 'false';
    var submit = this.sheet.querySelector('[data-reminders-capture] button[type="submit"]');
    // "Continue to save" only when this entry can complete the three dates:
    // an undated personal entry cannot, so it stays "Next reminder".
    var entry = active && state === 'capture' ? this.captureValues() : null;
    var entryCounts = !entry || !entry._unknownDate;
    if (submit) submit.textContent = active ? batch && Number.isInteger(batch.editingIndex) ? 'Update reminder' : qualifyingDraftCount(batch ? batch.people : []) >= 2 && entryCounts ? 'Done' : 'Continue' : words('save');
    var checkoutReturn = this.sheet.querySelector('[data-reminders-action="checkout-return"]');
    if (checkoutReturn) checkoutReturn.hidden = !(this.checkoutOpener && state === 'capture');
    var notNow = this.sheet.querySelector('[data-reminders-capture] [data-fb-reminders-close]');
    if (notNow) notNow.hidden = !!(this.checkoutOpener && state === 'capture');
    // "Next reminder" always starts another date. "I'm done" is the finish
    // path: a complete current entry is included, a blank or unfinished one
    // is not, and already queued dates go straight to sign-in.
    var done = this.sheet.querySelector('[data-reminders-action="batch-done"]');
    if (done) {
      var queued = !!(batch && batch.people.length);
      var currentReady = state === 'capture' && entry && !this.validateCapture(entry);
      done.hidden = !(state === 'capture' && this.guestBatchJourney() && !this.checkoutOpener && (queued || currentReady));
    }
    var summaries = this.sheet.querySelectorAll('[data-reminders-batch-summary]');
    summaries.forEach(function (node) {
      node.hidden = !batch || (state === 'identify' && !this.captureAuth); node.textContent = '';
      if (node.hidden) return;
      batch.people.forEach(function (p, i) {
        var row = element('li', 'fb-reminders-batch__row');
        row.appendChild(element('span', '', p.name + ' · ' + occasionName(p) + ' · ' + (p.unknownDate ? 'Date to add' : this.formatDate(p))));
        var edit = element('button', 'fb-reminders-text-action', 'Edit'); edit.type = 'button'; edit.dataset.remindersBatchEdit = String(i);
        edit.setAttribute('aria-label', 'Edit ' + p.name + ' — ' + occasionName(p));
        edit.disabled = !!(this.verifyingIdentity || this.requestingIdentity || this.savingBatch);
        row.appendChild(edit); node.appendChild(row);
      }, this);
    }, this);
    var identityTitle = this.sheet.querySelector('[data-reminders-state="identify"] h3');
    var identityBody = this.sheet.querySelector('[data-reminders-identity-body]');
    [identityTitle, identityBody].forEach(function (node) { if (node && !node.dataset.originalCopy) node.dataset.originalCopy = node.textContent; });
    var authenticating = !!batch && this.captureAuth && !this.pendingPreferences && !this.groupAuth && !this.groupInvitationToken;
    if (identityTitle) identityTitle.textContent = authenticating ? batch.people.length === 1 ? 'Save your reminder' : 'Save your ' + batch.people.length + ' reminders' : identityTitle.dataset.originalCopy;
    if (identityBody) identityBody.textContent = identityBody.dataset.originalCopy;
    this.applyEmailStep(authenticating);
    this.sheet.querySelectorAll('[data-reminders-state="identify"] [data-reminders-action="capture"], [data-reminders-state="verify"] [data-reminders-action="capture"]').forEach(function (button) {
      if (!button.dataset.originalCopy) button.dataset.originalCopy = button.textContent;
      button.textContent = authenticating ? (this.captureDraft() ? 'Continue unfinished reminder' : 'Add another reminder') : button.dataset.originalCopy;
    }, this);
    var exitCopy = this.sheet.querySelector('[data-reminders-batch-exit-copy]');
    if (exitCopy) exitCopy.textContent = batch ? 'You have ' + batch.people.length + ' reminder' + (batch.people.length === 1 ? '' : 's') + ' ready. Save your progress now, or keep adding dates' + (offer ? ' to reach your offer.' : '.') : 'Keep going to finish your reminder, or return to shopping. Your draft stays in this tab for up to 24 hours.';
    var exitHeading = this.sheet.querySelector('[data-reminders-batch-exit-heading]');
    var exitSave = this.sheet.querySelector('[data-reminders-state="batch-exit"] [data-reminders-action="batch-save"]');
    var exitLeave = this.sheet.querySelector('[data-reminders-state="batch-exit"] [data-reminders-action="batch-leave"]');
    var exitHelper = this.sheet.querySelector('[data-reminders-batch-exit-helper]');
    var exitContinue = this.sheet.querySelector('[data-reminders-action="batch-continue"]');
    if (this.leavePrompt) {
      var offerWords = this.leaveOfferWords();
      if (exitHeading) exitHeading.textContent = 'Are you sure?';
      if (exitCopy) exitCopy.textContent = this.leaveConfirmCopy(this.guestDatesCount());
      if (exitContinue) exitContinue.textContent = 'Keep my ' + offerWords;
      if (exitLeave) exitLeave.textContent = offerWords === 'free delivery' ? 'Pay for delivery' : 'Pay full price';
      if (exitSave) exitSave.hidden = true;
      if (exitHelper) exitHelper.hidden = true;
    } else {
      if (exitHeading) exitHeading.textContent = 'Keep the dates that matter.';
      if (exitLeave) exitLeave.textContent = 'Continue shopping';
      if (exitSave) exitSave.hidden = false;
      if (exitHelper) exitHelper.hidden = false;
    }
    if (exitContinue && !this.leavePrompt) exitContinue.textContent = this.exitReturnState === 'verify' ? 'Continue verifying' : this.exitReturnState === 'identify' ? 'Continue saving' : this.exitReturnState === 'batch-review' ? 'Review remaining reminders' : 'Keep adding reminders';
    var review = this.sheet.querySelector('[data-reminders-batch-conflict]');
    var first = batch && batch.people[0];
    var duplicate = first && (this.batchDuplicates || []).find(function (p) { return p.id && sameDraftPerson(first, p); });
    if (review) {
      review.hidden = !duplicate;
      var detail = review.querySelector('p');
      if (duplicate) detail.textContent = first.name + ' — ' + occasionName(first) + ' is already on your account (' + this.formatDate(duplicate.date || duplicate) + '). You entered ' + (first.unknownDate ? 'no date' : this.formatDate(first)) + '. Keep the existing reminder, or save this as a different person.';
      var different = review.querySelector('[data-reminders-action="batch-confirm-new"]'); if (different) different.hidden = !!(first && first.friendId);
    }
    var retry = this.sheet.querySelector('[data-reminders-action="batch-retry"]'); if (retry) retry.hidden = !!duplicate;
    this.sheet.querySelectorAll('[data-reminders-state="batch-review"] button').forEach(function (button) { disableControl(button, !!this.savingBatch); }, this);
    var draftDetail = this.sheet.querySelector('[data-reminders-batch-list]'); if (draftDetail) draftDetail.hidden = !batch;
    // Offer entry points show progress in the offer banner. Every other guest
    // entry point gets the same honest progress without the offer.
    var neutral = this.sheet.querySelector('[data-reminders-batch-progress]');
    if (neutral) neutral.hidden = !(active && (state === 'capture' || (state === 'identify' && this.emailHierarchy)) && !offer);
    var lead = this.sheet.querySelector('[data-reminders-batch-lead]'); if (lead) lead.textContent = 'Add 3 dates for ' + this.leaveOfferWords();
    if (active && !(this.me && this.me.signedIn) && ['capture', 'identify', 'verify', 'batch-exit'].indexOf(state) >= 0) {
      var meter = this.sheet.querySelector(offer ? '[data-reminders-reward-meter]' : '[data-reminders-batch-meter]'), countNode = this.sheet.querySelector(offer ? '[data-reminders-reward-count]' : '[data-reminders-batch-count]');
      var count = qualifyingDraftCount(batch ? batch.people : []);
      // Completed guest entries are drafts until verification saves them.
      var status = (this.sheet.dataset.journeyAdded || '__COUNT__ of __TOTAL__ added').replace('__COUNT__', String(count)).replace('__TOTAL__', '3');
      // One line, only right after an entry that leaves the count unchanged.
      var hint = this.batchHint === 'unknown' ? this.sheet.dataset.rewardUnknown : this.batchHint === 'holiday' ? this.sheet.dataset.rewardHoliday : '';
      if (meter) { meter.hidden = false; meter.value = Math.min(3, count); meter.max = 3; meter.setAttribute('aria-label', status); }
      var tick = this.sheet.querySelector('[data-reminders-batch-tick]'); if (tick) tick.hidden = count < 1;
      this.celebrateProgress(count, offer);
      if (countNode) countNode.textContent = status + (hint && count < 3 ? '. ' + hint : '');
    }
    this.renderCaptureJourney(this.me);
  };

  // Percentage offers and their size (10% from 12 Oct 2026; issued 30%
  // codes keep 30%). Anyone without a code sees the offer /me names.
  var REWARD_PCT_ARMS = { pct30: 30, pct10: 10 };
  function isPctRewardArm(arm) { return typeof arm === 'string' && Object.prototype.hasOwnProperty.call(REWARD_PCT_ARMS, arm); }
  function rewardArmPercent(arm) { return isPctRewardArm(arm) ? REWARD_PCT_ARMS[arm] : REWARD_PCT_ARMS.pct10; }
  function fillRewardPercent(copy, arm) { return String(copy).replace(/\[percent\]/g, String(rewardArmPercent(arm))); }

  function quietMemberRewardArm(arm) {
    return typeof arm === 'string' && arm && !isPctRewardArm(arm) && arm !== 'free_delivery' && arm !== 'none' && arm !== 'off';
  }
  Controller.prototype.assignedRewardArm = function (me) {
    var reward = me && me.signedIn && me.member && me.member.datesReward;
    if (reward && quietMemberRewardArm(reward.arm)) return '';
    if (reward && ['pending', 'earned', 'redeemed', 'expired'].indexOf(reward.status) >= 0) {
      return isPctRewardArm(reward.arm) ? reward.arm : 'free_delivery';
    }
    var offered = reward ? reward.arm : me && me.signedIn === false ? me.rewardOfferArm : null;
    var source = reward || (me && me.signedIn === false ? me : null);
    var key = reward ? 'arm' : 'rewardOfferArm';
    if (source && Object.prototype.hasOwnProperty.call(source, key) && (offered === null || offered === 'none' || offered === 'off')) return 'none';
    if (reward && typeof reward.arm === 'string' && reward.arm && !isPctRewardArm(reward.arm)) return '';
    return isPctRewardArm(offered) ? offered : 'pct10';
  };

  Controller.prototype.renderCaptureJourney = function (me) {
    var data = this.sheet.dataset, state = data.state;
    if (this.invitationMode && state === 'saved') return;
    var offer = data.rewardJourney === 'true', signedIn = !!(me && me.signedIn);
    var notNow = this.sheet.querySelector('[data-reminders-capture] [data-fb-reminders-close]');
    if (notNow) notNow.hidden = offer || !!(this.checkoutOpener && state === 'capture');
    var done = this.sheet.querySelector('[data-reminders-action="batch-done"]');
    if (done && offer) done.hidden = true;
    var batch = this.batchDraft(), reward = me && me.member && me.member.datesReward;
    var count = signedIn ? reward && Number.isInteger(reward.dated) ? reward.dated : null : qualifyingDraftCount(batch ? batch.people : []);
    var total = signedIn && reward && Number.isInteger(reward.threshold) && reward.threshold > 0 ? reward.threshold : 3;
    if (signedIn && (this.rewardChecking || this.rewardProgressUnavailable)) count = null;
    var editing = batch && Number.isInteger(batch.editingIndex);
    var progressing = offer && count != null && count < total && !(reward && ['pending', 'earned'].indexOf(reward.status) >= 0);
    var oneMore = progressing && count === total - 1;
    var pct = isPctRewardArm(data.rewardArm);
    var next = oneMore ? pct ? fillRewardPercent(data.journeyOneMorePct || 'One more date unlocks [percent]% off', data.rewardArm) : data.journeyOneMoreFree || 'One more date unlocks free delivery' : data.journeyNext || 'Who else would you love to remember?';
    this.captureJourneyTitle = progressing && !editing ? count === 0 ? data.journeyFirst || 'Whose birthday comes to mind?' : next : null;
    var title = this.sheet.querySelector('#fb-reminders-title');
    if (state === 'capture' && title && this.captureJourneyTitle) title.textContent = this.captureJourneyTitle;
    var acknowledgement = this.sheet.querySelector('[data-reminders-journey-acknowledgement]');
    if (acknowledgement) {
      var last = batch && (this.lastQueuedCapture || batch.people[batch.people.length - 1]);
      acknowledgement.hidden = !(offer && !signedIn && state === 'capture' && !editing && last);
      acknowledgement.textContent = '';
      if (!acknowledgement.hidden) {
        var details = { NAME: last.name, OCCASION: occasionName(last), DATE: last.unknownDate ? data.dateNeeded || 'Date to add' : this.formatDate(last) };
        acknowledgement.textContent = (data.journeyAcknowledgement || '__NAME__ · __OCCASION__ · __DATE__ added.').replace(/__(NAME|OCCASION|DATE)__/g, function (_, key) { return details[key]; });
      }
    }
    var nextPrompt = this.sheet.querySelector('[data-reminders-journey-next]');
    if (nextPrompt) { nextPrompt.hidden = !(progressing && state === 'saved'); nextPrompt.textContent = next; }
    var verification = this.sheet.querySelector('[data-reminders-journey-verification]');
    if (verification) {
      verification.hidden = !(offer && !signedIn && ['capture', 'identify', 'verify'].indexOf(state) >= 0);
      verification.textContent = count >= total - 1 ? data.journeyVerification || 'Verify once to save your dates and claim your reward.' : data.journeySteps || 'Add 3 dates, then verify once.';
    }
    var condition = this.sheet.querySelector('[data-reminders-reward-condition]');
    if (condition) condition.hidden = this.assignedRewardArm(me) === 'none' || !signedIn || !!(reward && ['pending', 'earned'].indexOf(reward.status) >= 0);
    var form = this.sheet.querySelector('[data-reminders-capture]');
    var submit = this.sheet.querySelector('[data-reminders-capture] button[type="submit"]');
    if (offer && form && submit && !this.savingCapture) {
      var entry = this.captureValues();
      var entryCounts = !entry._unknownDate;
      submit.textContent = editing ? 'Update reminder' : oneMore && entryCounts ? pct ? fillRewardPercent(data.journeyUnlockPct || 'Unlock my [percent]% off', data.rewardArm) : data.journeyUnlockFree || 'Unlock my free delivery' : signedIn ? words('save') : data.journeyAddDate || 'Add this date';
    }
    var authenticating = offer && !signedIn && batch && count >= total && this.captureAuth && !this.pendingPreferences && !this.groupAuth && !this.groupInvitationToken;
    if (authenticating) {
      var identityTitle = this.sheet.querySelector('[data-reminders-state="identify"] h3');
      var identityBody = this.sheet.querySelector('[data-reminders-identity-body]');
      [identityTitle, identityBody].forEach(function (node) { if (node && node.dataset.originalCopy == null) node.dataset.originalCopy = node.textContent; });
      if (identityTitle) identityTitle.textContent = pct ? fillRewardPercent(data.journeyVerifyPct || 'Verify to unlock your [percent]% off', data.rewardArm) : data.journeyVerifyFree || 'Verify to unlock your free delivery';
      this.applyEmailStep(true);
    }
  };

  Controller.prototype.show = function (name) {
    var captureLogin = this.sheet.querySelector('[data-reminders-capture-login]');
    if (captureLogin) captureLogin.hidden = name !== 'capture' || !!(this.me && this.me.signedIn);
    var draftNote = this.sheet.querySelector('[data-reminders-draft-note]');
    if (draftNote) draftNote.hidden = !this.resumingDraft;
    this.sheet.querySelectorAll('[data-reminders-state]').forEach(function (state) {
      var active = state.dataset.remindersState === name;
      state.hidden = !active;
      state.querySelectorAll('button, input, select, textarea').forEach(function (control) {
        if (!active) {
          if (!control.hasAttribute('data-fb-reminders-was-disabled')) {
            control.setAttribute('data-fb-reminders-was-disabled', control.disabled ? 'true' : 'false');
          }
          control.disabled = true;
        } else if (control.hasAttribute('data-fb-reminders-was-disabled')) {
          control.disabled = control.getAttribute('data-fb-reminders-was-disabled') === 'true';
          control.removeAttribute('data-fb-reminders-was-disabled');
        }
      });
      state.querySelectorAll('a[href], [data-fb-reminders-href]').forEach(function (link) {
        if (!active && link.hasAttribute('href')) {
          link.setAttribute('data-fb-reminders-href', link.getAttribute('href'));
          link.removeAttribute('href');
        } else if (active && link.hasAttribute('data-fb-reminders-href')) {
          // Rendering may have assigned a new person/occasion while this
          // state was hidden. Restore only an unchanged, suspended link.
          if (!link.hasAttribute('href')) link.setAttribute('href', link.getAttribute('data-fb-reminders-href'));
          link.removeAttribute('data-fb-reminders-href');
        }
      });
    });
    this.sheet.dataset.state = name;
    if (name !== 'preview') this.renderDrawerReward(null);
    var continuation = this.sheet.querySelector('[data-reminders-action="continue-shopping"]');
    if (continuation) { if (!this.shoppingLabel) this.shoppingLabel = continuation.textContent; continuation.textContent = this.checkoutOpener ? 'Continue to checkout' : this.shoppingLabel; }
    this.renderRewardJourney(this.me);
    this.renderBatch();
    var dialogTitle = this.sheet.querySelector('#fb-reminders-title');
    var heading = this.sheet.querySelector('[data-reminders-state="' + name + '"] h3');
    if (dialogTitle) dialogTitle.textContent = name === 'empty' ? this.sheet.dataset.title || 'Reminders' : name === 'capture' ? this.captureJourneyTitle || (this.resumingDraft ? this.sheet.dataset.resumeTitle : this.sheet.dataset.captureTitle) || words('add') : heading ? heading.textContent : words('add');
    // The panel header already names the active view. Keep its body heading
    // only when it says something different, as on the empty view.
    if (name === 'checkout-offer' && dialogTitle) dialogTitle.textContent = 'Your reminder reward';
    if (heading) {
      heading.hidden = Boolean(dialogTitle && dialogTitle.textContent === heading.textContent);
      if (!heading.hidden) heading.setAttribute('tabindex', '-1');
    }
    if (!this.sheet.hidden) {
      // Each step starts with its context and progress in view, even when the
      // previous form's submit button was below the fold on a small screen.
      var body = this.sheet.querySelector('.fb-reminders-sheet__body');
      if (body) body.scrollTop = 0;
      var mobileCapture = name === 'capture' && root.matchMedia && root.matchMedia('(max-width: 768px)').matches;
      var focusTarget = heading && !heading.hidden ? heading : dialogTitle || this.sheet.querySelector('[data-fb-reminders-close]');
      if (name === 'capture' && !mobileCapture) focusTarget = this.sheet.querySelector('[name="name"]');
      if (typeof root.trapFocus === 'function') root.trapFocus(this.panel, focusTarget);
      else if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    }
  };

  /* People already on the occasions list, one row per friend. Name only:
     occasion type is not stored, and note bodies are not read. */
  function uniqueFriends(occasions) {
    var seen = Object.create(null);
    var friends = [];
    (occasions || []).forEach(function (occasion) {
      if (!occasion || occasion.friendId == null || occasion.friendId === '') return;
      var id = String(occasion.friendId);
      if (seen[id]) return;
      var name = String(occasion.name || '').replace(/\s+/g, ' ').trim();
      if (!name) return;
      seen[id] = true;
      friends.push({ id: id, name: name });
    });
    return friends;
  }

  function friendNameMatches(name, query) {
    var needle = String(query || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!needle) return false;
    return String(name || '').replace(/\s+/g, ' ').trim().toLowerCase().indexOf(needle) !== -1;
  }

  Controller.prototype.trackSearchedPerson = function (friendId) {
    var ids = { source: 'drawer_search' };
    if (friendId) ids.friend_id = String(friendId);
    trackReminderEvent('reminders_person_opened', 'sheet', 'sheet', ids);
  };

  Controller.prototype.renderPersonSearch = function () {
    var input = this.sheet.querySelector('[data-reminders-person-query]');
    var results = this.sheet.querySelector('[data-reminders-person-results]');
    var empty = this.sheet.querySelector('[data-reminders-person-empty]');
    if (!input || !results) return;
    var needle = String(input.value || '').replace(/\s+/g, ' ').trim();
    var loaded = this.previewFriendsLoaded === true;
    var matches = needle && loaded ? (this.previewFriends || []).filter(function (friend) {
      return friendNameMatches(friend.name, needle);
    }) : [];
    results.textContent = '';
    matches.forEach(function (friend) {
      var item = element('li');
      var link = element('a', 'fb-reminders-person-search__result', friend.name);
      link.href = pageUrl('/pages/reminders', 'friend', friend.id);
      link.setAttribute('data-reminders-person-result', '');
      link.setAttribute('data-reminders-friend-id', friend.id);
      item.appendChild(link);
      results.appendChild(item);
    });
    results.hidden = matches.length === 0;
    if (empty) empty.hidden = !(needle && loaded && matches.length === 0);
  };

  Controller.prototype.renderMe = function (me) {
    if (this.sheet.dataset.captureUtility === 'true' && (!me || !me.signedIn || !me.member || !me.member.counts || me.member.counts.people === 0)) {
      this.beginCapture({}, true); return;
    }
    if (!me || !me.signedIn || !me.member || !me.member.counts || me.member.counts.people === 0) {
      this.show('empty');
      return;
    }
    var next = me.member.next;
    if (!next) {
      this.show('empty');
      return;
    }
    var name = next.name || '';
    var date = next.date || (next.next && next.next.date) || '';
    this.sheet.querySelector('[data-reminders-next-name]').textContent = name + (next.type ? ' · ' + occasionName(next) : '');
    var days = next.daysUntil;
    var countdown = Number.isInteger(days) && days >= 0 ? (days === 0 ? words('today') : days === 1 ? words('tomorrow') : words('days', { DAYS: days })) : '';
    this.sheet.querySelector('[data-reminders-next-date]').textContent = this.formatDate(date) + (countdown ? ' · ' + countdown : '');
    var gift = this.sheet.querySelector('[data-reminders-gift-link]');
    gift.textContent = safeReplace(this.sheet.dataset.findGiftTemplate, '__NAME__', name);
    gift.href = next.occasionId ? pageUrl('/pages/reminders', 'person', next.occasionId) : (next.links && next.links.shop) || next.shopUrl || this.sheet.dataset.defaultGiftUrl;
    var personQuery = this.sheet.querySelector('[data-reminders-person-query]');
    if (personQuery) personQuery.value = '';
    this.previewFriends = [];
    this.previewFriendsLoaded = false;
    if (personQuery) this.renderPersonSearch();
    var viewAll = this.sheet.querySelector('[data-reminders-view-all]');
    if ((viewAll || personQuery) && this.api && typeof this.api.getOccasions === 'function') {
      var self = this;
      var generation = (this.previewPeopleRequest || 0) + 1;
      this.previewPeopleRequest = generation;
      this.api.getOccasions().then(function (response) {
        if (self.previewPeopleRequest !== generation) return;
        if (self.sheet.dataset.state !== 'preview') return;
        var occasions = response && response.occasions;
        if (!occasions) return;
        if (viewAll) viewAll.textContent = viewAll.dataset.label + ' (' + occasions.length + ')';
        self.previewFriends = uniqueFriends(occasions);
        self.previewFriendsLoaded = true;
        self.renderPersonSearch();
      }).catch(function () {});
    }
    this.show('preview');
    this.renderDrawerReward(me);
  };

  Controller.prototype.renderDrawerReward = function (me) {
    var card = this.sheet.querySelector('[data-reminders-drawer-reward]');
    if (!card) return;
    root.clearTimeout(this.drawerRewardTimer);
    this.drawerRewardTimer = null;
    this.drawerRewardMe = me;
    this.drawerRewardCode = null;
    var field = function (name) { return card.querySelector('[data-reminders-drawer-reward-' + name + ']'); };
    card.hidden = true;
    ['value', 'code', 'terms', 'expiry', 'status'].forEach(function (name) { field(name).textContent = ''; });
    field('copy').textContent = card.dataset.copy;
    field('shop').removeAttribute('href');
    field('shop').removeAttribute('data-fb-reminders-href');
    field('shop').removeAttribute('aria-label');
    if (this.sheet.hidden || this.sheet.dataset.state !== 'preview') return;
    var reward = me && me.signedIn === true && me.member && me.member.datesReward;
    if (!reward || quietMemberRewardArm(reward.arm) || reward.status !== 'earned' || typeof reward.code !== 'string' || !/^REMIND-[A-Za-z0-9]{4,32}$/.test(reward.code)) return;
    var expiry = reward.expiresAt ? Date.parse(reward.expiresAt) : null;
    if (expiry !== null && (!Number.isFinite(expiry) || expiry <= Date.now())) return;
    var percent = Number(reward.percentOff), minimum = Number(reward.minimumSubtotal);
    var values = {
      percent: Number.isFinite(percent) && percent > 0 ? percent : rewardArmPercent(reward.arm),
      minimum: Number.isFinite(minimum) && minimum > 0 ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(minimum) : null
    };
    /* minimumSubtotal 0 (new codes) shows no minimum; only an API value above 0 does. */
    var stripMinimum = function (copy) { return String(copy || '').replace(/ on (?:an order|orders) of \[minimum\] or more/g, '').replace(/ · \[minimum\]\+ on products/g, '').replace(/ · Orders \[minimum\]\+\./g, '.').replace(/[^.]*\[minimum\][^.]*\.?\s*/g, '').trim(); };
    var fill = function (copy) { if (values.minimum == null) copy = stripMinimum(copy); return String(copy || '').replace(/\[(percent|minimum|expiry)\]/g, function (_, key) { return values[key]; }); };
    var pct = isPctRewardArm(reward.arm);
    field('value').textContent = fill(pct ? card.dataset.pctValue : card.dataset.freeValue);
    field('terms').textContent = fill(pct ? card.dataset.pctTerms : card.dataset.freeTerms);
    field('code').textContent = reward.code;
    field('shop').setAttribute('aria-label', card.dataset.shopLabel + ': ' + field('value').textContent);
    field('shop').setAttribute('href', '/discount/' + encodeURIComponent(reward.code) + '?redirect=%2Fcollections%2Fflowers');
    this.drawerRewardCode = reward.code;
    card.hidden = false;
    if (expiry !== null) {
      values.expiry = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Australia/Melbourne' }).format(new Date(expiry));
      field('expiry').textContent = fill(card.dataset.expiry);
      var self = this;
      this.drawerRewardTimer = root.setTimeout(function () { self.renderDrawerReward(self.drawerRewardMe); }, Math.min(expiry - Date.now(), 2147483647));
    }
  };

  Controller.prototype.copyDrawerReward = async function () {
    this.renderDrawerReward(this.drawerRewardMe);
    var code = this.drawerRewardCode;
    if (!code) return;
    var card = this.sheet.querySelector('[data-reminders-drawer-reward]');
    var copied = false;
    try { await root.navigator.clipboard.writeText(code); copied = true; } catch (_) {}
    this.renderDrawerReward(this.drawerRewardMe);
    if (this.drawerRewardCode !== code) return;
    if (copied) card.querySelector('[data-reminders-drawer-reward-copy]').textContent = card.dataset.copied;
    card.querySelector('[data-reminders-drawer-reward-status]').textContent = copied ? card.dataset.copied : card.dataset.copyFailed;
  };

  Controller.prototype.updateDots = function (me) {
    var next = me && me.signedIn && me.member ? me.member.next : null;
    var outcome = next && (next.outcome || (next.next && next.next.outcome));
    var days = next && (next.daysUntil != null ? next.daysUntil : next.next && next.next.daysUntil);
    var visible = outcome === 'PENDING' && Number(days) >= 0 && Number(days) <= 30;
    document.querySelectorAll('[data-fb-reminders-dot]').forEach(function (dot) { dot.hidden = !visible; });
  };

  Controller.prototype.renderShortcuts = function () {
    var container = this.sheet.querySelector('[data-reminders-shortcuts]');
    if (!container) return;
    var self = this; container.textContent = '';
    // Every occasion type is a chip, Birthday first. No chip is pressed until
    // the customer picks one: the form opens with no occasion chosen.
    OCCASION_TYPES.forEach(function (type) {
      var button = occasionChip(type, words(type));
      button.dataset.shortcutType = type;
      button.addEventListener('click', function () {
        var form = self.sheet.querySelector('[data-reminders-capture]'); form.elements.type.value = type; syncDateForm(form);
        self.captureDefaultType = '';
        container.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
        self.retainCaptureDraft();
        self.renderBatch();
        form.elements.name.focus();
      }); container.appendChild(button);
    });
  };
  Controller.prototype.beginCapture = function (prefill, resume) {
    if (this.savingCapture) { this.show('capture'); return; }
    // Guest capture has one onboarding journey, including header and popup
    // links that do not carry an explicit offer-intent attribute.
    if (!this.me || !this.me.signedIn) this.batchJourney = true;
    this.captureAuth = false;
    this.preferencesIntent = null;
    this.pendingPreferences = null;
    trackReminderEvent('reminder_capture_opened', 'sheet', 'capture', null);
    prefill = prefill || {};
    this.captureDefaultType = '';
    var batch = this.batchDraft();
    if (resume && batch && this.me && this.me.signedIn && !this.captureDraft()) { this.show('batch-review'); return; }
    if (resume && batch && !this.captureDraft() && qualifyingDraftCount(batch.people) >= 3) { this.startBatchSave(); return; }
    if (resume && !prefill.remindersFriendId && !prefill.remindersName && !prefill.remindersMonth && !prefill.remindersDay && !prefill.remindersType && this.captureDraft()) { this.resumingDraft = true; this.restoreDraftToForm(); this.show('capture'); return; }
    var form = this.sheet.querySelector('[data-reminders-capture]');
    clearDraft(); this.pendingDraft = null; this.resumingDraft = false; form.reset(); form._dateType = null; form._dateUnknown = false; form._manualDates = {}; this.confirmNew = false;
    prefill = prefill || {};
    if (form.elements.friendId) form.elements.friendId.value = prefill.remindersFriendId || '';
    form.elements.name.value = prefill.remindersName || '';
    form.elements.name.readOnly = !!prefill.remindersFriendId;
    var reward = this.me && this.me.member && this.me.member.datesReward;
    var defaultBirthday = this.rewardJourney && this.assignedRewardArm(this.me) && !(this.me && this.me.signedIn && (!reward || reward.status !== 'locked'));
    this.captureDefaultType = defaultBirthday && OCCASION_TYPES.indexOf(prefill.remindersType) < 0 ? 'BIRTHDAY' : '';
    if (form.elements.type) form.elements.type.value = OCCASION_TYPES.indexOf(prefill.remindersType) >= 0 ? prefill.remindersType : defaultBirthday ? 'BIRTHDAY' : '';
    if (form.elements.label) form.elements.label.value = prefill.remindersLabel || '';
    form.elements.month.value = prefill.remindersMonth || '';
    form.elements.day.value = prefill.remindersDay || '';
    syncDateForm(form);
    this.sheet.querySelector('[data-reminders-capture-error]').textContent = '';
    this.markCaptureError(null);
    var duplicate = this.sheet.querySelector('[data-reminders-duplicate]'); if (duplicate) duplicate.hidden = true;
    this.show('capture');
  };
  Controller.prototype.action = function (action) {
    if (action === 'copy-drawer-reward') return this.copyDrawerReward();
    if (action === 'batch-done') return this.finishGuestAdd();
    if (action === 'batch-save') return this.startBatchSave();
    if (action === 'batch-continue' && this.leavePrompt) { this.leavePrompt = false; trackReminderEvent('reminder_sheet_leave_prompt', 'sheet', 'capture', { dates_count: this.guestDatesCount(), choice: 'keep_going' }); this.beginCapture({}, true); return; }
    if (action === 'batch-leave' && this.leavePrompt) { this.leavePrompt = false; trackReminderEvent('reminder_sheet_leave_prompt', 'sheet', 'capture', { dates_count: this.guestDatesCount(), choice: 'leave' }); return this.close(true, 'confirm_leave'); }
    if (action === 'batch-continue') { if (this.exitReturnState && this.exitReturnState !== 'capture') this.show(this.exitReturnState); else this.beginCapture({}, true); return; }
    if (action === 'batch-leave') return this.close(true, 'leave');
    if (action === 'batch-retry') return this.saveSignedInBatch();
    if (action === 'batch-keep-existing') return this.keepBatchExisting();
    if (action === 'batch-confirm-new') return this.saveSignedInBatch(true);
    if (action === 'checkout-accept') { this.rewardJourney = true; trackReminderEvent('reminder_checkout_offer_accepted', 'sheet', 'checkout-offer', null); return this.beginCapture({}, true); }
    if (action === 'checkout-continue') { trackReminderEvent('reminder_checkout_offer_declined', 'sheet', 'checkout-offer', null); return this.resumeCheckout(); }
    if (action === 'continue-shopping' && this.checkoutOpener) return this.resumeCheckout();
    if (action === 'checkout-return') return this.checkoutOpener ? this.resumeCheckout() : this.close(true);
    if (action === 'newsletter-subscribe') return this.subscribeNewsletter();
    if (action === 'continue-shopping') { trackReminderEvent('reminder_continue_shopping', 'sheet', 'saved', null); return this.close(); }
    if (action === 'retry-open') return this.open(this.opener);
    if (action === 'discard-draft') {
      var batch = this.batchDraft();
      if (batch) {
        var workingDraft = batch.workingDraft;
        delete batch.editingIndex; delete batch.workingDraft; storeBatch(batch);
        if (workingDraft) { this.pendingDraft = writeDraft(workingDraft); this.beginCapture({}, true); return; }
      }
      return this.beginCapture();
    }
    if (action === 'share-birthday' && this.invitationPanel) return this.invitationPanel.open();
    if (action === 'confirm-new') { this.confirmNew = true; this.sheet.querySelector('[data-reminders-capture]').requestSubmit(); return; }

    if (action === 'capture' || action === 'add-another') {
      if (action === 'add-another') return this.beginCapture({}, !!(this.batchFinished && this.captureDraft()));
      if (this.batchDraft() && !this.captureDraft()) return this.beginCapture();
      this.beginCapture({}, true);
    } else if (action === 'identify') {
      this.captureAuth = false;
      this.setIdentityMode('email');
      this.show('identify');
    } else if (action === 'resend') {
      this.resend();
    } else if (action === 'preferences') {
      this.loadPreferences();
    } else if (action === 'keep-off') {
      this.keepNotificationsOff();
    }
  };

  Controller.prototype.captureValues = function () {
    var form = this.sheet.querySelector('[data-reminders-capture]');
    var unknown = form.elements.unknownDate.checked;
    var type = form.elements.type ? form.elements.type.value : 'BIRTHDAY';
    return {
      name: form.elements.name.value.trim(),
      type: type,
      label: type === 'OTHER' && form.elements.label ? form.elements.label.value.trim() : undefined,
      friendId: form.elements.friendId && form.elements.friendId.value || undefined,
      confirmNew: this.confirmNew === true,
      month: unknown || !form.elements.month.value ? null : Number(form.elements.month.value),
      day: unknown || !form.elements.day.value ? null : Number(form.elements.day.value),
      year: null,
      source: 'theme_sheet',
      _unknownDate: unknown
    };
  };

  Controller.prototype.validateCapture = function (values) {
    if (!values.name) return { field: 'name', message: this.sheet.dataset.nameRequired };
    if (values.name.length > 80) return { field: 'name', message: this.sheet.dataset.nameLong };
    if (!values.type) return { field: 'type', message: this.sheet.dataset.occasionRequired };
    if (OCCASION_TYPES.indexOf(values.type) < 0) return { field: 'type', message: this.sheet.dataset.occasionRequired };
    var labelError = occasionLabelError(values.type, values.label, this.sheet.dataset);
    if (labelError) return { field: 'label', message: labelError };
    if (!values._unknownDate && !values.month) return { field: 'month', message: this.sheet.dataset.monthRequired || this.sheet.dataset.dateRequired };
    if (!values._unknownDate && !validDate(values.month, values.day)) return { field: 'day', message: this.sheet.dataset.dateRequired };
    if ((values.month === null) !== (values.day === null)) return { field: 'day', message: this.sheet.dataset.dateRequired };
    return null;
  };

  Controller.prototype.submitCapture = async function (event) {
    event.preventDefault();
    if (this.savingCapture) return;
    var errorNode = this.sheet.querySelector('[data-reminders-capture-error]');
    errorNode.textContent = '';
    var values = this.captureValues();
    var validation = this.validateCapture(values);
    this.markCaptureError(null);
    if (validation) {
      errorNode.textContent = validation.message;
      this.markCaptureError(validation.field);
      return;
    }
    trackReminderEvent('reminder_capture_submitted', 'sheet', 'capture', null);
    this.pendingDraft = writeDraft(values);
    if (this.guestBatchJourney() || this.batchDraft()) {
      var queued = this.pendingDraft;
      this.batchHint = '';
      if (!this.queueCapture(queued)) return;
      if (!qualifyingDraftCount([queued])) this.batchHint = 'unknown';
      if ((this.me && this.me.signedIn) || qualifyingDraftCount(this.batchDraft().people) >= 3) this.startBatchSave();
      else this.beginCapture({}, true);
      return;
    }
    delete values._unknownDate;
    if (!this.me || !this.me.signedIn) {
      this.captureAuth = true;
      this.setIdentityMode('email');
      this.show('identify');
      return;
    }
    try {
      this.savingCapture = true;
      var form = this.sheet.querySelector('[data-reminders-capture]');
      var saveButton = form.querySelector('button[type="submit"]');
      var saveLabel = saveButton.textContent;
      pendingForm(form, true);
      saveButton.disabled = true;
      saveButton.textContent = this.sheet.dataset.saving || 'Saving…';
      var response = await this.api.createOccasion(values);
      var saved = response && (response.occasion || response.saved && response.saved[0]);
      if (!saved || !saved.id) throw { code: 'REQUEST_FAILED' };
      clearDraft();
      this.pendingDraft = null;
      this.api.clearMe();
      this.showSaved(saved);
    } catch (error) {
      if (error.code === 'UNAUTHENTICATED') {
        this.me = { signedIn: false };
        this.captureAuth = true;
        this.setIdentityMode('email');
        this.show('identify');
        return;
      }
      errorNode.textContent = error.code === 'DUPLICATE' ? words('duplicate') : error.code === 'RATE_LIMITED' ? this.errorMessage(error) : this.sheet.dataset.saveError || this.sheet.dataset.unavailable;
      trackReminderEvent('reminder_capture_failed', 'sheet', 'capture', { error_code: ['DUPLICATE', 'RATE_LIMITED', 'INVALID_INPUT', 'INVALID_DATE', 'NETWORK_ERROR', 'UNAUTHENTICATED', 'FORBIDDEN_ORIGIN'].indexOf(error.code) >= 0 ? error.code : 'REQUEST_FAILED' });
      if (form) pendingForm(form, false);
      this.markCaptureError(error.field);
      if (error.code === 'DUPLICATE' && error.payload && error.payload.existing) {
        var duplicate = this.sheet.querySelector('[data-reminders-duplicate]');
        if (duplicate) { errorNode.textContent = ''; duplicate.hidden = false; this.sheet.querySelector('[data-reminders-existing]').href = pageUrl('/pages/reminders', 'person', error.payload.existing.id); duplicate.querySelector('button').hidden = !!values.friendId; }
      }
    } finally {
      this.savingCapture = false;
      if (form) pendingForm(form, false);
      if (saveButton) { saveButton.textContent = saveLabel; disableControl(saveButton, false); }
    }
  };

  Controller.prototype.markCaptureError = function (field) {
    this.sheet.querySelectorAll('[data-reminders-capture] [aria-invalid="true"]').forEach(function (input) {
      input.removeAttribute('aria-invalid');
      var described = (input.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id && id !== 'fb-reminders-capture-error'; }).join(' ');
      if (described) input.setAttribute('aria-describedby', described); else input.removeAttribute('aria-describedby');
    });
    if (['name', 'type', 'label', 'month', 'day'].indexOf(field) < 0) return;
    var input = this.sheet.querySelector('[data-reminders-capture] [name="' + field + '"]');
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', ((input.getAttribute('aria-describedby') || '') + ' fb-reminders-capture-error').trim());
      input.focus();
    }
  };

  Controller.prototype.toggleUnknownDate = function (checked) {
    var form = this.sheet.querySelector('[data-reminders-capture]');
    form.elements.unknownDate.checked = checked;
    syncDateForm(form);
  };

  Controller.prototype.restoreDraftToForm = function () {
    var draft = this.captureDraft();
    if (!draft) return;
    this.captureDefaultType = draft.type === 'BIRTHDAY' && draft.defaultType === 'BIRTHDAY' ? 'BIRTHDAY' : '';
    var form = this.sheet.querySelector('[data-reminders-capture]');
    form.elements.name.value = draft.name || '';
    form.elements.name.readOnly = !!draft.friendId;
    if (form.elements.friendId) form.elements.friendId.value = draft.friendId || '';
    if (form.elements.type) form.elements.type.value = draft.type == null ? 'BIRTHDAY' : draft.type;
    if (form.elements.label) form.elements.label.value = draft.label || '';
    this.confirmNew = draft.confirmNew === true;
    form._dateType = null; form._dateUnknown = false; form._manualDates = {};
    var unknown = draft.unknownDate != null ? draft.unknownDate : !draft.month && !draft.day;
    form.elements.unknownDate.checked = unknown;
    this.toggleUnknownDate(unknown);
    if (!unknown) {
      form.elements.month.value = String(draft.month || '');
      form.elements.day.value = String(draft.day || '');
    }
    syncDateForm(form);
  };

  Controller.prototype.setIdentityMode = function (mode) {
    this.identityMode = mode;
    var form = this.sheet.querySelector('[data-reminders-identify]');
    form.dataset.identityMode = mode;
    form.querySelector('[data-identity-email]').hidden = mode !== 'email';
    form.querySelector('[data-identity-phone]').hidden = mode !== 'sms';
    form.elements.email.required = mode === 'email';
    form.elements.phone.required = mode === 'sms';
    var optin = form.querySelector('[data-identity-marketing]'); if (optin) optin.hidden = mode !== 'email';
    form.querySelector('[data-identity-submit]').textContent = mode === 'email' ? (this.emailStepSaving ? this.emailStepCopy().submit : this.sheet.dataset.emailSubmit) : this.sheet.dataset.smsSubmit;
  };

  Controller.prototype.submitIdentity = async function (event) {
    event.preventDefault();
    if (this.requestingIdentity) return;
    var form = event.currentTarget;
    var errorNode = form.querySelector('[data-reminders-identify-error]');
    this.identityValue = this.identityMode === 'email' ? form.elements.email.value.trim() : form.elements.phone.value.trim();
    this.marketingConsent = !this.groupAuth && !this.groupInvitationToken && !this.birthdayInvitationToken && this.identityMode === 'email' && !!(form.elements.marketing && form.elements.marketing.checked);
    if (!this.identityValue || !form.checkValidity()) {
      form.reportValidity();
      return;
    }
    errorNode.textContent = '';
    try {
      this.requestingIdentity = true;
      pendingForm(form, true);
      if (this.identityMode === 'email') await this.api.requestEmailCode(this.identityValue);
      else await this.api.requestSmsCode(this.identityValue);
      trackReminderEvent('reminder_identity_requested', 'sheet', 'identify', null);
      this.show('verify');
      this.startResendTimer();
    } catch (error) {
      errorNode.textContent = this.errorMessage(error);
    } finally { this.requestingIdentity = false; pendingForm(form, false); }
  };

  Controller.prototype.submitVerify = async function (event) {
    event.preventDefault();
    if (this.verifyingIdentity) return;
    var form = event.currentTarget;
    var code = form.elements.code.value.trim();
    var errorNode = form.querySelector('[data-reminders-verify-error]');
    if (!/^\d{6}$/.test(code)) {
      errorNode.textContent = this.sheet.dataset.verifyError;
      return;
    }
    var captureAuth = this.captureAuth && !this.groupAuth && !this.groupInvitationToken && !this.pendingPreferences && this.preferencesIntent == null && !this.birthdayInvitationToken;
    var batch = captureAuth ? this.batchDraft() : null;
    var draft = captureAuth && !batch ? this.captureDraft() : null;
    if (batch) {
      var invalidIndex = batch.people.findIndex(function (p) { return !!this.validateCapture(Object.assign({}, p, { _unknownDate: p.unknownDate === true })); }, this);
      if (invalidIndex >= 0) { this.editBatch(invalidIndex); return; }
    }
    if (draft && this.validateCapture(Object.assign({}, draft, { _unknownDate: draft.unknownDate === true }))) {
      this.restoreDraftToForm(); this.show('capture'); return;
    }
    var body = { code: code, source: this.birthdayInvitationToken ? 'birthday_invitation' : this.groupInvitationToken ? 'group_invitation' : this.groupAuth ? 'group_sign_in' : 'theme_sheet' };
    if (this.birthdayInvitationToken) body.birthdayInvitationToken = this.birthdayInvitationToken;
    if (this.groupInvitationToken) body.invitationToken = this.groupInvitationToken;
    body[this.identityMode === 'email' ? 'email' : 'phone'] = this.identityValue;
    if (draft) body.draft = apiDraft(draft);
    if (batch) body.draft = { people: batch.people.map(function (p) { return apiDraft(p).people[0]; }) };
    if (this.marketingConsent && !this.birthdayInvitationToken) body.emailMarketingConsent = true;
    if (!this.groupInvitationToken && this.identityMode === 'sms' && !this.groupAuth && !this.birthdayInvitationToken && this.pendingPreferences && this.pendingPreferences.sms) body.smsConsent = true;
    var response;
    try {
      this.verifyingIdentity = true;
      pendingForm(form, true);
      response = this.identityMode === 'email'
        ? await this.api.verifyEmailCode(body)
        : await this.api.verifySmsCode(body);
    } catch (error) {
      errorNode.textContent = error.code === 'RATE_LIMITED' ? this.errorMessage(error) : this.sheet.dataset.verifyError;
      return;
    } finally {
      this.verifyingIdentity = false; pendingForm(form, false);
      if (!response) await this.resumeBirthdayInvitation();
    }
    trackReminderEvent('reminder_identity_verified', 'sheet', 'identify', response.member && response.member.id ? { member_id: response.member.id } : null);
    this.api.clearMe();
    try {
      if (response.member) this.me = { signedIn: true, member: response.member };
      if (this.birthdayInvitationToken) {
        var returnToInvitation = this.pendingBirthdayInvitation ? null : this.birthdayInvitationReturn;
        this.birthdayInvitationReturn = null; this.close(true);
        if (returnToInvitation) await returnToInvitation();
        return;
      }
      if (this.pendingPreferences && this.identityMode === 'sms') this.preferencesChanged = true;
      if (batch) {
        this.justVerifiedEmail = this.identityMode === 'email';
        this.acceptBatchResults(response);
      } else if (draft && response.duplicates && response.duplicates.length) {
        this.restoreDraftToForm();
        this.show('capture');
        this.sheet.querySelector('[data-reminders-capture-error]').textContent = '';
        var duplicate = this.sheet.querySelector('[data-reminders-duplicate]');
        duplicate.hidden = false;
        this.sheet.querySelector('[data-reminders-existing]').href = pageUrl('/pages/reminders', 'person', response.duplicates[0].id);
        duplicate.querySelector('button').hidden = !!draft.friendId;
      } else if (draft && response.saved && response.saved[0] && response.saved[0].id) {
        clearDraft();
        this.pendingDraft = null;
        this.captureAuth = false;
        this.justVerifiedEmail = this.identityMode === 'email';
        this.showSaved(response.saved[0]);
      } else if (draft) {
        this.restoreDraftToForm(); this.show('capture');
        this.sheet.querySelector('[data-reminders-capture-error]').textContent = this.sheet.dataset.saveError || this.sheet.dataset.unavailable;
      } else if (this.pendingPreferences) {
        var preferences = this.pendingPreferences;
        this.pendingPreferences = null;
        var returnState = this.preferenceReturnState || 'saved';
        var statusSelector = returnState === 'preferences'
          ? '[data-reminders-preferences-status]'
          : '[data-reminders-saved-status]';
        this.show(returnState);
        var preferenceResponse = await this.savePreferences(preferences, this.sheet.querySelector(statusSelector));
        if (preferenceResponse) {
          this.preferenceReturnState = null;
        }
      } else if (this.preferencesIntent != null) {
        await this.loadPreferences(this.preferencesIntent);
      } else {
        this.me = await this.api.me({ force: true });
        this.renderMe(this.me);
      }
    } catch (error) {
      this.showFatal(error);
    } finally {
      await this.resumeBirthdayInvitation();
    }
    form.reset();
    if (typeof root.CustomEvent === 'function') document.dispatchEvent(new root.CustomEvent('fb-reminders:verified', { detail: { source: body.source } }));
  };

  Controller.prototype.resumeBirthdayInvitation = async function () {
    var pending = this.pendingBirthdayInvitation;
    if (!pending) return;
    this.pendingBirthdayInvitation = null;
    this.birthdayInvitationToken = pending.token;
    this.birthdayInvitationReturn = pending.onVerified;
    this.captureAuth = false; this.groupAuth = false; this.groupInvitationToken = null;
    this.pendingPreferences = null; this.preferencesIntent = null; this.marketingConsent = false;
    if (this.me && this.me.signedIn) {
      this.birthdayInvitationReturn = null; this.close(true);
      if (pending.onVerified) await pending.onVerified();
    } else {
      var optIn = this.sheet.querySelector('[data-identity-marketing]');
      if (optIn) optIn.hidden = true;
    }
  };

  Controller.prototype.startResendTimer = function () {
    var self = this;
    var button = this.sheet.querySelector('[data-reminders-action="resend"]');
    var remaining = 30;
    root.clearInterval(this.resendTimer);
    button.disabled = true;
    function tick() {
      button.textContent = self.sheet.dataset.resendWaitTemplate.replace('__SECONDS__', String(remaining));
      remaining -= 1;
      if (remaining < 0) {
        root.clearInterval(self.resendTimer);
        button.disabled = false;
        button.textContent = self.sheet.dataset.resend;
      }
    }
    tick();
    this.resendTimer = root.setInterval(tick, 1000);
  };

  Controller.prototype.resend = async function () {
    var errorNode = this.sheet.querySelector('[data-reminders-verify-error]');
    try {
      if (this.identityMode === 'email') await this.api.requestEmailCode(this.identityValue);
      else await this.api.requestSmsCode(this.identityValue);
      errorNode.textContent = '';
      this.startResendTimer();
    } catch (error) {
      errorNode.textContent = this.errorMessage(error);
    }
  };

  Controller.prototype.renderRewardJourney = function (me) {
    if (this.invitationMode && this.sheet.dataset.state === 'saved') {
      var invitationBanner = this.sheet.querySelector('[data-reminders-reward-banner]');
      if (invitationBanner) invitationBanner.hidden = true;
      return;
    }
    var reward = me && me.member && me.member.datesReward;
    this.sheet.dataset.rewardArm = this.assignedRewardArm(me);
    var eligible = this.rewardJourney && this.sheet.dataset.rewardArm !== 'none' && !!this.sheet.dataset.rewardArm && !(me && me.signedIn && (!reward || ['locked', 'pending', 'earned'].indexOf(reward.status) < 0));
    this.sheet.dataset.rewardJourney = eligible ? 'true' : 'false';
    var banner = this.sheet.querySelector('[data-reminders-reward-banner]');
    if (banner) banner.hidden = !eligible || ['capture', 'identify', 'verify', 'saved', 'batch-review'].indexOf(this.sheet.dataset.state) < 0;
    var intro = this.sheet.querySelector('[data-reminders-capture-intro]');
    if (intro) intro.hidden = !!eligible;
    this.sheet.dataset.rewardComplete = 'false';
    if (!eligible) { this.renderCaptureJourney(me); return; }
    var count = reward && Number.isInteger(reward.dated) && reward.dated >= 0 ? reward.dated : null;
    var total = reward && Number.isInteger(reward.threshold) && reward.threshold > 0 ? reward.threshold : 3;
    if (this.rewardChecking || this.rewardProgressUnavailable) count = null;
    var complete = count != null && count >= total;
    this.sheet.dataset.rewardComplete = complete && !this.rewardChecking ? 'true' : 'false';
    var copy = count == null ? (this.rewardProgressUnavailable ? this.sheet.dataset.rewardCheckError : this.rewardChecking ? this.sheet.dataset.rewardChecking : this.sheet.dataset.rewardStart) : this.sheet.dataset.rewardProgress
      .replace('__COUNT__', String(Math.min(count, total))).replace('__TOTAL__', String(total)).replace('__LEFT__', String(Math.max(0, total - count)));
    if (!this.rewardChecking && !this.rewardProgressUnavailable && reward && reward.status === 'pending') copy = this.sheet.dataset.rewardPending;
    if (!this.rewardChecking && !this.rewardProgressUnavailable && reward && reward.status === 'earned' && reward.code) copy = this.sheet.dataset.rewardReady;
    var progress = this.sheet.querySelector('[data-reminders-saved-progress]');
    if (this.sheet.dataset.state === 'saved' && progress) {
      var saved = this.savedOccasion;
      if (!complete && count != null && saved && saved.date && !saved.date.known) copy += '. ' + this.sheet.dataset.rewardUnknown;
      progress.textContent = copy; progress.hidden = !!(banner && !banner.hidden);
    }
    var countNode = this.sheet.querySelector('[data-reminders-reward-count]');
    if (countNode) countNode.textContent = copy;
    var meter = this.sheet.querySelector('[data-reminders-reward-meter]');
    if (meter) { meter.hidden = count == null; meter.max = total; meter.value = count == null ? 0 : Math.min(count, total); if (meter.setAttribute) meter.setAttribute('aria-label', copy); }
    this.renderCaptureJourney(me);
  };

  Controller.prototype.showSaved = function (occasion) {
    if (!occasion || !occasion.id) return;
    this.batchFinished = false;
    this.trackedSaves = this.trackedSaves || new Set();
    if (!this.trackedSaves.has(occasion.id)) {
      this.trackedSaves.add(occasion.id);
      trackReminderEvent('occasion_saved', 'sheet', 'saved', { occasion_id: occasion.id });
    }
    notifyRemindersChanged();
    this.savedOccasion = occasion;
    this.invitationMode = !!(occasion.type === 'BIRTHDAY' && occasion.date && !occasion.date.known);
    this.sheet.dataset.birthdayInvitation = String(this.invitationMode);
    this.sheet.dataset.batchSaved = 'false';
    var shareStatus = this.sheet.querySelector('[data-reminders-share-status]');
    if (shareStatus) shareStatus.textContent = '';
    var shareUrl = this.sheet.querySelector('[data-reminders-share-url]');
    if (shareUrl) { shareUrl.hidden = true; shareUrl.value = ''; }
    var name = occasion.name || '';
    var dateValue = occasion.date && occasion.date.known !== false
      ? { month: occasion.date.month, day: occasion.date.day }
      : { month: occasion.month, day: occasion.day };
    var date = this.formatDate(dateValue);
    this.sheet.querySelector('[data-reminders-saved-summary]').textContent = safeReplace(
      safeReplace(this.sheet.dataset.savedTemplate, '__NAME__', name),
      '__DATE__', date
    );
    var form = this.sheet.querySelector('[data-reminders-saved-preferences]');
    var member = this.me && this.me.member;
    form.elements.email.checked = this.justVerifiedEmail || !!(member && member.channels && member.channels.email && member.channels.email.enabled);
    form.elements.sms.checked = !!(member && member.channels && member.channels.sms && member.channels.sms.enabled);
    this.justVerifiedEmail = false;
    var undated = occasion.date && !occasion.date.known && occasion.type === 'BIRTHDAY';
    var shareBlock = this.sheet.querySelector('[data-reminders-share-block]');
    if (shareBlock) {
      shareBlock.hidden = !undated;
      if (this.invitationPanel) this.invitationPanel.destroy();
      var invitation = shareBlock.querySelector('[data-reminders-invitation]');
      if (invitation && root.FBRemindersInvitation) this.invitationPanel = root.FBRemindersInvitation.mount(invitation, { url: occasion.links && occasion.links.joinReminders });
    }
    if (undated) this.sheet.querySelector('[data-reminders-saved-summary]').textContent = words('saved_unknown', { NAME: name });
    var shop = this.sheet.querySelector('[data-reminders-saved-shop]');
    if (shop) { shop.href = pageUrl('/pages/reminders', 'person', occasion.id); shop.hidden = !!undated; }
    // Favourite flowers: the moment they have just been thinking about this
    // person. Rendered only when the theme links to the picker.
    var flowers = this.sheet.querySelector('[data-reminders-saved-flowers]');
    if (flowers) {
      flowers.hidden = !(occasion.friendId && name);
      if (!flowers.hidden) {
        flowers.textContent = 'Know ' + possessive(name) + ' favourite flower?';
        flowers.href = '/pages/favourite-flowers?friend=' + encodeURIComponent(occasion.friendId) + '&via=reminder-saved';
      }
    }
    var more = this.sheet.querySelector('[data-reminders-more]');
    if (more) more.hidden = true;
    if (more && occasion.friendId) {
      var self = this;
      more.hidden = true;
      this.api.getOccasions().then(function (response) {
        if (self.savedOccasion !== occasion || self.batchFinished || self.invitationMode) return;
        moreOccasions(more, occasion, response.occasions); more.hidden = false;
      }).catch(function () {});
    }
    this.rewardChecking = !!this.rewardJourney;
    this.rewardProgressUnavailable = false;
    var savedHeading = this.sheet.querySelector('[data-reminders-saved-heading]');
    if (savedHeading) { if (savedHeading.dataset.originalCopy == null) savedHeading.dataset.originalCopy = savedHeading.textContent; savedHeading.textContent = savedHeading.dataset.originalCopy; }
    var keep = this.sheet.querySelector('[data-reminders-keep-posted]');
    // Set by finishBatch for a just-verified batch; the old Stems+ card stays away.
    this.keepPostedActive = !!this.keepPostedPending; this.keepPostedPending = false;
    if (keep && !this.keepPostedActive) keep.hidden = true;
    this.show('saved');
    this.refreshNewsletter();
    var progress = this.sheet.querySelector('[data-reminders-saved-progress]');
    if (progress) {
      progress.hidden = true;
      var self = this;
      Promise.all([this.api.me({ force: true }), this.rewardJourney ? Promise.resolve(null) : this.api.getOccasions()]).then(function (results) {
        var me = results[0];
        if (self.savedOccasion !== occasion) return;
        self.me = me;
        if (self.invitationMode) return;
        self.rewardChecking = false;
        self.rewardProgressUnavailable = false;
        if (self.rewardJourney) { self.renderRewardJourney(me); return; }
        // A finished batch already says how many it saved; an account-wide
        // count beside it would repeat or contradict that.
        if (self.batchFinished) return;
        if (!results[1] || !Array.isArray(results[1].occasions)) return;
        var count = results[1].occasions.length;
        progress.textContent = count === 1 ? self.sheet.dataset.countOne : self.sheet.dataset.countTemplate.replace('__COUNT__', String(count));
        progress.hidden = false;
      }).catch(function () {
        if (self.savedOccasion !== occasion || !self.rewardJourney) return;
        self.rewardChecking = false;
        self.rewardProgressUnavailable = true;
        self.renderRewardJourney(self.me);
      });
    }
  };

  Controller.prototype.refreshNewsletter = async function () {
    var card = this.sheet.querySelector('[data-reminders-newsletter]');
    if (!card) return;
    card.hidden = true;
    var keep = this.sheet.querySelector('[data-reminders-keep-posted]');
    if (this.keepPostedActive || (keep && !keep.hidden)) return;
    if (this.sheet.dataset.state !== 'saved' || !this.savedOccasion || this.invitationMode || this.groupAuth || this.groupInvitationToken || this.newsletterAccepted) return;
    var occasion = this.savedOccasion;
    var generation = this.newsletterGeneration = (this.newsletterGeneration || 0) + 1;
    try {
      var result = await this.api.getNewsletter();
      if (this.keepPostedActive || this.newsletterGeneration !== generation || this.savedOccasion !== occasion || this.sheet.dataset.state !== 'saved' || this.sheet.hidden || this.newsletterAccepted || this.invitationMode) return;
      card.hidden = result.status !== 'eligible';
      if (!card.hidden) {
        card.querySelector('[data-reminders-action="newsletter-subscribe"]').disabled = !!this.newsletterSubmitting;
        card.querySelector('[data-reminders-newsletter-status]').textContent = '';
        trackReminderEvent('newsletter_offer_viewed', 'sheet', 'saved', null);
      }
    } catch (_) { /* Optional offer never prevents another reminder. */ }
  };

  Controller.prototype.subscribeNewsletter = async function () {
    var card = this.sheet.querySelector('[data-reminders-newsletter]');
    if (!card || this.invitationMode || this.sheet.dataset.state !== 'saved' || this.newsletterSubmitting || this.newsletterAccepted) return;
    var button = card.querySelector('[data-reminders-action="newsletter-subscribe"]');
    var status = card.querySelector('[data-reminders-newsletter-status]');
    var occasion = this.savedOccasion;
    this.newsletterSubmitting = true; button.disabled = true; status.textContent = '';
    trackReminderEvent('newsletter_signup_requested', 'sheet', 'saved', null);
    try {
      var result = await this.api.subscribeNewsletter();
      if (result.status === 'enrolled' || result.status === 'pending' || result.status === 'subscribed') {
        this.newsletterAccepted = true;
        button.setAttribute('aria-pressed', 'true');
        var label = card.querySelector('[data-reminders-newsletter-label]');
        if (label) label.textContent = this.sheet.dataset.newsletterConfirmed;
        if (this.savedOccasion !== occasion || this.sheet.dataset.state !== 'saved' || this.sheet.hidden) card.hidden = true;
        else status.textContent = result.status === 'pending' ? this.sheet.dataset.newsletterPending : this.sheet.dataset.newsletterSuccess;
        trackReminderEvent('newsletter_signup_saved', 'sheet', 'saved', { status: result.status });
      } else if (result.status === 'suppressed' || result.status === 'no_email') {
        card.hidden = true;
      } else { status.textContent = this.sheet.dataset.newsletterError; }
    } catch (_) { status.textContent = this.sheet.dataset.newsletterError; }
    finally { this.newsletterSubmitting = false; button.disabled = !!this.newsletterAccepted; }
  };

  Controller.prototype.preferenceValues = function (form) {
    return { sms: form.elements.sms.checked, email: form.elements.email.checked };
  };

  Controller.prototype.submitPreferences = async function (event) {
    event.preventDefault();
    var values = this.preferenceValues(event.currentTarget);
    var statusNode = event.currentTarget.querySelector('[data-reminders-saved-status], [data-reminders-preferences-status]');
    var smsAvailable = this.me && this.me.member && this.me.member.channels && this.me.member.channels.sms && this.me.member.channels.sms.available;
    if (values.sms && !smsAvailable) {
      this.pendingPreferences = values;
      this.preferenceReturnState = this.sheet.dataset.state;
      this.setIdentityMode('sms');
      this.show('identify');
      return;
    }
    await this.savePreferences(values, statusNode);
  };

  Controller.prototype.savePreferences = async function (values, statusNode) {
    try {
      var body = Object.assign({}, values);
      var channels = this.me && this.me.member && this.me.member.channels;
      // An email-only member has no verified mobile to update. Sending an
      // unchanged sms:false makes the API reject the whole email preference.
      if (body.sms === false && channels && channels.sms && channels.sms.available === false) delete body.sms;
      var response = await this.api.putPreferences(body);
      if (statusNode) statusNode.textContent = response.providerSync === 'pending' ? this.sheet.dataset.preferencesPending : this.sheet.dataset.preferencesSaved;
      trackReminderEvent('preference_changed', 'sheet', 'preferences', null);
      if (values.sms || values.email) trackReminderEvent('notification_channel_enabled', 'sheet', 'preferences', null);
      this.api.clearMe();
      this.preferencesChanged = true;
      return response;
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') {
        this.pendingPreferences = values;
        this.preferenceReturnState = this.sheet.dataset.state;
        this.setIdentityMode('email');
        this.show('identify');
        return null;
      }
      if (statusNode) statusNode.textContent = this.errorMessage(error);
      return null;
    }
  };

  Controller.prototype.keepNotificationsOff = async function () {
    var node = this.sheet.querySelector('[data-reminders-saved-status]');
    var response = await this.savePreferences({ sms: false, email: false }, node);
    if (!response) return;
    node.textContent = this.sheet.dataset.offState;
    var form = this.sheet.querySelector('[data-reminders-saved-preferences]');
    form.elements.sms.checked = false;
    form.elements.email.checked = false;
  };

  Controller.prototype.loadPreferences = async function (enableSms) {
    this.preferencesIntent = enableSms === true;
    this.show('loading');
    try {
      var prefs = await this.api.getPreferences();
      var form = this.sheet.querySelector('[data-reminders-preferences]');
      form.elements.sms.checked = !!(prefs.sms && prefs.sms.enabled);
      form.elements.email.checked = !!(prefs.email && prefs.email.enabled);
      var emailDisabled = !!(prefs.email && prefs.email.editable === false);
      if (form.elements.email.hasAttribute('data-fb-reminders-was-disabled')) {
        form.elements.email.setAttribute('data-fb-reminders-was-disabled', emailDisabled ? 'true' : 'false');
      } else {
        form.elements.email.disabled = emailDisabled;
      }
      this.sheet.querySelector('[data-reminders-phone-masked]').textContent = prefs.sms && prefs.sms.phoneMasked ? '(' + prefs.sms.phoneMasked + ')' : '';
      this.sheet.querySelector('[data-reminders-email-masked]').textContent = prefs.email && prefs.email.emailMasked ? '(' + prefs.email.emailMasked + ')' : '';
      var emailReason = this.sheet.querySelector('[data-reminders-email-reason]');
      emailReason.textContent = prefs.email && prefs.email.reason ? prefs.email.reason : '';
      emailReason.hidden = !emailReason.textContent;
      this.sheet.querySelector('[data-reminders-preferences-status]').textContent = prefs.providerSync === 'pending' ? this.sheet.dataset.preferencesPending : '';
      this.show('preferences');
    } catch (error) {
      if (error && error.code === 'UNAUTHENTICATED') {
        this.setIdentityMode('email');
        this.show('identify');
        return;
      }
      this.showFatal(error);
    }
  };

  Controller.prototype.formatDate = function (value) {
    if (!value) return this.sheet.dataset.dateNeeded;
    var month;
    var day;
    if (typeof value === 'string') {
      var parts = value.split('-');
      month = Number(parts[1]);
      day = Number(parts[2]);
    } else {
      month = Number(value.month);
      day = Number(value.day);
    }
    if (!validDate(month, day)) return this.sheet.dataset.dateNeeded;
    return new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2000, month - 1, day)));
  };

  Controller.prototype.errorMessage = function (error) {
    if (error && error.code === 'RATE_LIMITED' && error.retryInSeconds) {
      return this.sheet.dataset.rateLimitTemplate.replace('__SECONDS__', String(error.retryInSeconds));
    }
    if (error && error.code === 'FORBIDDEN_ORIGIN') return this.sheet.dataset.unavailable;
    return this.sheet.dataset.unavailable;
  };

  Controller.prototype.showFatal = function (error) {
    this.sheet.querySelector('[data-reminders-fatal-error]').textContent = this.errorMessage(error);
    this.show('error');
  };

  var controller;
  var pageController;
  var bannerController;
  root.FBReminders = {
    celebrate: { pulse: pulseProgress, confetti: throwConfetti },
    init: function (sheet) {
      if (!controller) controller = new Controller(sheet);
      return controller;
    },
    initPage: function (page) {
      initPageCartContext();
      if (!pageController) pageController = new PageController(page);
      return pageController;
    },
    initBanner: function (container) {
      if (!bannerController) bannerController = new BannerController(container);
      return bannerController;
    },
    _test: {
      syncDateForm: syncDateForm,
      automaticDate: automaticDate,
      shareBirthday: shareBirthday,
      validDate: validDate,
      readDraft: readDraft,
      writeDraft: writeDraft,
      clearDraft: clearDraft,
      apiDraft: apiDraft,
      trackReminderEvent: trackReminderEvent,
      reminderLinkMeasurement: reminderLinkMeasurement,
      FLOW_VERSION: FLOW_VERSION,
      OUTCOME_EVENT_NAMES: OUTCOME_EVENT_NAMES,
      Controller: Controller,
      DRAFT_KEY: DRAFT_KEY,
      DRAFT_TTL: DRAFT_TTL,
      qualifyingDraftCount: qualifyingDraftCount,
      PageController: PageController,
      occasionIntentControl: occasionIntentControl,
      parseParams: parseParams,
      resolveView: resolveView,
      preseedMockScene: preseedMockScene,
      preseedProgressText: preseedProgressText,
      preseedFixture: preseedFixture,
      PRESEED_UNLOCKED_COPY: PRESEED_UNLOCKED_COPY,
      PRESEED_UNLOCKED_SET_COPY: PRESEED_UNLOCKED_SET_COPY,
      PRESEED_UNLOCKED_HEADING: PRESEED_UNLOCKED_HEADING,
      PRESEED_TOKEN_KEY: PRESEED_TOKEN_KEY,
      appendParam: appendParam,
      withReturn: withReturn,
      isSafeHref: isSafeHref,
      pageUrl: pageUrl,
      uniqueFriends: uniqueFriends,
      friendNameMatches: friendNameMatches,
      possessive: possessive,
      classifyOccasion: classifyOccasion,
      statusWord: statusWord,
      groupOccasions: groupOccasions,
      relevantOccasions: relevantOccasions,
      channelsSummary: channelsSummary,
      canSnooze: canSnooze,
      canRestore: canRestore,
      CTX_KEY: CTX_KEY,
      CART_ATTRIBUTE: CART_ATTRIBUTE,
      PERSON_NOTES_ATTRIBUTE: PERSON_NOTES_ATTRIBUTE,
      fulfilmentPersonNotes: fulfilmentPersonNotes,
      syncPersonNotesFromCart: syncPersonNotesFromCart,
      writePersonNotesAttribute: writePersonNotesAttribute,
      readContext: readContext,
      writeContext: writeContext,
      clearContext: clearContext,
      contextExpiry: contextExpiry,
      formatContextDate: formatContextDate,
      storeOccasionLinkContext: storeOccasionLinkContext,
      readShopCart: readShopCart,
      writeCartAttribute: writeCartAttribute,
      isCartMutationUrl: isCartMutationUrl,
      BannerController: BannerController
    }
  };

  /* The page (sections/fb-reminders-app.liquid) loads this file eagerly
     with a plain <script defer> — its whole purpose is Reminders, unlike
     every other page where the sheet lazy-loads it on first open — so
     self-init here rather than waiting to be told. typeof-guarded because
     T1's own tests run this whole file through vm.runInNewContext with no
     document, and must keep passing unchanged. */
  if (typeof document !== 'undefined') {
    /* Review fix #5: this sibling <script defer> can run before
       fb-reminders-api.js has finished loading, or after it failed to load
       at all — root.FBRemindersAPI is then undefined and the PageController
       constructor throws. Fail safe: log it and leave the server-rendered
       shell visible rather than an uncaught throw with no diagnostic. */
    try {
      var fbRemindersPageRoot = document.getElementById('fb-reminders-app');
      if (fbRemindersPageRoot) root.FBReminders.initPage(fbRemindersPageRoot);
    } catch (error) {
      if (root.console && typeof root.console.error === 'function') {
        root.console.error('[fb-reminders] page init failed', error);
      }
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
